/**
 * Pipeline alertas: classificação Vendas/Atendimento + chat IA persistente.
 */
Eloca.behaviors.alertaVazaoPipeline = function (context) {
    const $kanban = $("#kanban", context);
    if (!$kanban.length) {
        return;
    }

    const pipelineId = parseInt($kanban.attr("data-pipeline"), 10);
    const alertaUrl = $kanban.attr("data-alerta-vazao-url");
    const tipoUrl = $kanban.attr("data-pipeline-alertas-tipo-url");
    const conversasUrl = $kanban.attr("data-pipeline-alertas-conversas-url");
    const conversaUrlTemplate = $kanban.attr(
        "data-pipeline-alertas-conversa-url-template",
    );
    const mensagensUrl = $kanban.attr("data-pipeline-alertas-mensagens-url");
    const graficosUrl = $kanban.attr("data-pipeline-alertas-graficos-url");
    const analisesUrl = $kanban.attr("data-pipeline-alertas-analises-url");
    const analiseConversasPeriodoUrl = $kanban.attr(
        "data-pipeline-alertas-analise-conversas-periodo-url",
    );

    if (!pipelineId || pipelineId <= 0 || !alertaUrl) {
        return;
    }

    if ($kanban.data("pipeline-alertas-iniciado") || $(".js-alerta-vazao-pipeline").length) {
        return;
    }
    $kanban.data("pipeline-alertas-iniciado", true);

    const PERGUNTAS_FREQUENTES = [
        "Quem é o responsável que mais perdeu valor?",
        "Quais equipamentos mais aparecem nas perdas?",
        "No motivo Preço, quem mais perdeu?",
        "Qual canal concentra mais perdas?",
        "Qual combinação de motivo e equipamento mais dói?",
        "Em quais motivos o aging até perder está maior?",
        "A perda está mais em origem ativa ou receptiva?",
        "O que esses cruzamentos sugerem priorizar agora?",
    ];

    let estadoChat = {
        conversaId: null,
        origem: "livre",
        rascunho: false,
        selecionandoModo: false,
        titulo: null,
        mensagemAbertura: null,
        baloesAbertura: [],
        modoAnalise: "atual",
        dataInicio: null,
        dataFim: null,
        metrica: null,
        mensagensUsuario: 0,
        limiteMensagensUsuario: 40,
        limiteMensagensAtingido: false,
    };
    let modoListaArquivadas = false;
    let analiseConversasHabilitada = false;
    let pollAnaliseConversasTimer = null;
    let fraseAnaliseConversasTimer = null;
    let cacheAlertasAtivos = {
        payload: null,
        alertas: [],
        autorizado: null,
    };
    let cacheAlertasAnalisados = {
        carregado: false,
        analises: [],
    };
    let abaAlertasAtivos = "pendentes";
    let hoverGraficosTimer = null;
    let hoverGraficosCloseTimer = null;
    let hoverGraficosRequest = null;
    let hoverGraficosCardEl = null;
    let graficosModalRequestSeq = 0;
    let gravadorAudioCopiloto = null;
    let gravandoAudioCopiloto = false;
    let gravacaoAudioIniciadaEm = null;
    let intervaloDuracaoGravacaoAudio = null;
    let processandoGravacaoAudioCopiloto = false;
    let reconhecimentoFalaCopiloto = null;
    let ouvindoFalaNavegador = false;
    let falaNavegadorIndisponivel = false;
    let textoBaseFalaCopiloto = "";
    let textoConfirmadoFalaCopiloto = "";
    let $modalFalaCopiloto = null;
    let graficosFabHoverTimer = null;
    let graficosFabHideTimer = null;
    let hintHoverGraficosTimer = null;
    let hintHoverGraficosHideTimer = null;
    let hintHoverGraficosTypeTimer = null;
    const HINT_HOVER_GRAFICOS_STORAGE_KEY =
        "eloca:pipeline-alertas-hover-graficos-hint:v3";
    const HINT_HOVER_GRAFICOS_TITULO = "Passe o mouse neste alerta";
    const HINT_HOVER_GRAFICOS_TEXTO =
        "Os gráficos abrem sozinhos quando o cursor fica sobre o card.";
    const METRICAS_COM_GRAFICOS = {
        vazao_pipeline: true,
        tempo_ideal_pipeline: true,
        tma_pipeline: true,
        acoes_urgentes_pipeline: true,
        forecast_meta_pipeline: true,
        primeira_resposta_pipeline: true,
        distribuicao_pipeline: true,
        taxa_conversao_pipeline: true,
        tempo_encerramento_pipeline: true,
        qualidade_conversa_pipeline: true,
    };
    const METRICAS_LABELS = {
        vazao_pipeline: "Vazão da pipeline",
        tempo_ideal_pipeline: "Tempo ideal",
        tma_pipeline: "TMA",
        acoes_urgentes_pipeline: "Ações urgentes",
        forecast_meta_pipeline: "Forecast e meta",
        primeira_resposta_pipeline: "Primeira resposta",
        distribuicao_pipeline: "Distribuição",
        taxa_conversao_pipeline: "Taxa de conversão",
        tempo_encerramento_pipeline: "Tempo de encerramento",
        qualidade_conversa_pipeline: "Qualidade das conversas",
    };

    function labelCategoriaBadge(categoria) {
        if (categoria === "vendas") {
            return "Vendas";
        }
        if (categoria === "atendimento") {
            return "Atendimento";
        }

        return "";
    }

    function aplicarBadgeCategoria($root, tipoPipeline, categoria, seletorBadge) {
        const $badge = $root.find(seletorBadge);
        if (!$badge.length) {
            return;
        }

        const $wrap = $badge.closest(".js-pipeline-alertas-categoria-wrap");
        const label =
            tipoPipeline === "mista" ? labelCategoriaBadge(categoria) : "";

        $badge
            .removeClass(
                "pipeline-alertas-categoria-badge--vendas pipeline-alertas-categoria-badge--atendimento",
            )
            .text("");

        if (!label) {
            $badge.attr("hidden", true);
            if ($wrap.length) {
                $wrap.attr("hidden", true);
            }
            return;
        }

        $badge
            .text(label)
            .removeAttr("hidden")
            .addClass("pipeline-alertas-categoria-badge--" + categoria);
        if ($wrap.length) {
            $wrap.removeAttr("hidden");
        }
    }

    function estadoChatBase(extra) {
        return Object.assign(
            {
                conversaId: null,
                origem: "livre",
                rascunho: false,
                selecionandoModo: false,
                titulo: null,
                mensagemAbertura: null,
                baloesAbertura: [],
                modoAnalise: "atual",
                dataInicio: null,
                dataFim: null,
                incluirAnaliseConversas: false,
                aguardandoAnaliseConversas: false,
                metrica: null,
                temRespostaAssistente: false,
                mensagensUsuario: 0,
                limiteMensagensUsuario: 40,
                limiteMensagensAtingido: false,
            },
            extra || {},
        );
    }

    function formatDateInput(date) {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, "0");
        const d = String(date.getDate()).padStart(2, "0");
        return y + "-" + m + "-" + d;
    }

    function formatDateBr(dataIso) {
        const partes = String(dataIso || "").split("-");
        if (partes.length !== 3) {
            return String(dataIso || "");
        }
        return partes[2] + "/" + partes[1] + "/" + partes[0];
    }

    function parseDateInput(dataIso) {
        const data = new Date(String(dataIso || "") + "T00:00:00");
        if (Number.isNaN(data.getTime())) {
            return null;
        }
        return data;
    }

    function addDaysDate(date, days) {
        const copia = new Date(date.getTime());
        copia.setDate(copia.getDate() + days);
        return copia;
    }

    function hojeLocal() {
        const hoje = new Date();
        hoje.setHours(0, 0, 0, 0);
        return hoje;
    }

    function datasPadraoAtual() {
        const hoje = hojeLocal();
        const minInicio = addDaysDate(hoje, -30);
        let inicio = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
        if (inicio < minInicio) {
            inicio = minInicio;
        }
        return {
            inicio: formatDateInput(inicio),
            fim: formatDateInput(hoje),
            minInicio: formatDateInput(minInicio),
            maxInicio: formatDateInput(hoje),
        };
    }

    function calcularFimComparativo(dataInicio) {
        const inicio = parseDateInput(dataInicio);
        if (!inicio) {
            return "";
        }
        return formatDateInput(addDaysDate(inicio, 30));
    }

    function datasPadraoComparativo() {
        const hoje = hojeLocal();
        const inicio = addDaysDate(hoje, -60);
        return {
            inicio: formatDateInput(inicio),
            fim: calcularFimComparativo(formatDateInput(inicio)),
            maxInicio: formatDateInput(addDaysDate(hoje, -30)),
        };
    }

    const MAX_DIAS_PERIODO_ATUAL = 31;

    function calcularDiasPeriodoInclusivo(dataInicio, dataFim) {
        const inicio = parseDateInput(dataInicio);
        const fim = parseDateInput(dataFim);
        if (!inicio || !fim) {
            return null;
        }
        const diffMs = fim.getTime() - inicio.getTime();
        return Math.floor(diffMs / 86400000) + 1;
    }

    function validarPeriodoAtual(dataInicio, dataFim) {
        const hoje = formatDateInput(hojeLocal());
        if (!dataInicio || !dataFim) {
            return {
                valido: false,
                mensagem: "Informe a data de início da análise.",
            };
        }
        if (dataFim !== hoje) {
            return {
                valido: false,
                mensagem: "A data fim da análise atual é sempre o dia de hoje.",
            };
        }
        if (dataInicio > dataFim) {
            return {
                valido: false,
                mensagem:
                    "A data de início deve ser anterior ou igual à data de fim.",
            };
        }
        const dias = calcularDiasPeriodoInclusivo(dataInicio, dataFim);
        if (dias === null) {
            return {
                valido: false,
                mensagem: "Período inválido. Verifique as datas informadas.",
            };
        }
        if (dias > MAX_DIAS_PERIODO_ATUAL) {
            return {
                valido: false,
                mensagem:
                    "O período da análise atual pode ter no máximo 31 dias.",
            };
        }
        return { valido: true, mensagem: "", dataFim: dataFim };
    }

    function validarPeriodoComparativo(dataInicio) {
        if (!dataInicio) {
            return {
                valido: false,
                mensagem: "Informe a data de início do período de comparação.",
            };
        }
        const dataFim = calcularFimComparativo(dataInicio);
        if (!dataFim) {
            return {
                valido: false,
                mensagem: "Período inválido. Verifique a data de início.",
            };
        }
        const hoje = formatDateInput(hojeLocal());
        if (dataFim > hoje) {
            return {
                valido: false,
                mensagem:
                    "A janela de comparação precisa terminar hoje ou antes. Escolha uma data de início até 30 dias atrás.",
            };
        }
        const dias = calcularDiasPeriodoInclusivo(dataInicio, dataFim);
        if (dias !== 31) {
            return {
                valido: false,
                mensagem:
                    "O período de comparação deve ter exatamente 30 dias a partir da data de início.",
            };
        }
        return { valido: true, mensagem: "", dataFim: dataFim };
    }

    function sincronizarUiPeriodoModo($modal) {
        const modo = String(
            $modal
                .find(".js-pipeline-alertas-modo-opcao.is-selected")
                .attr("data-modo") || "atual",
        );
        const $periodo = $modal.find(".js-pipeline-alertas-modo-periodo");
        const $titulo = $modal.find(".js-pipeline-alertas-modo-periodo-titulo");
        const $hint = $modal.find(".js-pipeline-alertas-modo-periodo-hint");
        const $inicio = $modal.find(".js-pipeline-alertas-modo-inicio");
        const $fim = $modal.find(".js-pipeline-alertas-modo-fim");
        const $fimCampo = $modal.find(".js-pipeline-alertas-modo-fim-campo");
        const $fimCalculado = $modal.find(
            ".js-pipeline-alertas-modo-fim-calculado",
        );

        $periodo.prop("hidden", false);

        if (modo === "comparativo") {
            const padrao = datasPadraoComparativo();
            $titulo.text("Período de comparação");
            $hint.text(
                "Informe só a data de início. A análise compara os últimos 30 dias com uma janela fixa de 30 dias a partir dessa data.",
            );
            if (!$inicio.val()) {
                $inicio.val(padrao.inicio);
            }
            $inicio.attr("max", padrao.maxInicio).removeAttr("min");
            $fimCampo.prop("hidden", true);
            $fim.prop("disabled", true).val("");
            $fimCalculado.prop("hidden", false);
            const fimCalc = calcularFimComparativo(
                String($inicio.val() || "").trim(),
            );
            $fimCalculado
                .find(".js-pipeline-alertas-modo-fim-texto")
                .text(fimCalc ? formatDateBr(fimCalc) : "—");
            return;
        }

        const padrao = datasPadraoAtual();
        $titulo.text("Período da análise");
        $hint.text(
            "Padrão: do 1º dia do mês até hoje. Você pode antecipar o início até no máximo 31 dias.",
        );
        if (!$inicio.data("periodoAtualInicializado")) {
            $inicio.val(padrao.inicio);
            $inicio.data("periodoAtualInicializado", true);
        }
        $inicio.attr("min", padrao.minInicio).attr("max", padrao.maxInicio);
        $fimCampo.prop("hidden", false);
        $fim.prop("disabled", true).attr("max", padrao.fim).val(padrao.fim);
        $fimCalculado.prop("hidden", true);
    }

    function atualizarValidacaoPeriodoModo($modal) {
        const modo = String(
            $modal
                .find(".js-pipeline-alertas-modo-opcao.is-selected")
                .attr("data-modo") || "atual",
        );
        const $continuar = $modal.find(".js-pipeline-alertas-modo-continuar");
        const $erro = $modal.find(".js-pipeline-alertas-modo-erro");
        const $periodoCard = $modal.find(".pipeline-alertas-modo__periodo-card");
        const dataInicio = String(
            $modal.find(".js-pipeline-alertas-modo-inicio").val() || "",
        ).trim();

        let validacao;
        if (modo === "comparativo") {
            const dataFim = calcularFimComparativo(dataInicio);
            $modal
                .find(".js-pipeline-alertas-modo-fim-texto")
                .text(dataFim ? formatDateBr(dataFim) : "—");
            validacao = validarPeriodoComparativo(dataInicio);
        } else {
            const dataFim = formatDateInput(hojeLocal());
            $modal.find(".js-pipeline-alertas-modo-fim").val(dataFim);
            validacao = validarPeriodoAtual(dataInicio, dataFim);
        }

        if (validacao.valido) {
            $erro.prop("hidden", true).text("");
            $periodoCard.removeClass("is-invalid");
            $continuar.prop("disabled", false);
            return;
        }

        $erro.text(validacao.mensagem).prop("hidden", false);
        $periodoCard.addClass("is-invalid");
        $continuar.prop("disabled", true);
    }

    function pararEsperaAnaliseConversas() {
        estadoChat.aguardandoAnaliseConversas = false;
        if (pollAnaliseConversasTimer) {
            clearInterval(pollAnaliseConversasTimer);
            pollAnaliseConversasTimer = null;
        }
        if (fraseAnaliseConversasTimer) {
            clearInterval(fraseAnaliseConversasTimer);
            fraseAnaliseConversasTimer = null;
        }
    }

    function htmlCheckboxAnaliseConversas() {
        if (!analiseConversasHabilitada) {
            return "";
        }
        return `
            <div class="pipeline-alertas-modo__analise-conversas js-pipeline-alertas-modo-analise-conversas">
                <label class="pipeline-alertas-modo__check">
                    <input type="checkbox" class="js-pipeline-alertas-incluir-conversas" checked />
                    <span>Considerar análise das conversas no que a IA gerar</span>
                </label>
                <p class="pipeline-alertas-modo__analise-hint">
                    Se marcado, o Copiloto espera as conversas do período serem analisadas antes de abrir o chat.
                    Você pode desmarcar para seguir só com as métricas.
                </p>
            </div>
        `;
    }

    function htmlEsperaAnaliseConversas() {
        return `
            <div class="pipeline-alertas-analise-espera js-pipeline-alertas-analise-espera">
                <p class="pipeline-alertas-analise-espera__eyebrow">Preparando o Copiloto</p>
                <h6 class="pipeline-alertas-analise-espera__titulo">A IA está lendo as conversas do período</h6>
                <div class="progress pipeline-alertas-analise-espera__barra">
                    <div class="progress-bar pipeline-alertas-analise-espera__barra-preenchida is-processando js-pipeline-alertas-analise-espera-barra"
                         role="progressbar"
                         aria-valuemin="0"
                         aria-valuemax="100"
                         aria-valuenow="8"
                         aria-label="Progresso da análise das conversas"
                         style="width: 8%;"></div>
                </div>
                <p class="pipeline-alertas-analise-espera__frase js-pipeline-alertas-analise-espera-frase">
                    Analisando conversas
                </p>
            </div>
        `;
    }

    function aplicarProgressoAnaliseConversas($modal, dados) {
        const $barra = $modal.find(".js-pipeline-alertas-analise-espera-barra");
        const largura = Math.max(8, Math.min(100, Number(dados.largura_barra || 0)));
        $barra.css("width", largura + "%").attr("aria-valuenow", Math.round(largura));
        $modal
            .find(".js-pipeline-alertas-chat-item.is-preparando .js-pipeline-alertas-item-barra")
            .css("width", largura + "%");
        const frases = Array.isArray(dados.frases) && dados.frases.length
            ? dados.frases
            : ["Analisando conversas"];
        $modal.data("pipeline-alertas-frases-analise", frases);
        const $frase = $modal.find(".js-pipeline-alertas-analise-espera-frase");
        if (!$frase.data("frase-fixada")) {
            $frase.text(frases[0]);
        }
    }

    function iniciarRotacaoFrasesAnalise($modal) {
        if (fraseAnaliseConversasTimer) {
            return;
        }
        let indice = 0;
        fraseAnaliseConversasTimer = setInterval(function () {
            const frases = $modal.data("pipeline-alertas-frases-analise") || [];
            if (!frases.length) {
                return;
            }
            indice = (indice + 1) % frases.length;
            const $frase = $modal.find(".js-pipeline-alertas-analise-espera-frase");
            $frase.data("frase-fixada", true).text(frases[indice]);
        }, 2800);
    }

    function consultarAnaliseConversasPeriodo(params, enfileirar) {
        const payload = Object.assign(
            {
                pipeline_id: pipelineId,
                enfileirar: enfileirar ? 1 : 0,
            },
            params,
        );
        return $.ajax({
            url: analiseConversasPeriodoUrl,
            method: enfileirar ? "POST" : "GET",
            dataType: "json",
            headers: {
                "X-CSRF-TOKEN": csrfToken(),
                Accept: "application/json",
            },
            data: payload,
        });
    }

    function aguardarAnaliseConversasEContinuar($modal, modo, dataInicio, dataFim, opcoes) {
        if (!analiseConversasPeriodoUrl) {
            confirmarModoAnalise($modal, modo, dataInicio, dataFim, true);
            return;
        }
        opcoes = opcoes || {};
        pararEsperaAnaliseConversas();
        estadoChat.aguardandoAnaliseConversas = true;
        setComposerVisivel($modal, false);
        definirHtmlMensagensChat($modal, htmlEsperaAnaliseConversas());
        setChatBusy(
            $modal,
            $modal.find(".js-alerta-vazao-chat-form").hasClass("is-busy"),
        );
        atualizarBannerGraficosChat($modal);

        const params = {
            modo_analise: modo,
            data_inicio: dataInicio,
            data_fim: dataFim,
        };
        if (opcoes.conversaId) {
            params.conversa_id = opcoes.conversaId;
        }
        const criarConversa = opcoes.criarConversa !== false && !opcoes.conversaId;
        const enfileirar = criarConversa || !!opcoes.enfileirar;
        if (criarConversa) {
            params.criar_conversa = 1;
        }
        let concluido = false;

        function concluir(ok) {
            if (concluido) {
                return;
            }
            concluido = true;
            pararEsperaAnaliseConversas();
            if (!ok) {
                return;
            }
            confirmarModoAnalise(
                $modal,
                modo,
                dataInicio,
                dataFim,
                true,
                estadoChat.conversaId,
            );
        }

        consultarAnaliseConversasPeriodo(params, enfileirar)
            .done(function (dados) {
                if (concluido) {
                    return;
                }
                delete params.criar_conversa;
                const conversa = dados && dados.conversa;
                if (conversa && conversa.id) {
                    params.conversa_id = conversa.id;
                    estadoChat = estadoChatBase({
                        conversaId: conversa.id,
                        rascunho: false,
                        titulo: conversa.titulo || estadoChat.titulo,
                        modoAnalise: modo,
                        dataInicio: dataInicio,
                        dataFim: dataFim,
                        incluirAnaliseConversas: true,
                        aguardandoAnaliseConversas: true,
                    });
                    carregarListaConversas($modal, pipelineId, false);
                    marcarItemAtivo($modal, conversa.id, false);
                    atualizarBannerGraficosChat($modal);
                }
                aplicarProgressoAnaliseConversas($modal, dados || {});
                if (dados && dados.processando === false) {
                    concluir(true);
                    return;
                }
                iniciarRotacaoFrasesAnalise($modal);
                pollAnaliseConversasTimer = setInterval(function () {
                    if (concluido) {
                        return;
                    }
                    consultarAnaliseConversasPeriodo(params, true)
                        .done(function (status) {
                            if (concluido) {
                                return;
                            }
                            aplicarProgressoAnaliseConversas($modal, status || {});
                            if (status && status.processando === false) {
                                concluir(true);
                            }
                        })
                        .fail(function (xhr) {
                            const msg =
                                (xhr.responseJSON && xhr.responseJSON.message) ||
                                "Não foi possível acompanhar a análise das conversas.";
                            $modal
                                .find(".js-pipeline-alertas-analise-espera-frase")
                                .text(msg);
                            concluir(false);
                        });
                }, 4000);
            })
            .fail(function (xhr) {
                const msg =
                    (xhr.responseJSON && xhr.responseJSON.message) ||
                    "Não foi possível iniciar a análise das conversas.";
                definirHtmlMensagensChat(
                    $modal,
                    '<p class="pipeline-alertas-analise-espera__frase">' +
                        $("<div>").text(msg).html() +
                        "</p>",
                );
            });
    }

    function storageKey(lojaId, pipeline, userId, metrica) {
        const metricaKey = metrica || "legado";
        return `eloca:pipeline-alerta:${lojaId}:${pipeline}:${userId}:${metricaKey}`;
    }

    function storageKeyLegado(lojaId, pipeline, userId) {
        return `eloca:alerta-vazao:${lojaId}:${pipeline}:${userId}`;
    }

    function isDismissed(lojaId, pipeline, userId, assinatura, metrica) {
        if (!assinatura) {
            return true;
        }
        try {
            const raw = window.localStorage.getItem(
                storageKey(lojaId, pipeline, userId, metrica),
            );
            if (raw) {
                const parsed = JSON.parse(raw);
                if (parsed && parsed.assinatura === assinatura) {
                    return true;
                }
            }
            // Compat: dismiss antigo sem métrica (só vazão)
            if (!metrica || metrica === "vazao_pipeline") {
                const legado = window.localStorage.getItem(
                    storageKeyLegado(lojaId, pipeline, userId),
                );
                if (!legado) {
                    return false;
                }
                const parsedLegado = JSON.parse(legado);
                return parsedLegado && parsedLegado.assinatura === assinatura;
            }
            return false;
        } catch (e) {
            return false;
        }
    }

    function dismiss(lojaId, pipeline, userId, assinatura, metrica) {
        try {
            window.localStorage.setItem(
                storageKey(lojaId, pipeline, userId, metrica),
                JSON.stringify({
                    assinatura: assinatura,
                    dismissed_at: new Date().toISOString(),
                }),
            );
        } catch (e) {
            /* localStorage indisponível */
        }
    }

    function formatCurrency(value) {
        const n = Number(value) || 0;
        return n.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
        });
    }

    function csrfToken() {
        return $('meta[name="csrf-token"]').attr("content") || "";
    }

    function escapeHtml(text) {
        return String(text || "")
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#39;");
    }

    function sanitizeUrl(url) {
        const value = String(url || "").trim();
        if (/^https?:\/\//i.test(value)) {
            return value;
        }
        return "#";
    }

    function normalizarRotuloBalaoVisivel(texto) {
        return String(texto || "")
            .replace(/_/g, " ")
            .replace(/\s{2,}/g, " ")
            .trim();
    }

    function rotuloBalaoVisivel(balao, chave) {
        const titulo = normalizarRotuloBalaoVisivel(
            String((balao && balao.titulo) || "").trim(),
        );
        const chaveTexto = normalizarRotuloBalaoVisivel(chave);
        return titulo || chaveTexto;
    }

    function registrarChaveBalao(mapa, chave, balao) {
        const chaveTexto = String(chave || "").trim();
        if (!chaveTexto) {
            return;
        }
        mapa[chaveTexto] = balao;
        mapa[chaveTexto.toLowerCase()] = balao;
        const normalizada = normalizarRotuloBalaoVisivel(chaveTexto);
        if (normalizada && normalizada !== chaveTexto) {
            mapa[normalizada] = balao;
            mapa[normalizada.toLowerCase()] = balao;
        }
    }

    function renderMarkdown(source, baloes, interactive) {
        const chips = {};
        let raw = String(source || "").replace(/\r\n/g, "\n");
        // Alguns modelos devolvem "\\n" literal no JSON
        if (raw.indexOf("\n") === -1 && raw.indexOf("\\n") !== -1) {
            raw = raw.split("\\n").join("\n");
        }

        const listaBaloes = Array.isArray(baloes) ? baloes : [];
        const chaveValida = {};

        listaBaloes.forEach(function (balao) {
            registrarChaveBalao(chaveValida, String((balao && balao.chave) || "").trim(), balao);
        });

        if (interactive && listaBaloes.length) {
            const chavesJaChip = {};
            raw = raw.replace(/\{\{([^}]+)\}\}/g, function (_m, chaveBruta) {
                const chave = String(chaveBruta || "").trim();
                const chaveNormalizada = normalizarRotuloBalaoVisivel(chave);
                const balao =
                    chaveValida[chave] ||
                    chaveValida[chave.toLowerCase()] ||
                    chaveValida[chaveNormalizada] ||
                    chaveValida[chaveNormalizada.toLowerCase()];
                if (!balao) {
                    return normalizarRotuloBalaoVisivel(chave);
                }
                const chaveCanonica = String(balao.chave || chave);
                const chaveNorm = chaveCanonica.toLowerCase();
                // Uma mesma chave vira chip só na primeira ocorrência
                if (chavesJaChip[chaveNorm]) {
                    return rotuloBalaoVisivel(balao, chaveCanonica);
                }
                chavesJaChip[chaveNorm] = true;
                const token = `@@CHIP_${Object.keys(chips).length}@@`;
                chips[token] = {
                    chave: chaveCanonica,
                    rotulo: rotuloBalaoVisivel(balao, chaveCanonica),
                };
                return token;
            });
        } else {
            raw = raw.replace(/\{\{([^}]+)\}\}/g, function (_m, chaveBruta) {
                return normalizarRotuloBalaoVisivel(chaveBruta);
            });
        }

        let text = escapeHtml(raw);

        text = text.replace(/```([\s\S]*?)```/g, function (_m, code) {
            return `<pre class="pipeline-alertas-md__pre"><code>${code}</code></pre>`;
        });
        text = text.replace(/`([^`\n]+)`/g, "<code>$1</code>");
        text = text.replace(/^###\s+(.+)$/gm, "<h4>$1</h4>");
        text = text.replace(/^##\s+(.+)$/gm, "<h3>$1</h3>");
        text = text.replace(/^#\s+(.+)$/gm, "<h3>$1</h3>");
        text = text.replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>");
        text = text.replace(/(^|[^*])\*([^*\n]+)\*(?!\*)/g, "$1<em>$2</em>");
        text = text.replace(
            /\[([^\]]+)\]\(([^)]+)\)/g,
            function (_m, label, url) {
                const safe = sanitizeUrl(url);
                if (safe === "#") {
                    return label;
                }
                return `<a href="${escapeHtml(safe)}" target="_blank" rel="noopener noreferrer">${label}</a>`;
            },
        );

        const lines = text.split("\n");
        const html = [];
        let inList = false;

        lines.forEach(function (line) {
            const listMatch = line.match(/^[-*] (.+)$/);
            if (listMatch) {
                if (!inList) {
                    html.push("<ul>");
                    inList = true;
                }
                html.push(`<li>${listMatch[1]}</li>`);
                return;
            }
            if (inList) {
                html.push("</ul>");
                inList = false;
            }
            if (line.trim() === "") {
                html.push('<div class="pipeline-alertas-md__spacer"></div>');
                return;
            }
            if (/^<(h3|h4|pre)/.test(line)) {
                html.push(line);
                return;
            }
            html.push(`<p>${line}</p>`);
        });

        if (inList) {
            html.push("</ul>");
        }

        let out = html.join("");
        Object.keys(chips).forEach(function (token) {
            const chip = chips[token];
            const chave = typeof chip === "string" ? chip : chip.chave;
            const rotulo =
                typeof chip === "string"
                    ? normalizarRotuloBalaoVisivel(chip)
                    : chip.rotulo;
            const chipHtml =
                `<button type="button" class="pipeline-alertas-chip js-pipeline-alertas-chip" data-chave="${escapeHtml(chave)}" aria-expanded="false">` +
                `<span>${escapeHtml(rotulo)}</span>` +
                `</button>`;
            out = out.split(token).join(chipHtml);
        });

        return out;
    }

    function removerBaloesInfo($modal) {
        $modal.find(".js-pipeline-alertas-balao").remove();
        $modal
            .find(".js-pipeline-alertas-chip.is-active")
            .removeClass("is-active")
            .attr("aria-expanded", "false");
    }

    function fecharBalaoInfo($modal) {
        const $atuais = $modal.find(".js-pipeline-alertas-balao");
        if (!$atuais.length) {
            $modal
                .find(".js-pipeline-alertas-chip.is-active")
                .removeClass("is-active")
                .attr("aria-expanded", "false");
            return;
        }

        $atuais.removeClass("is-visible");
        $modal
            .find(".js-pipeline-alertas-chip.is-active")
            .removeClass("is-active")
            .attr("aria-expanded", "false");

        window.setTimeout(function () {
            $atuais.remove();
        }, 220);
    }

    function posicionarBalaoJuntoAoChip($balao, $chip, $messages) {
        const balaoEl = $balao[0];
        const chipEl = $chip[0];
        const msgEl = $messages[0];
        if (!balaoEl || !chipEl || !msgEl) {
            return;
        }

        const chipRect = chipEl.getBoundingClientRect();
        const msgRect = msgEl.getBoundingClientRect();
        const gap = 10;
        const padding = 12;
        // Mais horizontal: largura maior, limitada ao espaço disponível
        const larguraAlvo = 520;
        const maxWidth = Math.min(
            larguraAlvo,
            Math.max(280, msgRect.width - padding * 2),
        );
        balaoEl.style.width = maxWidth + "px";
        balaoEl.style.maxWidth = maxWidth + "px";

        // Mede no tamanho real (sem scale da animação)
        balaoEl.style.visibility = "hidden";
        balaoEl.style.transform = "none";
        const balaoHeight = balaoEl.offsetHeight;
        balaoEl.style.transform = "";
        balaoEl.style.visibility = "";

        const chipLeft = chipRect.left - msgRect.left + msgEl.scrollLeft;
        const chipTop = chipRect.top - msgRect.top + msgEl.scrollTop;
        const chipRight = chipLeft + chipRect.width;
        const areaLeft = msgEl.scrollLeft + padding;
        const areaRight = msgEl.scrollLeft + msgRect.width - padding;
        const areaTop = msgEl.scrollTop + padding;
        const areaBottom = msgEl.scrollTop + msgRect.height - padding;

        const espacoDireita = areaRight - (chipRight + gap);
        const espacoEsquerda = chipLeft - gap - areaLeft;
        let left;
        let originX = "0%";

        // Preferência: à direita da palavra-chave
        if (espacoDireita >= Math.min(maxWidth, 240) || espacoDireita >= espacoEsquerda) {
            left = chipRight + gap;
            if (left + maxWidth > areaRight) {
                left = Math.max(areaLeft, areaRight - maxWidth);
            }
            originX = "0%";
            $balao.removeClass("is-left").addClass("is-right");
        } else {
            left = chipLeft - gap - maxWidth;
            if (left < areaLeft) {
                left = areaLeft;
            }
            originX = "100%";
            $balao.removeClass("is-right").addClass("is-left");
        }

        // Alinha no topo da palavra; se estourar embaixo, sobe
        let top = chipTop;
        let originY = "0%";
        if (top + balaoHeight > areaBottom) {
            top = Math.max(areaTop, areaBottom - balaoHeight);
            originY = "100%";
            $balao.addClass("is-above");
        } else {
            $balao.removeClass("is-above");
        }

        balaoEl.style.left = left + "px";
        balaoEl.style.top = top + "px";
        balaoEl.style.transformOrigin = originX + " " + originY;

        if (top + balaoHeight > msgEl.scrollTop + msgRect.height - 8) {
            msgEl.scrollTop +=
                top + balaoHeight - (msgEl.scrollTop + msgRect.height) + 16;
        }
        if (top < msgEl.scrollTop + 8) {
            msgEl.scrollTop = Math.max(0, top - 12);
        }
    }

    function abrirBalaoInfo($modal, $chip, balao) {
        removerBaloesInfo($modal);

        const titulo = String((balao && balao.titulo) || balao.chave || "Detalhe");
        const conteudo = String((balao && balao.conteudo) || "");
        const $balao = $(`
            <div class="pipeline-alertas-balao js-pipeline-alertas-balao" role="dialog" aria-label="">
                <div class="pipeline-alertas-balao__header">
                    <strong class="pipeline-alertas-balao__titulo"></strong>
                    <button type="button" class="pipeline-alertas-balao__fechar js-pipeline-alertas-balao-fechar" aria-label="Fechar">&times;</button>
                </div>
                <div class="pipeline-alertas-balao__body js-pipeline-alertas-balao-body"></div>
            </div>
        `);
        $balao.attr("aria-label", titulo);
        $balao.find(".pipeline-alertas-balao__titulo").text(titulo);
        $balao
            .find(".js-pipeline-alertas-balao-body")
            .html(renderMarkdown(conteudo, [], false));

        const $messages = $modal.find(".js-alerta-vazao-chat-messages");
        $messages.css("position", "relative");
        $messages.append($balao);
        $chip.addClass("is-active").attr("aria-expanded", "true");

        posicionarBalaoJuntoAoChip($balao, $chip, $messages);

        window.requestAnimationFrame(function () {
            window.requestAnimationFrame(function () {
                $balao.addClass("is-visible");
            });
        });
    }

    function fecharCard($card, estadoCard) {
        const atual = estadoCard.alertas[estadoCard.indice] || {};
        dismiss(
            estadoCard.lojaId,
            estadoCard.pipelineId,
            estadoCard.userId,
            atual.assinatura,
            atual.metrica,
        );

        const restantes = estadoCard.alertas.filter(function (alerta, idx) {
            return idx !== estadoCard.indice;
        });

        if (restantes.length === 0) {
            $card.removeClass("is-visible");
            window.setTimeout(function () {
                $card.remove();
            }, 280);
            return;
        }

        estadoCard.alertas = restantes;
        estadoCard.indice = 0;
        atualizarConteudoCard($card, estadoCard);
    }

    // Data URI: evita círculo branco nos pontinhos (background HTTP às vezes não pinta a tempo)
    const AVATAR_SRC = 'data:image/png;base64,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';

    function montarAvatarNode() {
        const wrap = document.createElement("span");
        wrap.className = "alerta-vazao-modal__chat-avatar";
        wrap.setAttribute("aria-hidden", "true");
        wrap.setAttribute("title", "Eloca");

        const img = document.createElement("img");
        img.className = "alerta-vazao-modal__chat-avatar-img";
        img.alt = "Eloca";
        img.width = 34;
        img.height = 34;
        img.decoding = "sync";
        img.src = AVATAR_SRC;

        wrap.appendChild(img);
        return wrap;
    }

    function formatarTempoAudio(segundos) {
        const total = Math.max(0, Math.floor(Number(segundos) || 0));
        const min = Math.floor(total / 60);
        const sec = String(total % 60).padStart(2, "0");
        return min + ":" + sec;
    }

    function ligarPlayerAudioBolha($wrap) {
        const audio = $wrap.find(".js-alerta-vazao-audio-el").get(0);
        const $play = $wrap.find(".js-alerta-vazao-audio-play");
        const $range = $wrap.find(".js-alerta-vazao-audio-range");
        const $atual = $wrap.find(".js-alerta-vazao-audio-atual");
        const $total = $wrap.find(".js-alerta-vazao-audio-total");
        const $toggle = $wrap.find(".js-alerta-vazao-audio-toggle");
        const $transcript = $wrap.find(".js-alerta-vazao-audio-transcript");

        if (!audio) {
            return;
        }

        function atualizarIcone(tocando) {
            $play.attr("aria-label", tocando ? "Pausar áudio" : "Reproduzir áudio");
            $wrap.toggleClass("is-playing", tocando);
        }

        let rafProgresso = null;
        function atualizarProgresso() {
            const duracao = audio.duration;
            $range.val(audio.currentTime);
            $atual.text(formatarTempoAudio(audio.currentTime));
            const pct =
                duracao && isFinite(duracao)
                    ? (audio.currentTime / duracao) * 100
                    : 0;
            $wrap.css("--audio-progress", pct + "%");
        }
        function loopProgresso() {
            atualizarProgresso();
            if (!audio.paused && !audio.ended) {
                rafProgresso = window.requestAnimationFrame(loopProgresso);
            } else {
                rafProgresso = null;
            }
        }

        $play.on("click", function (e) {
            e.preventDefault();
            if (!audio.getAttribute("src")) {
                return;
            }
            if (audio.paused) {
                $wrap
                    .closest(".js-alerta-vazao-chat-messages")
                    .find(".js-alerta-vazao-audio-el")
                    .each(function () {
                        if (this !== audio) {
                            this.pause();
                        }
                    });
                atualizarIcone(true);
                const playPromise = audio.play();
                if (playPromise && typeof playPromise.catch === "function") {
                    playPromise.catch(function () {
                        atualizarIcone(false);
                    });
                }
            } else {
                audio.pause();
                atualizarIcone(false);
            }
        });

        $(audio).on("play", function () {
            atualizarIcone(true);
            if (rafProgresso) {
                window.cancelAnimationFrame(rafProgresso);
            }
            rafProgresso = window.requestAnimationFrame(loopProgresso);
        });
        $(audio).on("pause ended", function () {
            atualizarIcone(false);
            if (rafProgresso) {
                window.cancelAnimationFrame(rafProgresso);
                rafProgresso = null;
            }
            if (audio.ended) {
                audio.currentTime = 0;
            }
            atualizarProgresso();
        });
        $(audio).on("loadedmetadata durationchange", function () {
            const duracao = audio.duration;
            if (!isFinite(duracao)) {
                return;
            }
            $range.attr("max", duracao);
            $total.text(formatarTempoAudio(duracao));
        });

        $range.on("input", function () {
            audio.currentTime = Number(this.value) || 0;
            atualizarProgresso();
        });

        $toggle.on("click", function () {
            if ($wrap.hasClass("is-transcribing")) {
                return;
            }
            const abrir = $transcript.prop("hidden");
            $transcript.prop("hidden", !abrir);
            $toggle.attr("aria-expanded", abrir ? "true" : "false");
            $wrap.toggleClass("is-transcript-open", abrir);
        });
    }

    function montarBolhaAudio(audioUrl, texto) {
        const transcrevendo = !texto || texto === "Transcrevendo...";
        const $wrap = $(`
            <div class="alerta-vazao-modal__audio-msg">
                <audio class="js-alerta-vazao-audio-el" preload="metadata"></audio>
                <div class="alerta-vazao-modal__audio-player">
                    <button type="button" class="alerta-vazao-modal__audio-play js-alerta-vazao-audio-play" aria-label="Reproduzir áudio">
                        <span class="alerta-vazao-modal__audio-play-icon alerta-vazao-modal__audio-play-icon--play" aria-hidden="true">
                            <i class="fas fa-play"></i>
                        </span>
                        <span class="alerta-vazao-modal__audio-play-icon alerta-vazao-modal__audio-play-icon--pause" aria-hidden="true">
                            <i class="fas fa-pause"></i>
                        </span>
                    </button>
                    <div class="alerta-vazao-modal__audio-track">
                        <div class="alerta-vazao-modal__audio-wave" aria-hidden="true"></div>
                        <input type="range" class="alerta-vazao-modal__audio-range js-alerta-vazao-audio-range" min="0" max="0" value="0" step="0.1" aria-label="Progresso do áudio" />
                        <div class="alerta-vazao-modal__audio-times">
                            <span class="js-alerta-vazao-audio-atual">0:00</span>
                            <span class="js-alerta-vazao-audio-total">0:00</span>
                        </div>
                    </div>
                </div>
                <button type="button" class="alerta-vazao-modal__audio-toggle js-alerta-vazao-audio-toggle" aria-expanded="false">
                    <i class="fas fa-align-left" aria-hidden="true"></i>
                    <span class="js-alerta-vazao-audio-toggle-label">Transcrição</span>
                    <i class="fas fa-chevron-down alerta-vazao-modal__audio-toggle-chevron" aria-hidden="true"></i>
                </button>
                <div class="alerta-vazao-modal__audio-transcript js-alerta-vazao-audio-transcript" hidden>
                    <p class="alerta-vazao-modal__chat-transcricao-texto"></p>
                </div>
            </div>
        `);
        const $wave = $wrap.find(".alerta-vazao-modal__audio-wave");
        const $base = $('<div class="alerta-vazao-modal__audio-wave-inner">');
        const $played = $(
            '<div class="alerta-vazao-modal__audio-wave-inner alerta-vazao-modal__audio-wave-played">'
        );
        const alturas = [42, 70, 52, 84, 48, 76, 58, 90, 46, 68, 80, 54, 72, 44, 78, 50, 86, 60, 74, 48];
        alturas.forEach(function (altura) {
            $base.append($("<i>").css("height", altura + "%"));
            $played.append($("<i>").css("height", altura + "%"));
        });
        $wave.append($base).append($played);
        $wrap.find(".js-alerta-vazao-audio-el").attr("src", audioUrl);
        $wrap
            .find(".alerta-vazao-modal__chat-transcricao-texto")
            .text(texto || "Transcrevendo...");
        if (transcrevendo) {
            $wrap.addClass("is-transcribing");
            $wrap.find(".js-alerta-vazao-audio-toggle-label").text("Transcrevendo...");
        }
        ligarPlayerAudioBolha($wrap);
        return $wrap;
    }

    function appendBubble($messages, role, text, asMarkdown, baloes, audioUrl) {
        const $bubble = $(`
            <div class="alerta-vazao-modal__chat-row alerta-vazao-modal__chat-row--${role}">
                <div class="alerta-vazao-modal__chat-bubble alerta-vazao-modal__chat-bubble--${role}">
                    <div class="alerta-vazao-modal__chat-bubble-text"></div>
                </div>
            </div>
        `);
        if (role === "assistant") {
            $bubble.prepend(montarAvatarNode());
        }
        const listaBaloes = Array.isArray(baloes) ? baloes : [];
        $bubble.data("baloes", listaBaloes);
        const $text = $bubble.find(".alerta-vazao-modal__chat-bubble-text");
        if (role === "assistant" && asMarkdown) {
            $text.html(renderMarkdown(text || "", listaBaloes, true));
        } else if (role === "assistant") {
            $text.html(renderMarkdown(text || "", listaBaloes, false));
        } else if (audioUrl) {
            $bubble.addClass("alerta-vazao-modal__chat-row--audio");
            $bubble
                .find(".alerta-vazao-modal__chat-bubble")
                .addClass("alerta-vazao-modal__chat-bubble--audio");
            $text.empty().append(montarBolhaAudio(audioUrl, text));
        } else {
            $text.text(text || "");
        }
        $messages.append($bubble);
        $messages.scrollTop($messages[0].scrollHeight);
        return $bubble;
    }

    function appendTyping($messages) {
        const $typing = $(`
            <div class="alerta-vazao-modal__chat-row alerta-vazao-modal__chat-row--assistant is-typing js-alerta-vazao-typing">
                <div class="alerta-vazao-modal__chat-bubble alerta-vazao-modal__chat-bubble--assistant">
                    <div class="alerta-vazao-modal__chat-typing" aria-hidden="true">
                        <i></i><i></i><i></i>
                    </div>
                </div>
            </div>
        `);
        $typing.prepend(montarAvatarNode());
        $messages.append($typing);
        $messages.scrollTop($messages[0].scrollHeight);
        return $typing;
    }

    function digitarTexto($bubble, texto, baloes, onDone) {
        const $text = $bubble.find(".alerta-vazao-modal__chat-bubble-text");
        const listaBaloes = Array.isArray(baloes) ? baloes : [];
        $bubble.data("baloes", listaBaloes);
        $text.html("");
        $bubble.addClass("is-streaming");
        let i = 0;
        const total = String(texto || "").length;
        const passo = total > 600 ? 4 : total > 250 ? 3 : 2;

        function tick() {
            i = Math.min(total, i + passo);
            $text.html(renderMarkdown(texto.slice(0, i), listaBaloes, false));
            const $messages = $bubble.closest(".js-alerta-vazao-chat-messages");
            if ($messages.length) {
                $messages.scrollTop($messages[0].scrollHeight);
            }
            if (i >= total) {
                $bubble.removeClass("is-streaming");
                $text.html(renderMarkdown(texto, listaBaloes, true));
                if (typeof onDone === "function") {
                    onDone();
                }
                return;
            }
            window.setTimeout(tick, 14);
        }

        tick();
    }

    function revelarRespostaAposPontinhos($typing, $messages, texto, baloes, onDone) {
        $typing.remove();
        const $bubble = appendBubble($messages, "assistant", "", false, baloes);
        digitarTexto($bubble, texto, baloes, onDone);
    }

    function aguardarPontinhosMinimos(inicioMs, minimoMs, callback) {
        const restante = Math.max(0, minimoMs - (Date.now() - inicioMs));
        window.setTimeout(callback, restante);
    }

    function ajustarAlturaChatInput($input) {
        const el = $input.get(0);
        if (!el) {
            return;
        }
        el.style.height = "auto";
        el.style.height = el.scrollHeight + "px";
    }

    function setChatBusy($modal, busy) {
        const $form = $modal.find(".js-alerta-vazao-chat-form");
        const $input = $form.find(".js-alerta-vazao-chat-input");
        const $btn = $form.find(".js-alerta-vazao-chat-enviar");
        const $chat = $modal.find(".js-alerta-vazao-chat");
        const bloqueadoPorLimite = !!estadoChat.limiteMensagensAtingido;
        const desabilitado = busy || bloqueadoPorLimite;
        $input.prop("disabled", desabilitado);
        $btn.prop("disabled", desabilitado);
        if (bloqueadoPorLimite) {
            $input.attr(
                "placeholder",
                "Limite atingido — inicie uma nova análise",
            );
        } else if ($input.attr("placeholder") !== "Pergunte sobre as métricas da pipeline...") {
            $input.attr(
                "placeholder",
                "Pergunte sobre as métricas da pipeline...",
            );
        }
        $form.toggleClass("is-busy", busy);
        $form.toggleClass("is-limit-reached", bloqueadoPorLimite);
        $chat.toggleClass("is-busy", busy);
        $chat.toggleClass("is-limit-reached", bloqueadoPorLimite);
        if (!gravandoAudioCopiloto) {
            atualizarBotaoComposerAudio($modal);
        }
        $modal.attr("aria-busy", busy ? "true" : "false");
        const graficosInativos = busy || !!estadoChat.aguardandoAnaliseConversas;
        $modal
            .find(".js-pipeline-alertas-graficos-toggle, .js-pipeline-alertas-graficos-fab")
            .prop("disabled", graficosInativos)
            .attr("aria-disabled", graficosInativos ? "true" : "false");
        if (graficosInativos) {
            fecharPainelFabGraficos($modal, true);
        }
        if (busy || bloqueadoPorLimite) {
            esconderSugestoesChat($modal);
        }
        sincronizarFabGraficosChat($modal);
    }

    function htmlAvisoLimiteChat() {
        return `
            <div class="alerta-vazao-modal__chat-limit-notice js-alerta-vazao-chat-limit-notice" role="status" aria-live="polite">
                <div class="alerta-vazao-modal__chat-limit-notice-icon" aria-hidden="true">
                    <i class="fas fa-robot"></i>
                    <span class="alerta-vazao-modal__chat-limit-notice-slash"></span>
                </div>
                <span class="alerta-vazao-modal__chat-limit-notice-kicker">Análise encerrada</span>
                <strong class="alerta-vazao-modal__chat-limit-notice-title">Limite desta conversa</strong>
                <p class="alerta-vazao-modal__chat-limit-notice-text">
                    Não é possível enviar mais mensagens aqui.<br />Inicie uma nova análise para continuar.
                </p>
            </div>
        `;
    }

    function atualizarAvisoLimiteChat($modal) {
        const $messages = $modal.find(".js-alerta-vazao-chat-messages");
        const $status = $modal.find(".js-alerta-vazao-chat-status");
        let $notice = $messages.find(".js-alerta-vazao-chat-limit-notice");

        if (!estadoChat.limiteMensagensAtingido) {
            $notice.remove();
            return;
        }

        if (!$notice.length) {
            $notice = $(htmlAvisoLimiteChat());
        }

        $messages.append($notice);
        $status.text("").removeClass("is-error");
        $messages.scrollTop($messages.prop("scrollHeight"));
    }

    function sincronizarLimiteMensagensChat($modal, dados, opcoes) {
        if (!dados || typeof dados !== "object") {
            return;
        }
        const opcoesSync = opcoes || {};
        if (dados.mensagens_usuario != null) {
            estadoChat.mensagensUsuario = Number(dados.mensagens_usuario) || 0;
        }
        if (dados.limite_mensagens_usuario != null) {
            estadoChat.limiteMensagensUsuario =
                Number(dados.limite_mensagens_usuario) || 40;
        }
        if (dados.limite_mensagens_atingido != null) {
            estadoChat.limiteMensagensAtingido = !!dados.limite_mensagens_atingido;
        } else {
            estadoChat.limiteMensagensAtingido =
                estadoChat.mensagensUsuario >= estadoChat.limiteMensagensUsuario;
        }

        if (opcoesSync.adiarAviso !== true) {
            atualizarAvisoLimiteChat($modal);
        }
        setChatBusy($modal, $modal.find(".js-alerta-vazao-chat-form").hasClass("is-busy"));
    }

    function esconderSugestoesChat($modal) {
        $modal
            .find(".js-alerta-vazao-chat-sugestoes")
            .removeClass("is-visible")
            .attr("aria-hidden", "true");
    }

    function atualizarSugestoesChat($modal) {
        const $input = $modal.find(".js-alerta-vazao-chat-input");
        const $lista = $modal.find(".js-alerta-vazao-chat-sugestoes-lista");
        const $wrap = $modal.find(".js-alerta-vazao-chat-sugestoes");
        const digitado = String($input.val() || "").trim().toLowerCase();

        if (!digitado || $input.prop("disabled")) {
            esconderSugestoesChat($modal);
            return;
        }

        const filtradas = PERGUNTAS_FREQUENTES.filter(function (pergunta) {
            return (
                pergunta.toLowerCase().indexOf(digitado) !== -1 ||
                digitado.length <= 2
            );
        }).slice(0, 5);

        const perguntas =
            digitado.length <= 2
                ? PERGUNTAS_FREQUENTES.slice(0, 5)
                : filtradas;

        $lista.empty();

        if (perguntas.length === 0) {
            esconderSugestoesChat($modal);
            return;
        }

        perguntas.forEach(function (pergunta) {
            const $btn = $(
                '<button type="button" class="alerta-vazao-modal__chat-sugestao js-alerta-vazao-chat-sugestao"></button>',
            );
            $btn.text(pergunta);
            $btn.attr("data-pergunta", pergunta);
            $lista.append($btn);
        });

        $wrap.addClass("is-visible").attr("aria-hidden", "false");
    }

    function marcarItemAtivo($modal, conversaId, isDraft) {
        $modal.find(".js-pipeline-alertas-chat-item").removeClass("is-active");
        if (isDraft) {
            $modal
                .find(".js-pipeline-alertas-chat-item[data-draft='1']")
                .addClass("is-active");
            return;
        }
        if (conversaId) {
            $modal
                .find(
                    `.js-pipeline-alertas-chat-item[data-id='${conversaId}']`,
                )
                .addClass("is-active");
        }
    }

    function formatChatDate(value) {
        if (!value) {
            return "";
        }
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) {
            return "";
        }

        const agora = new Date();
        const mesmoDia =
            date.getFullYear() === agora.getFullYear() &&
            date.getMonth() === agora.getMonth() &&
            date.getDate() === agora.getDate();

        if (mesmoDia) {
            return date.toLocaleTimeString("pt-BR", {
                hour: "2-digit",
                minute: "2-digit",
            });
        }

        return date.toLocaleDateString("pt-BR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        });
    }

    function sincronizarUiListaArquivadas($modal) {
        if (!$modal || !$modal.length) {
            return;
        }

        $modal
            .find(".pipeline-alertas-chat-modal")
            .toggleClass("is-lista-arquivadas", modoListaArquivadas);
        $modal
            .find(".js-pipeline-alertas-sidebar-label")
            .text(modoListaArquivadas ? "Arquivadas" : "Histórico");
        $modal
            .find(".js-pipeline-alertas-toggle-arquivadas")
            .attr("aria-pressed", modoListaArquivadas ? "true" : "false")
            .toggleClass("is-active", modoListaArquivadas);
        $modal
            .find(".js-pipeline-alertas-toggle-arquivadas-label")
            .text(modoListaArquivadas ? "Ver ativas" : "Ver arquivadas");
        $modal
            .find(".js-pipeline-alertas-toggle-arquivadas-icon")
            .toggleClass("fa-archive", !modoListaArquivadas)
            .toggleClass("fa-inbox", modoListaArquivadas);
        $modal
            .find(".js-pipeline-alertas-novo-chat")
            .prop("hidden", modoListaArquivadas);
    }

    function renderListaConversas($modal, conversas, draftTitulo) {
        const $lista = $modal.find(".js-pipeline-alertas-chat-list");
        $lista.empty();

        const tituloDraft =
            !modoListaArquivadas && draftTitulo ? draftTitulo : null;

        if (tituloDraft) {
            const $draft = $(`
                <div class="pipeline-alertas-chat__item js-pipeline-alertas-chat-item is-active" data-draft="1" role="button" tabindex="0">
                    <div class="pipeline-alertas-chat__item-body">
                        <span class="pipeline-alertas-chat__item-title"></span>
                        <span class="pipeline-alertas-chat__item-meta">
                            <span class="pipeline-alertas-chat__item-origem">Em andamento</span>
                        </span>
                    </div>
                </div>
            `);
            $draft.find(".pipeline-alertas-chat__item-title").text(tituloDraft);
            $lista.append($draft);
        }

        const lista = conversas || [];
        if (!tituloDraft && !lista.length) {
            const emptyText = modoListaArquivadas
                ? "Nenhuma análise arquivada."
                : "Nenhuma análise registrada nesta pipeline.";
            $lista.append(
                `<div class="pipeline-alertas-chat__list-empty"></div>`,
            );
            $lista.find(".pipeline-alertas-chat__list-empty").text(emptyText);
            return;
        }

        lista.forEach(function (conversa) {
            const fixado = !!conversa.fixado;
            const arquivado = !!conversa.arquivado;
            const $item = $(`
                <div class="pipeline-alertas-chat__item js-pipeline-alertas-chat-item" data-id="" role="button" tabindex="0">
                    <div class="pipeline-alertas-chat__item-body">
                        <span class="pipeline-alertas-chat__item-title">
                            <i class="fas fa-thumbtack pipeline-alertas-chat__pin-icon js-pipeline-alertas-chat-pin" aria-hidden="true" hidden></i>
                            <span class="js-pipeline-alertas-chat-titulo-texto"></span>
                        </span>
                        <span class="pipeline-alertas-chat__item-meta">
                            <span class="pipeline-alertas-chat__item-origem"></span>
                            <span class="pipeline-alertas-chat__item-actions">
                                <span class="pipeline-alertas-chat__item-data"></span>
                                <div class="pipeline-alertas-chat__menu js-pipeline-alertas-chat-menu-wrap">
                                    <button type="button" class="pipeline-alertas-chat__menu-trigger js-pipeline-alertas-chat-menu-trigger" aria-label="Mais opções" aria-haspopup="true" aria-expanded="false" title="Mais opções">
                                        <i class="fas fa-ellipsis-v" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </span>
                        </span>
                    </div>
                </div>
            `);
            const dataLabel = formatChatDate(
                conversa.ultima_mensagem_at || conversa.created_at,
            );
            $item.attr("data-id", String(conversa.id));
            $item.attr("data-fixado", fixado ? "1" : "0");
            $item.attr("data-arquivado", arquivado ? "1" : "0");
            $item.attr("data-titulo", conversa.titulo || "Análise");
            $item.toggleClass("is-preparando", !!conversa.preparando_analise_conversas);
            $item
                .find(".js-pipeline-alertas-chat-titulo-texto")
                .text(conversa.titulo || "Análise");
            $item
                .find(".js-pipeline-alertas-chat-pin")
                .prop("hidden", !fixado);
            $item
                .find(".pipeline-alertas-chat__item-origem")
                .text(
                    conversa.preparando_analise_conversas
                        ? "Analisando conversas"
                        : conversa.origem === "alerta"
                          ? "Alerta"
                          : "Livre",
                );
            $item.find(".pipeline-alertas-chat__item-data").text(dataLabel);
            if (conversa.preparando_analise_conversas) {
                $item.find(".pipeline-alertas-chat__item-body").append(`
                    <div class="pipeline-alertas-chat__item-progresso">
                        <div class="progress pipeline-alertas-chat__item-barra">
                            <div class="progress-bar pipeline-alertas-chat__item-barra-preenchida is-processando js-pipeline-alertas-item-barra"
                                 style="width: 8%;"></div>
                        </div>
                    </div>
                `);
            }
            if (fixado) {
                $item.addClass("is-fixado");
            }
            $lista.append($item);
        });
    }

    function garantirMenuFlutuanteChat() {
        let $menu = $("#pipelineAlertasChatMenuFloat");
        if ($menu.length) {
            return $menu;
        }

        $menu = $(`
            <div class="pipeline-alertas-chat__menu-dropdown pipeline-alertas-chat__menu-dropdown--float js-pipeline-alertas-chat-menu-float" id="pipelineAlertasChatMenuFloat" hidden role="menu">
                <button type="button" class="pipeline-alertas-chat__menu-item js-pipeline-alertas-chat-acao" data-acao="fixar" role="menuitem">
                    <i class="fas fa-thumbtack" aria-hidden="true"></i>
                    <span class="js-pipeline-alertas-chat-acao-fixar-label">Fixar</span>
                </button>
                <button type="button" class="pipeline-alertas-chat__menu-item js-pipeline-alertas-chat-acao" data-acao="renomear" role="menuitem">
                    <i class="fas fa-pen" aria-hidden="true"></i>
                    <span>Renomear</span>
                </button>
                <button type="button" class="pipeline-alertas-chat__menu-item js-pipeline-alertas-chat-acao" data-acao="arquivar" role="menuitem">
                    <i class="fas fa-archive js-pipeline-alertas-chat-acao-arquivar-icon" aria-hidden="true"></i>
                    <span class="js-pipeline-alertas-chat-acao-arquivar-label">Arquivar</span>
                </button>
                <button type="button" class="pipeline-alertas-chat__menu-item pipeline-alertas-chat__menu-item--danger js-pipeline-alertas-chat-acao" data-acao="excluir" role="menuitem">
                    <i class="far fa-trash-alt" aria-hidden="true"></i>
                    <span>Excluir</span>
                </button>
            </div>
        `);
        $("body").append($menu);
        return $menu;
    }

    function fecharMenusChat($modal) {
        const $menu = $("#pipelineAlertasChatMenuFloat");
        if ($menu.length) {
            $menu
                .prop("hidden", true)
                .removeData("conversaId")
                .removeData("fixado")
                .removeData("arquivado")
                .removeData("titulo")
                .removeData("chatModal");
            const el = $menu.get(0);
            if (el) {
                el.style.top = "";
                el.style.left = "";
            }
        }
        if ($modal && $modal.length) {
            $modal
                .find(".js-pipeline-alertas-chat-menu-trigger")
                .attr("aria-expanded", "false")
                .closest(".js-pipeline-alertas-chat-menu-wrap")
                .removeClass("is-open");
        } else {
            $(".js-pipeline-alertas-chat-menu-trigger").attr(
                "aria-expanded",
                "false",
            );
            $(".js-pipeline-alertas-chat-menu-wrap").removeClass("is-open");
        }
    }

    function abrirMenuFlutuanteChat($modal, $trigger, $item) {
        const $menu = garantirMenuFlutuanteChat();
        const triggerEl = $trigger.get(0);
        const menuEl = $menu.get(0);
        if (!triggerEl || !menuEl) {
            return;
        }

        const fixado = $item.attr("data-fixado") === "1";
        const arquivado =
            $item.attr("data-arquivado") === "1" || modoListaArquivadas;
        $menu.data("conversaId", parseInt($item.attr("data-id"), 10));
        $menu.data("fixado", fixado);
        $menu.data("arquivado", arquivado);
        $menu.data("titulo", String($item.attr("data-titulo") || "").trim());
        $menu.data("chatModal", $modal);
        $menu
            .find(".js-pipeline-alertas-chat-acao-fixar-label")
            .text(fixado ? "Desafixar" : "Fixar");
        $menu.find('[data-acao="fixar"]').prop("hidden", arquivado);
        $menu
            .find(".js-pipeline-alertas-chat-acao-arquivar-label")
            .text(arquivado ? "Desarquivar" : "Arquivar");
        $menu
            .find(".js-pipeline-alertas-chat-acao-arquivar-icon")
            .toggleClass("fa-archive", !arquivado)
            .toggleClass("fa-box-open", arquivado);

        menuEl.style.visibility = "hidden";
        menuEl.hidden = false;

        const triggerRect = triggerEl.getBoundingClientRect();
        const menuRect = menuEl.getBoundingClientRect();
        const gap = 8;
        const padding = 8;

        // Abre ao lado e levemente abaixo do trigger (primeiro item perto do topo).
        let left = triggerRect.right + gap;
        let top = triggerRect.top + 2;

        if (left + menuRect.width > window.innerWidth - padding) {
            left = triggerRect.left - menuRect.width - gap;
        }
        if (left < padding) {
            left = padding;
        }
        if (top + menuRect.height > window.innerHeight - padding) {
            top = Math.max(
                padding,
                triggerRect.bottom - menuRect.height,
            );
        }
        if (top < padding) {
            top = padding;
        }

        menuEl.style.top = Math.round(top) + "px";
        menuEl.style.left = Math.round(left) + "px";
        menuEl.style.visibility = "";

        $trigger.attr("aria-expanded", "true");
        $trigger.closest(".js-pipeline-alertas-chat-menu-wrap").addClass("is-open");
    }

    function garantirModaisAcaoChat() {
        if ($("#modalPipelineAlertasChatAcao").length) {
            return;
        }

        $("body").append(`
            <div class="modal fade pipeline-alertas-acao-modal-root" id="modalPipelineAlertasChatAcao" tabindex="-1" role="dialog" aria-labelledby="modalPipelineAlertasChatAcaoLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered pipeline-alertas-acao-dialog" role="document">
                    <div class="modal-content pipeline-alertas-acao-modal">
                        <div class="modal-header">
                            <h5 class="modal-title js-pipeline-alertas-acao-titulo" id="modalPipelineAlertasChatAcaoLabel"></h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Fechar">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <p class="pipeline-alertas-acao-modal__texto js-pipeline-alertas-acao-texto mb-0"></p>
                            <div class="pipeline-alertas-acao-modal__renomear js-pipeline-alertas-acao-renomear" hidden>
                                <label class="pipeline-alertas-acao-modal__label" for="pipelineAlertasChatTituloInput">Novo título</label>
                                <input type="text" id="pipelineAlertasChatTituloInput" class="form-control js-pipeline-alertas-acao-input" maxlength="80" autocomplete="off" />
                                <p class="pipeline-alertas-acao-modal__erro js-pipeline-alertas-acao-erro" hidden></p>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-cancel" data-dismiss="modal">Cancelar</button>
                            <button type="button" class="btn js-pipeline-alertas-acao-confirmar">Confirmar</button>
                        </div>
                    </div>
                </div>
            </div>
        `);

        const $acaoModal = $("#modalPipelineAlertasChatAcao");
        $acaoModal.on("show.bs.modal", function () {
            $("#modalPipelineAlertasChat .pipeline-alertas-chat-modal").addClass(
                "is-dimmed",
            );
            window.setTimeout(function () {
                $(".modal-backdrop")
                    .last()
                    .addClass("pipeline-alertas-acao-backdrop");
            }, 0);
        });
        $acaoModal.on("shown.bs.modal", function () {
            $(".modal-backdrop")
                .last()
                .addClass("pipeline-alertas-acao-backdrop");
            const $input = $acaoModal.find(".js-pipeline-alertas-acao-input");
            if (!$acaoModal.find(".js-pipeline-alertas-acao-renomear").prop("hidden")) {
                $input.trigger("focus").trigger("select");
            }
        });
        $acaoModal.on("hidden.bs.modal", function () {
            $("#modalPipelineAlertasChat .pipeline-alertas-chat-modal").removeClass(
                "is-dimmed",
            );
            $acaoModal.removeData("onConfirm");
            $acaoModal.find(".js-pipeline-alertas-acao-erro").prop("hidden", true).text("");
            $acaoModal.find(".js-pipeline-alertas-acao-input").val("");
        });
        $acaoModal.on("click", ".js-pipeline-alertas-acao-confirmar", function () {
            const onConfirm = $acaoModal.data("onConfirm");
            if (typeof onConfirm !== "function") {
                $acaoModal.modal("hide");
                return;
            }
            onConfirm($acaoModal);
        });
        $acaoModal.on("keydown", ".js-pipeline-alertas-acao-input", function (e) {
            if (e.key === "Enter") {
                e.preventDefault();
                $acaoModal.find(".js-pipeline-alertas-acao-confirmar").trigger("click");
            }
        });
    }

    function abrirModalAcaoChat(opcoes) {
        garantirModaisAcaoChat();
        const opts = opcoes || {};
        const $acaoModal = $("#modalPipelineAlertasChatAcao");
        const $btn = $acaoModal.find(".js-pipeline-alertas-acao-confirmar");
        const $renomear = $acaoModal.find(".js-pipeline-alertas-acao-renomear");
        const $texto = $acaoModal.find(".js-pipeline-alertas-acao-texto");
        const $erro = $acaoModal.find(".js-pipeline-alertas-acao-erro");
        const $input = $acaoModal.find(".js-pipeline-alertas-acao-input");

        $acaoModal.find(".js-pipeline-alertas-acao-titulo").text(opts.titulo || "Confirmar");
        $texto.text(opts.texto || "").prop("hidden", !opts.texto);
        $renomear.prop("hidden", opts.modo !== "renomear");
        $erro.prop("hidden", true).text("");
        $input.val(opts.valorInicial || "");
        $btn
            .text(opts.botao || "Confirmar")
            .removeClass("btn-danger btn-primary btn-success")
            .addClass(opts.danger ? "btn-danger" : "btn-primary");

        $acaoModal.data("onConfirm", function ($modalAcao) {
            if (opts.modo === "renomear") {
                const titulo = String($input.val() || "").trim();
                if (!titulo) {
                    $erro.text("Informe um título.").prop("hidden", false);
                    $input.trigger("focus");
                    return;
                }
                $modalAcao.modal("hide");
                if (typeof opts.onConfirm === "function") {
                    opts.onConfirm(titulo);
                }
                return;
            }
            $modalAcao.modal("hide");
            if (typeof opts.onConfirm === "function") {
                opts.onConfirm();
            }
        });

        $acaoModal.modal({
            backdrop: true,
            keyboard: true,
            show: true,
        });
    }

    function atualizarConversa($modal, conversaId, dados, opcoes) {
        if (!conversaUrlTemplate || !conversaId) {
            return;
        }
        const opts = opcoes || {};
        const url = conversaUrlTemplate.replace("__ID__", String(conversaId));
        setChatBusy($modal, true);

        $.ajax({
            url: url,
            method: "PATCH",
            dataType: "json",
            contentType: "application/json",
            headers: {
                "X-CSRF-TOKEN": csrfToken(),
                Accept: "application/json",
            },
            data: JSON.stringify(
                Object.assign({ pipeline_id: pipelineId }, dados),
            ),
        })
            .done(function (response) {
                const eraAtiva =
                    Number(estadoChat.conversaId) === Number(conversaId);
                const mudouArquivo = Object.prototype.hasOwnProperty.call(
                    dados,
                    "arquivado",
                );
                const saiuDaListaAtual =
                    mudouArquivo &&
                    ((modoListaArquivadas && !dados.arquivado) ||
                        (!modoListaArquivadas && !!dados.arquivado));

                if (saiuDaListaAtual) {
                    estadoChat = eraAtiva ? estadoChatBase() : estadoChat;
                    carregarListaConversas($modal, pipelineId, false)
                        .done(function (listaResponse) {
                            const conversas =
                                (listaResponse && listaResponse.conversas) ||
                                [];
                            if (eraAtiva && conversas.length) {
                                carregarConversa($modal, conversas[0].id);
                                return;
                            }
                            if (eraAtiva || !conversas.length) {
                                mostrarEstadoVazioChat(
                                    $modal,
                                    !conversas.length,
                                );
                            }
                        })
                        .always(function () {
                            setChatBusy($modal, false);
                        });
                    return;
                }

                if (
                    eraAtiva &&
                    response &&
                    response.conversa &&
                    response.conversa.titulo
                ) {
                    estadoChat.titulo = response.conversa.titulo;
                }

                carregarListaConversas(
                    $modal,
                    pipelineId,
                    !!estadoChat.rascunho && !estadoChat.conversaId,
                ).always(function () {
                    setChatBusy($modal, false);
                    if (typeof opts.onDone === "function") {
                        opts.onDone(response);
                    }
                });
            })
            .fail(function (xhr) {
                const msg =
                    (xhr.responseJSON && xhr.responseJSON.message) ||
                    "Não foi possível atualizar a análise.";
                $modal
                    .find(".js-alerta-vazao-chat-status")
                    .text(msg)
                    .addClass("is-error");
                setChatBusy($modal, false);
            });
    }

    function mostrarEstadoVazioChat($modal, semHistorico) {
        estadoChat = estadoChatBase();
        limparThread($modal);
        setComposerVisivel($modal, false);
        marcarItemAtivo($modal, null, false);

        let titulo = semHistorico
            ? "Nenhuma análise nesta pipeline"
            : "Selecione uma análise";
        let texto = semHistorico
            ? "Quando houver conversas com a IA, elas aparecerão aqui. Use “Nova análise” para começar."
            : "Escolha uma conversa na lista ao lado para continuar.";

        if (modoListaArquivadas) {
            titulo = semHistorico
                ? "Nenhuma análise arquivada"
                : "Selecione uma análise";
            texto = semHistorico
                ? "Análises arquivadas aparecerão aqui. Use “Ver ativas” para voltar ao histórico."
                : "Escolha uma conversa arquivada na lista ao lado. No menu, use Desarquivar para restaurá-la.";
        }

        definirHtmlMensagensChat(
            $modal,
            `
            <div class="pipeline-alertas-chat__empty">
                <div class="pipeline-alertas-chat__empty-icon" aria-hidden="true">
                    <i class="fas fa-robot"></i>
                </div>
                <h6 class="pipeline-alertas-chat__empty-title"></h6>
                <p class="pipeline-alertas-chat__empty-text"></p>
            </div>
        `,
        );
        $modal.find(".pipeline-alertas-chat__empty-title").text(titulo);
        $modal.find(".pipeline-alertas-chat__empty-text").text(texto);
        atualizarBannerGraficosChat($modal);
    }

    function excluirConversa($modal, conversaId) {
        if (!conversaUrlTemplate || !conversaId) {
            return;
        }

        const url =
            conversaUrlTemplate.replace("__ID__", String(conversaId)) +
            "?pipeline_id=" +
            encodeURIComponent(pipelineId);
        setChatBusy($modal, true);

        $.ajax({
            url: url,
            method: "DELETE",
            dataType: "json",
            headers: { "X-CSRF-TOKEN": csrfToken() },
        })
            .done(function () {
                const eraAtiva =
                    Number(estadoChat.conversaId) === Number(conversaId);
                estadoChat = estadoChatBase();

                carregarListaConversas($modal, pipelineId, false)
                    .done(function (response) {
                        const conversas =
                            (response && response.conversas) || [];
                        if (eraAtiva && conversas.length) {
                            carregarConversa($modal, conversas[0].id);
                            return;
                        }
                        if (eraAtiva || !conversas.length) {
                            mostrarEstadoVazioChat($modal, !conversas.length);
                        }
                    })
                    .always(function () {
                        setChatBusy($modal, false);
                    });
            })
            .fail(function (xhr) {
                const msg =
                    (xhr.responseJSON && xhr.responseJSON.message) ||
                    "Não foi possível excluir a análise.";
                $modal
                    .find(".js-alerta-vazao-chat-status")
                    .text(msg)
                    .addClass("is-error");
                setChatBusy($modal, false);
            });
    }

    function carregarListaConversas($modal, pipeline, manterDraft) {
        if (!conversasUrl) {
            return $.Deferred().resolve({ conversas: [] }).promise();
        }

        return $.ajax({
            url: conversasUrl,
            method: "GET",
            dataType: "json",
            data: {
                pipeline_id: pipeline,
                arquivadas: modoListaArquivadas ? 1 : 0,
            },
        }).then(function (response) {
            const conversas = (response && response.conversas) || [];
            renderListaConversas(
                $modal,
                conversas,
                manterDraft && !modoListaArquivadas
                    ? estadoChat.titulo || "Nova análise"
                    : null,
            );
            marcarItemAtivo(
                $modal,
                estadoChat.conversaId,
                !!manterDraft && estadoChat.rascunho && !modoListaArquivadas,
            );
            return response;
        });
    }

    function garantirBannerGraficosEmMensagens($modal) {
        const $messages = $modal.find(".js-alerta-vazao-chat-messages");
        if (!$messages.length) {
            return $();
        }

        let $banner = $modal.find(".js-pipeline-alertas-graficos-banner");
        if ($banner.length > 1) {
            $banner.slice(1).remove();
            $banner = $modal.find(".js-pipeline-alertas-graficos-banner").first();
        }

        if (!$banner.length) {
            $banner = $(htmlBannerGraficosChat(estadoChat.metrica));
            $messages.prepend($banner);
        } else if (
            !$banner.find(".js-pipeline-alertas-graficos-banner-metrica").length ||
            !$banner.find(".pipeline-alertas-graficos-banner__bubble").length
        ) {
            const $novo = $(htmlBannerGraficosChat(estadoChat.metrica));
            $banner.replaceWith($novo);
            $banner = $novo;
        }

        if (!$banner.parent().is($messages) || !$banner.is($messages.children().first())) {
            $messages.prepend($banner);
        }

        garantirFabGraficosChat($modal);
        return $banner;
    }

    function limparConteudoMensagensChat($modal) {
        const $messages = $modal.find(".js-alerta-vazao-chat-messages");
        $messages.children().not(".js-pipeline-alertas-graficos-banner").remove();
        garantirBannerGraficosEmMensagens($modal);
    }

    function definirHtmlMensagensChat($modal, html) {
        limparConteudoMensagensChat($modal);
        $modal.find(".js-alerta-vazao-chat-messages").append(html);
    }

    function limparThread($modal) {
        pararEsperaAnaliseConversas();
        fecharBalaoInfo($modal);
        limparConteudoMensagensChat($modal);
        $modal
            .find(".js-alerta-vazao-chat-status")
            .text("")
            .removeClass("is-error");
        $modal.find(".js-alerta-vazao-chat-limit-notice").remove();
        $modal.find(".js-alerta-vazao-chat").removeClass("is-limit-reached");
        const $inputLimpo = $modal.find(".js-alerta-vazao-chat-input");
        $inputLimpo.val("");
        ajustarAlturaChatInput($inputLimpo);
        esconderSugestoesChat($modal);
        setChatBusy($modal, false);
    }

    function setComposerVisivel($modal, visivel) {
        $modal
            .find(".js-alerta-vazao-chat")
            .toggleClass("is-selecionando-modo", !visivel);
    }

    function abrirSeletorModoAnalise($modal) {
        pararEsperaAnaliseConversas();
        estadoChat = estadoChatBase({
            selecionandoModo: true,
            titulo: "Nova análise",
        });
        fecharBalaoInfo($modal);
        limparThread($modal);
        setComposerVisivel($modal, false);
        carregarListaConversas($modal, pipelineId, false);

        const padraoAtual = datasPadraoAtual();
        definirHtmlMensagensChat(
            $modal,
            `
            <div class="pipeline-alertas-modo js-pipeline-alertas-modo">
                <div class="pipeline-alertas-modo__heading">
                    <p class="pipeline-alertas-modo__eyebrow">Nova análise</p>
                    <h6 class="pipeline-alertas-modo__titulo">Como deseja iniciar?</h6>
                    <p class="pipeline-alertas-modo__intro">
                        Escolha o contexto que a IA usará nesta conversa. Se você sair sem enviar mensagem, esta análise será descartada.
                    </p>
                </div>
                <div class="pipeline-alertas-modo__opcoes" role="radiogroup" aria-label="Modo da análise">
                    <button type="button" class="pipeline-alertas-modo__opcao js-pipeline-alertas-modo-opcao is-selected" data-modo="atual" aria-pressed="true">
                        <span class="pipeline-alertas-modo__opcao-check" aria-hidden="true"><i class="fas fa-check"></i></span>
                        <span class="pipeline-alertas-modo__opcao-icon" aria-hidden="true"><i class="fas fa-chart-line"></i></span>
                        <strong class="pipeline-alertas-modo__opcao-title">Métricas atuais</strong>
                        <span class="pipeline-alertas-modo__opcao-hint">Chat com o contexto do período que você definir (padrão: mês atual)</span>
                    </button>
                    <button type="button" class="pipeline-alertas-modo__opcao js-pipeline-alertas-modo-opcao" data-modo="comparativo" aria-pressed="false">
                        <span class="pipeline-alertas-modo__opcao-check" aria-hidden="true"><i class="fas fa-check"></i></span>
                        <span class="pipeline-alertas-modo__opcao-icon" aria-hidden="true"><i class="fas fa-exchange-alt"></i></span>
                        <strong class="pipeline-alertas-modo__opcao-title">Comparativo com o passado</strong>
                        <span class="pipeline-alertas-modo__opcao-hint">Compara os últimos 30 dias com uma janela fixa de 30 dias no passado</span>
                    </button>
                </div>
                <div class="pipeline-alertas-modo__periodo js-pipeline-alertas-modo-periodo">
                    <div class="pipeline-alertas-modo__periodo-card">
                        <div class="pipeline-alertas-modo__periodo-head">
                            <strong class="js-pipeline-alertas-modo-periodo-titulo">Período da análise</strong>
                            <span class="js-pipeline-alertas-modo-periodo-hint">Padrão: do 1º dia do mês até hoje. Você pode antecipar o início até no máximo 31 dias.</span>
                        </div>
                        <div class="pipeline-alertas-modo__periodo-campos">
                            <label class="pipeline-alertas-modo__campo">
                                <span>Data início</span>
                                <input type="date" class="js-pipeline-alertas-modo-inicio" min="${padraoAtual.minInicio}" max="${padraoAtual.maxInicio}" value="${padraoAtual.inicio}" />
                            </label>
                            <label class="pipeline-alertas-modo__campo js-pipeline-alertas-modo-fim-campo">
                                <span>Data fim</span>
                                <input type="date" class="js-pipeline-alertas-modo-fim" max="${padraoAtual.fim}" value="${padraoAtual.fim}" disabled />
                            </label>
                            <div class="pipeline-alertas-modo__campo pipeline-alertas-modo__campo--calculado js-pipeline-alertas-modo-fim-calculado" hidden>
                                <span>Data fim</span>
                                <div class="pipeline-alertas-modo__fim-box" aria-live="polite">
                                    <strong class="pipeline-alertas-modo__fim-valor js-pipeline-alertas-modo-fim-texto">—</strong>
                                    <small class="pipeline-alertas-modo__fim-hint">+30 dias · calculada</small>
                                </div>
                            </div>
                        </div>
                        <p class="pipeline-alertas-modo__periodo-erro js-pipeline-alertas-modo-erro" hidden></p>
                    </div>
                        </div>
                ${htmlCheckboxAnaliseConversas()}
                <div class="pipeline-alertas-modo__acoes">
                    <button type="button" class="pipeline-alertas-modo__continuar js-pipeline-alertas-modo-continuar">
                        Continuar
                    </button>
                </div>
            </div>
        `,
        );
        $modal
            .find(".js-pipeline-alertas-modo-inicio")
            .data("periodoAtualInicializado", true);
        sincronizarUiPeriodoModo($modal);
        atualizarValidacaoPeriodoModo($modal);
        atualizarBannerGraficosChat($modal);
    }

    function confirmarModoAnalise($modal, modo, dataInicio, dataFim, incluirAnaliseConversas, conversaId) {
        const titulo =
            modo === "comparativo"
                ? "Comparativo de métricas"
                : "Nova análise";
        const persistida = !!conversaId;

        estadoChat = estadoChatBase({
            conversaId: persistida ? conversaId : null,
            rascunho: !persistida,
            selecionandoModo: false,
            titulo: titulo,
            modoAnalise: modo,
            dataInicio: dataInicio,
            dataFim: dataFim,
            incluirAnaliseConversas: !!incluirAnaliseConversas,
        });

        limparThread($modal);
        setComposerVisivel($modal, true);
        atualizarBannerGraficosChat($modal);
        carregarListaConversas($modal, pipelineId, !persistida);

        const contextoTexto =
            modo === "comparativo"
                ? "Contexto: últimos 30 dias + período " +
                  formatDateBr(dataInicio) +
                  " a " +
                  formatDateBr(dataFim) +
                  " (30 dias). A IA responderá em comparação."
                : "Contexto: métricas do período " +
                  formatDateBr(dataInicio) +
                  " a " +
                  formatDateBr(dataFim) +
                  " desta pipeline.";

        definirHtmlMensagensChat(
            $modal,
            `
            <div class="pipeline-alertas-chat__ready">
                <div class="pipeline-alertas-chat__ready-icon" aria-hidden="true">
                    <i class="fas fa-comments"></i>
                </div>
                <h6 class="pipeline-alertas-chat__ready-title">Pronto para analisar</h6>
                <p class="pipeline-alertas-chat__ready-text"></p>
            </div>
        `,
        );
        $modal.find(".pipeline-alertas-chat__ready-text").text(contextoTexto);
        $modal.find(".js-alerta-vazao-chat-input").trigger("focus");
    }

    function descartarRascunhoSeVazio($modal) {
        if (estadoChat.conversaId || (!estadoChat.rascunho && !estadoChat.selecionandoModo)) {
            return;
        }
        estadoChat = estadoChatBase();
        setComposerVisivel($modal, true);
        carregarListaConversas($modal, pipelineId, false);
    }

    function iniciarRascunhoLivre($modal) {
        abrirSeletorModoAnalise($modal);
    }

    function carregarConversa($modal, conversaId) {
        if (!conversaUrlTemplate || !conversaId) {
            return;
        }

        const url = conversaUrlTemplate.replace("__ID__", String(conversaId));
        setChatBusy($modal, true);
        limparThread($modal);

        $.ajax({
            url: url,
            method: "GET",
            dataType: "json",
            data: { pipeline_id: pipelineId },
        })
            .done(function (conversa) {
                const mensagens = conversa.mensagens || [];
                const temRespostaAssistente = mensagens.some(function (mensagem) {
                    return mensagem.papel === "assistant";
                });
                const origemConversa = conversa.origem || "livre";
                const metricaConversa =
                    conversa.metrica ||
                    (origemConversa === "livre" && temRespostaAssistente
                        ? "vazao_pipeline"
                        : null);

                estadoChat = estadoChatBase({
                    conversaId: conversa.id,
                    origem: origemConversa,
                    rascunho: false,
                    titulo: conversa.titulo || "Análise",
                    metrica: metricaConversa,
                    temRespostaAssistente: temRespostaAssistente,
                    modoAnalise: conversa.modo_analise || "atual",
                    dataInicio: conversa.data_inicio || null,
                    dataFim: conversa.data_fim || null,
                    incluirAnaliseConversas: !!conversa.incluir_analise_conversas,
                    mensagensUsuario: Number(conversa.mensagens_usuario) || 0,
                    limiteMensagensUsuario:
                        Number(conversa.limite_mensagens_usuario) || 40,
                    limiteMensagensAtingido: !!conversa.limite_mensagens_atingido,
                });
                marcarItemAtivo($modal, conversa.id, false);

                if (conversa.preparando_analise_conversas) {
                    setComposerVisivel($modal, false);
                    setChatBusy($modal, false);
                    aguardarAnaliseConversasEContinuar(
                        $modal,
                        estadoChat.modoAnalise,
                        estadoChat.dataInicio,
                        estadoChat.dataFim,
                        { conversaId: conversa.id, criarConversa: false },
                    );
                    return;
                }

                setComposerVisivel($modal, true);
                if (
                    !(conversa.mensagens || []).length &&
                    conversa.incluir_analise_conversas
                ) {
                    setChatBusy($modal, false);
                    confirmarModoAnalise(
                        $modal,
                        estadoChat.modoAnalise,
                        estadoChat.dataInicio,
                        estadoChat.dataFim,
                        true,
                        conversa.id,
                    );
                    return;
                }

                const $messages = $modal.find(".js-alerta-vazao-chat-messages");
                (conversa.mensagens || []).forEach(function (mensagem) {
                    appendBubble(
                        $messages,
                        mensagem.papel === "assistant" ? "assistant" : "user",
                        mensagem.conteudo,
                        mensagem.papel === "assistant",
                        mensagem.baloes || [],
                        mensagem.audio_url || null,
                    );
                });
                marcarItemAtivo($modal, conversa.id, false);
                setChatBusy($modal, false);
                sincronizarLimiteMensagensChat($modal, conversa);
                atualizarBannerGraficosChat($modal);
            })
            .fail(function (xhr) {
                const msg =
                    (xhr.responseJSON && xhr.responseJSON.message) ||
                    "Não foi possível carregar a conversa.";
                $modal
                    .find(".js-alerta-vazao-chat-status")
                    .text(msg)
                    .addClass("is-error");
                setChatBusy($modal, false);
            });
    }

    function storageKeyHintHoverGraficos() {
        const payload = cacheAlertasAtivos.payload || {};
        const lojaId = payload.loja_id || "0";
        const userId = payload.user_id || "0";
        return `${HINT_HOVER_GRAFICOS_STORAGE_KEY}:${lojaId}:${userId}`;
    }

    function hintHoverGraficosJaVisto() {
        try {
            return window.localStorage.getItem(storageKeyHintHoverGraficos()) === "1";
        } catch (e) {
            return true;
        }
    }

    function marcarHintHoverGraficosVisto() {
        try {
            window.localStorage.setItem(storageKeyHintHoverGraficos(), "1");
        } catch (e) {
            /* localStorage indisponível */
        }
    }

    function listaTemAlertaComGrafico(lista) {
        if (!graficosUrl || !Array.isArray(lista) || !lista.length) {
            return false;
        }
        return lista.some(function (item) {
            return item && item.metrica && METRICAS_COM_GRAFICOS[item.metrica];
        });
    }

    function podeExibirHintHoverGraficos() {
        if (hintHoverGraficosJaVisto()) {
            return false;
        }
        return (
            listaTemAlertaComGrafico(cacheAlertasAtivos.alertas) ||
            listaTemAlertaComGrafico(cacheAlertasAnalisados.analises)
        );
    }

    function localizarCardHintHoverGraficos($modal) {
        let $cardAlvo = null;
        $modal
            .find(
                ".js-pipeline-alertas-aba-panel:not([hidden]) .js-pipeline-alertas-ativo-card",
            )
            .each(function () {
                const payload = $(this).data("alertaPayload") || {};
                if (payload.metrica && METRICAS_COM_GRAFICOS[payload.metrica]) {
                    $cardAlvo = $(this);
                    return false;
                }
            });
        return $cardAlvo;
    }

    function posicionarHintHoverGraficosTour($tour, $card) {
        if (!$tour.length || !$card || !$card.length || !$card[0]) {
            return;
        }

        const rect = $card[0].getBoundingClientRect();
        const pad = 10;
        const spotlightTop = Math.max(8, rect.top - pad);
        const spotlightLeft = Math.max(8, rect.left - pad);
        const spotlightWidth = Math.min(
            window.innerWidth - spotlightLeft - 8,
            rect.width + pad * 2,
        );
        const spotlightHeight = Math.min(
            window.innerHeight - spotlightTop - 8,
            rect.height + pad * 2,
        );

        $tour.find(".js-pipeline-alertas-hint-spotlight").css({
            top: spotlightTop + "px",
            left: spotlightLeft + "px",
            width: spotlightWidth + "px",
            height: spotlightHeight + "px",
        });

        const $popover = $tour.find(".js-pipeline-alertas-hint-popover");
        const popoverWidth = Math.min(280, window.innerWidth - 24);
        const popoverHeight = $popover.outerHeight() || 120;
        let popoverLeft = rect.right + 18;
        let popoverTop = rect.top + Math.max(0, (rect.height - popoverHeight) / 2);
        let popoverSide = "right";

        if (popoverLeft + popoverWidth > window.innerWidth - 12) {
            popoverLeft = rect.left - popoverWidth - 18;
            popoverSide = "left";
        }
        if (popoverLeft < 12) {
            popoverLeft = Math.max(
                12,
                Math.min(rect.left, window.innerWidth - popoverWidth - 12),
            );
            popoverTop = rect.bottom + 18;
            popoverSide = "below";
        }

        popoverTop = Math.max(
            12,
            Math.min(popoverTop, window.innerHeight - popoverHeight - 12),
        );

        $popover
            .attr("data-side", popoverSide)
            .css({
                top: popoverTop + "px",
                left: popoverLeft + "px",
                width: popoverWidth + "px",
            });

        $tour.find(".js-pipeline-alertas-hint-cursor").css({
            top: rect.top + rect.height * 0.62 + "px",
            left: rect.left + rect.width * 0.72 + "px",
        });
    }

    function limparDigitacaoHintHoverGraficos() {
        if (hintHoverGraficosTypeTimer) {
            window.clearTimeout(hintHoverGraficosTypeTimer);
            hintHoverGraficosTypeTimer = null;
        }
    }

    function digitarHintHoverGraficos($el, texto, velocidade, aoConcluir) {
        const conteudo = String(texto || "");
        let indice = 0;
        $el.text("").addClass("is-typing");

        function digitarProximo() {
            indice += 1;
            $el.text(conteudo.slice(0, indice));
            if (indice >= conteudo.length) {
                $el.removeClass("is-typing");
                hintHoverGraficosTypeTimer = null;
                if (typeof aoConcluir === "function") {
                    aoConcluir();
                }
                return;
            }
            hintHoverGraficosTypeTimer = window.setTimeout(
                digitarProximo,
                velocidade,
            );
        }

        hintHoverGraficosTypeTimer = window.setTimeout(digitarProximo, velocidade);
    }

    function iniciarDigitacaoHintHoverGraficos($tour) {
        const $titulo = $tour.find(".js-pipeline-alertas-hint-title");
        const $texto = $tour.find(".js-pipeline-alertas-hint-text");
        limparDigitacaoHintHoverGraficos();
        $titulo.text("");
        $texto.text("").attr("hidden", true);

        digitarHintHoverGraficos($titulo, HINT_HOVER_GRAFICOS_TITULO, 26, function () {
            $texto.removeAttr("hidden");
            const $cardAlvo = $(".js-pipeline-alertas-ativo-card.is-hint-spotlight").first();
            posicionarHintHoverGraficosTour($tour, $cardAlvo);
            digitarHintHoverGraficos($texto, HINT_HOVER_GRAFICOS_TEXTO, 16, function () {
                posicionarHintHoverGraficosTour($tour, $cardAlvo);
            });
        });
    }

    function ocultarHintHoverGraficos($modal, marcarVisto) {
        if (hintHoverGraficosTimer) {
            window.clearTimeout(hintHoverGraficosTimer);
            hintHoverGraficosTimer = null;
        }
        if (hintHoverGraficosHideTimer) {
            window.clearTimeout(hintHoverGraficosHideTimer);
            hintHoverGraficosHideTimer = null;
        }
        limparDigitacaoHintHoverGraficos();
        $(window).off("resize.pipelineAlertasHintTour");
        $modal
            .find(".js-pipeline-alertas-ativo-card.is-hint-spotlight")
            .removeClass("is-hint-spotlight");
        const $tour = $(".js-pipeline-alertas-hint-tour");
        if (!$tour.length) {
            if (marcarVisto) {
                marcarHintHoverGraficosVisto();
            }
            return;
        }
        $tour.removeClass("is-visible");
        window.setTimeout(function () {
            $tour.remove();
        }, 280);
        if (marcarVisto) {
            marcarHintHoverGraficosVisto();
        }
    }

    function mostrarHintHoverGraficos($modal) {
        if (!$modal || !$modal.length || !podeExibirHintHoverGraficos()) {
            return;
        }
        if (!$modal.find(".pipeline-alertas-chat__main").hasClass("is-view-alertas")) {
            return;
        }
        if ($(".js-pipeline-alertas-hint-tour").length) {
            return;
        }

        const $card = localizarCardHintHoverGraficos($modal);
        if (!$card || !$card.length) {
            return;
        }

        const cardEl = $card[0];
        if (cardEl && typeof cardEl.scrollIntoView === "function") {
            cardEl.scrollIntoView({
                block: "nearest",
                inline: "nearest",
            });
        }

        $card.addClass("is-hint-spotlight");

        const $tour = $(`
            <div class="pipeline-alertas-ativos__hint-tour js-pipeline-alertas-hint-tour" role="dialog" aria-modal="true" aria-labelledby="pipelineAlertasHintTourTitle">
                <button type="button" class="pipeline-alertas-ativos__hint-tour-backdrop js-pipeline-alertas-hint-tour-dismiss" aria-label="Fechar dica"></button>
                <div class="pipeline-alertas-ativos__hint-tour-spotlight js-pipeline-alertas-hint-spotlight" aria-hidden="true"></div>
                <div class="pipeline-alertas-ativos__hint-tour-cursor js-pipeline-alertas-hint-cursor" aria-hidden="true">
                    <span class="pipeline-alertas-ativos__hint-tour-cursor-ring"></span>
                    <span class="pipeline-alertas-ativos__hint-tour-cursor-ring pipeline-alertas-ativos__hint-tour-cursor-ring--delay"></span>
                    <svg class="pipeline-alertas-ativos__hint-tour-cursor-svg pipeline-alertas-ativos__hint-tour-cursor-svg--pointer" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.2 3.4c-.55-.28-1.15.22-1.02.82l4.2 19.1c.14.62.94.8 1.35.3l4.05-4.9 4.7 6.55c.34.48 1.04.56 1.48.17l2.35-2.1c.44-.39.48-1.08.08-1.52l-4.75-6.4 6.15-1.55c.6-.15.78-.9.3-1.22L6.2 3.4z" fill="#fff" stroke="#0f172a" stroke-width="1.4" stroke-linejoin="round"/>
                    </svg>
                    <svg class="pipeline-alertas-ativos__hint-tour-cursor-svg pipeline-alertas-ativos__hint-tour-cursor-svg--hand" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11 2.4c.66 0 1.2.54 1.2 1.2v7.7h.35V5.7c0-.66.54-1.2 1.2-1.2s1.2.54 1.2 1.2v5.4h.35V6.9c0-.66.54-1.2 1.2-1.2s1.2.54 1.2 1.2v4.35h.35V8.4c0-.66.54-1.2 1.2-1.2s1.2.54 1.2 1.2v7.35c0 2.76-2.24 5-5 5h-1.45c-1.78 0-3.38-.98-4.2-2.55L6.2 14.55a1.5 1.5 0 0 1 2.55-1.55l1.05 1.7V3.6c0-.66.54-1.2 1.2-1.2z" fill="#fff" stroke="#0f172a" stroke-width="1.5" stroke-linejoin="round"/>
                    </svg>
                </div>
                <div class="pipeline-alertas-ativos__hint-tour-popover js-pipeline-alertas-hint-popover">
                    <p class="pipeline-alertas-ativos__hint-tour-title js-pipeline-alertas-hint-title" id="pipelineAlertasHintTourTitle"></p>
                    <p class="pipeline-alertas-ativos__hint-tour-text js-pipeline-alertas-hint-text" hidden></p>
                </div>
            </div>
        `);
        $("body").append($tour);
        $tour.on("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            ocultarHintHoverGraficos($modal, true);
        });

        window.requestAnimationFrame(function () {
            posicionarHintHoverGraficosTour($tour, $card);
            $tour.addClass("is-visible");
            iniciarDigitacaoHintHoverGraficos($tour);
            window.requestAnimationFrame(function () {
                posicionarHintHoverGraficosTour($tour, $card);
            });
            window.setTimeout(function () {
                $tour.find(".js-pipeline-alertas-hint-cursor").addClass("is-hover");
            }, 1250);
        });

        $(window)
            .off("resize.pipelineAlertasHintTour")
            .on("resize.pipelineAlertasHintTour", function () {
                posicionarHintHoverGraficosTour($tour, $card);
            });

        hintHoverGraficosHideTimer = window.setTimeout(function () {
            hintHoverGraficosHideTimer = null;
            ocultarHintHoverGraficos($modal, true);
        }, 7000);
    }

    function agendarHintHoverGraficos($modal) {
        if (hintHoverGraficosTimer) {
            window.clearTimeout(hintHoverGraficosTimer);
            hintHoverGraficosTimer = null;
        }
        if (!podeExibirHintHoverGraficos()) {
            return;
        }
        hintHoverGraficosTimer = window.setTimeout(function () {
            hintHoverGraficosTimer = null;
            mostrarHintHoverGraficos($modal);
        }, 420);
    }

    function mostrarViewModal($modal, view) {
        const viewAlertas = view === "alertas";
        const $main = $modal.find(".pipeline-alertas-chat__main");
        $main
            .toggleClass("is-view-alertas", viewAlertas)
            .toggleClass("is-view-chat", !viewAlertas);
        $modal
            .find(".js-alerta-vazao-chat")
            .prop("hidden", viewAlertas)
            .attr("aria-hidden", viewAlertas ? "true" : "false");
        $modal
            .find(".js-pipeline-alertas-ativos-page")
            .prop("hidden", !viewAlertas)
            .attr("aria-hidden", viewAlertas ? "false" : "true");
        $modal
            .find(".js-pipeline-alertas-abrir-ativos")
            .toggleClass("is-active", viewAlertas)
            .attr("aria-pressed", viewAlertas ? "true" : "false");
        if (viewAlertas) {
            marcarItemAtivo($modal, null, false);
        } else {
            ocultarHintHoverGraficos($modal, false);
        }
    }

    function atualizarBotaoAlertasAtivos($modal) {
        const $btn = $modal.find(".js-pipeline-alertas-abrir-ativos");
        if (!$btn.length) {
            return;
        }
        const autorizado = cacheAlertasAtivos.autorizado !== false;
        const temAlertas = cacheAlertasAtivos.alertas.length > 0;
        if (!autorizado) {
            $btn.attr("hidden", true);
            if ($modal.find(".pipeline-alertas-chat__main").hasClass("is-view-alertas")) {
                mostrarViewModal($modal, "chat");
            }
            return;
        }
        $btn.removeAttr("hidden");
        $btn.toggleClass("has-alertas", temAlertas);
    }

    function destruirApexEm($container) {
        if (!$container || !$container.length) {
            return;
        }
        const lista = $container.data("apexCharts") || [];
        lista.forEach(function (chart) {
            try {
                if (chart && typeof chart.destroy === "function") {
                    chart.destroy();
                }
            } catch (e) {
                // ignore
            }
        });
        $container.data("apexCharts", []);
    }

    function htmlSkeletonGraficos() {
        return `
            <div class="pipeline-alertas-graficos__skeleton">
                <div class="pipeline-alertas-graficos__skeleton-card"></div>
                <div class="pipeline-alertas-graficos__skeleton-card"></div>
                <div class="pipeline-alertas-graficos__skeleton-card"></div>
            </div>
        `;
    }

    function formatDateBrFromIso(iso) {
        const texto = String(iso || "").trim();
        const partes = texto.split("-");
        if (partes.length !== 3) {
            return texto;
        }
        return partes[2] + "/" + partes[1] + "/" + partes[0];
    }

    function formatarValorGrafico(unidade, valor) {
        if (valor === null || valor === undefined || valor === "") {
            return "—";
        }
        const numero = Number(valor);
        if (!Number.isFinite(numero)) {
            return "—";
        }
        if (unidade === "BRL") {
            return numero.toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
                maximumFractionDigits: 0,
            });
        }
        if (unidade === "min") {
            return (
                numero.toLocaleString("pt-BR", { maximumFractionDigits: 1 }) +
                " min"
            );
        }
        if (unidade === "pct") {
            return (
                numero.toLocaleString("pt-BR", { maximumFractionDigits: 1 }) +
                "%"
            );
        }
        return numero.toLocaleString("pt-BR", { maximumFractionDigits: 2 });
    }

    function montarSubtituloModalGraficos(payload) {
        if (
            !payload ||
            payload.modo_analise !== "comparativo" ||
            !payload.periodo ||
            !payload.periodo.comparativo
        ) {
            return "Visualização padrão do sistema para a métrica desta conversa.";
        }

        const atual = payload.periodo.atual || {};
        const comp = payload.periodo.comparativo || {};
        const intervaloAtual =
            atual.inicio && atual.fim
                ? formatDateBrFromIso(atual.inicio) +
                  " a " +
                  formatDateBrFromIso(atual.fim)
                : "";
        const intervaloComp =
            comp.inicio && comp.fim
                ? formatDateBrFromIso(comp.inicio) +
                  " a " +
                  formatDateBrFromIso(comp.fim)
                : "";

        return (
            "Comparando " +
            (atual.descricao || "período atual").toLowerCase() +
            (intervaloAtual ? " (" + intervaloAtual + ")" : "") +
            " com o intervalo selecionado" +
            (intervaloComp ? " (" + intervaloComp + ")" : "") +
            ". Os gráficos alinham os dois períodos dia a dia."
        );
    }

    function htmlLegendaPeriodosGraficos(payload) {
        if (
            !payload ||
            payload.modo_analise !== "comparativo" ||
            !payload.periodo ||
            !payload.periodo.comparativo
        ) {
            return "";
        }

        const atual = payload.periodo.atual || {};
        const comp = payload.periodo.comparativo || {};
        const labelAtual =
            (atual.descricao || "Período atual") +
            (atual.inicio && atual.fim
                ? " · " +
                  formatDateBrFromIso(atual.inicio) +
                  " a " +
                  formatDateBrFromIso(atual.fim)
                : "");
        const labelComp =
            (comp.descricao || "Período comparativo") +
            (comp.inicio && comp.fim
                ? " · " +
                  formatDateBrFromIso(comp.inicio) +
                  " a " +
                  formatDateBrFromIso(comp.fim)
                : "");

        return (
            '<div class="pipeline-alertas-graficos__periodos">' +
            '<span class="pipeline-alertas-graficos__periodo pipeline-alertas-graficos__periodo--atual">' +
            "<i aria-hidden=\"true\"></i>" +
            escapeHtml(labelAtual) +
            "</span>" +
            '<span class="pipeline-alertas-graficos__periodo pipeline-alertas-graficos__periodo--comparativo">' +
            "<i aria-hidden=\"true\"></i>" +
            escapeHtml(labelComp) +
            "</span>" +
            '<span class="pipeline-alertas-graficos__periodos-hint">Mesmo índice = mesmo dia relativo em cada intervalo</span>' +
            "</div>"
        );
    }

    function sanitizarSerieData(data, chartType) {
        if (!Array.isArray(data)) {
            return [];
        }
        return data.map(function (ponto) {
            if (chartType === "scatter" || chartType === "bubble") {
                if (ponto && typeof ponto === "object") {
                    const base = {
                        x: Number(ponto.x) || 0,
                        y: Number(ponto.y) || 0,
                    };
                    if (chartType === "bubble") {
                        base.z = Number(ponto.z) || 4;
                    }
                    return base;
                }
                return chartType === "bubble"
                    ? { x: 0, y: 0, z: 4 }
                    : { x: 0, y: 0 };
            }
            if (chartType === "heatmap" && ponto && typeof ponto === "object") {
                return {
                    x: String(ponto.x || ""),
                    y: Number.isFinite(Number(ponto.y)) ? Number(ponto.y) : 0,
                };
            }
            if (ponto === null || ponto === undefined || ponto === "") {
                return chartType === "line" || chartType === "area" ? null : 0;
            }
            const numero = Number(ponto);
            return Number.isFinite(numero) ? numero : 0;
        });
    }

    function temaEscuroAtivo() {
        return document.body.classList.contains("eloca-theme-dark");
    }

    function aplicarTemaEscuroApex(options, chartType) {
        if (!temaEscuroAtivo()) {
            return options;
        }

        const corTexto = "#cbd5e1";
        const corGrade = "rgba(255,255,255,0.08)";

        options.chart = options.chart || {};
        options.chart.foreColor = corTexto;
        options.chart.background = "transparent";

        options.grid = options.grid || {};
        options.grid.borderColor = corGrade;

        options.legend = options.legend || {};
        options.legend.labels = Object.assign({}, options.legend.labels || {}, {
            colors: corTexto,
        });

        options.tooltip = options.tooltip || {};
        options.tooltip.theme = "dark";

        if (options.xaxis) {
            options.xaxis.labels = options.xaxis.labels || {};
            options.xaxis.labels.style = Object.assign(
                {},
                options.xaxis.labels.style || {},
                { colors: corTexto },
            );
            if (options.xaxis.title && options.xaxis.title.style) {
                options.xaxis.title.style = Object.assign(
                    {},
                    options.xaxis.title.style,
                    { color: corTexto },
                );
            }
            options.xaxis.axisBorder = Object.assign(
                {},
                options.xaxis.axisBorder || {},
                { color: corGrade },
            );
            options.xaxis.axisTicks = Object.assign(
                {},
                options.xaxis.axisTicks || {},
                { color: corGrade },
            );
        }

        if (options.yaxis) {
            const aplicarY = function (eixo) {
                eixo.labels = eixo.labels || {};
                eixo.labels.style = Object.assign(
                    {},
                    eixo.labels.style || {},
                    { colors: corTexto },
                );
                return eixo;
            };
            if (Array.isArray(options.yaxis)) {
                options.yaxis = options.yaxis.map(aplicarY);
            } else {
                options.yaxis = aplicarY(options.yaxis);
            }
        }

        if (
            options.annotations &&
            Array.isArray(options.annotations.yaxis)
        ) {
            options.annotations.yaxis = options.annotations.yaxis.map(
                function (anotacao) {
                    const copia = Object.assign({}, anotacao);
                    if (copia.label) {
                        copia.label = Object.assign({}, copia.label, {
                            style: Object.assign({}, copia.label.style || {}, {
                                color: "#f3f4f6",
                                background: "rgba(43, 46, 50, 0.92)",
                            }),
                        });
                    }
                    return copia;
                },
            );
        }

        return options;
    }

    function montarOpcoesApex(grafico) {
        const tipo = grafico.tipo || "bar";
        const horizontal = !!(grafico.meta && grafico.meta.horizontal);
        const meta = grafico.meta || {};
        const isComparativo = !!meta.comparativo;
        const labelsComparativo = Array.isArray(meta.labels_comparativo)
            ? meta.labels_comparativo
            : [];
        const unidade = meta.unidade || "";
        const cores = Array.isArray(grafico.cores) ? grafico.cores : ["#3379be"];
        const tiposApex = {
            area: "area",
            line: "line",
            donut: "donut",
            scatter: "scatter",
            radialBar: "radialBar",
            radar: "radar",
            polarArea: "polarArea",
            heatmap: "heatmap",
            bubble: "bubble",
        };
        const chartType = tiposApex[tipo] || "bar";

        const seriesObj = (grafico.series || []).map(function (serie) {
            return {
                name: serie.name || "",
                data: sanitizarSerieData(serie.data, chartType),
            };
        });

        const isSerieTemporal =
            chartType === "line" || chartType === "area";
        const temDuasSeries = seriesObj.length >= 2;
        const altura =
            chartType === "radialBar" ||
            chartType === "radar" ||
            chartType === "polarArea" ||
            chartType === "heatmap"
                ? 260
                : 220;

        const options = {
            chart: {
                type: chartType,
                height: altura,
                width: "100%",
                toolbar: { show: false },
                fontFamily: "inherit",
                animations: { enabled: true, speed: 450 },
                parentHeightOffset: 0,
            },
            colors: cores,
            series:
                chartType === "donut" ||
                chartType === "radialBar" ||
                chartType === "polarArea"
                    ? seriesObj[0] && Array.isArray(seriesObj[0].data)
                        ? seriesObj[0].data
                        : [0]
                    : seriesObj.length
                      ? seriesObj
                      : [{ name: "Dados", data: [0] }],
            dataLabels: { enabled: false },
            stroke: {
                curve: "smooth",
                width: isSerieTemporal ? 3 : chartType === "radar" ? 2 : 0,
            },
            legend: {
                show:
                    seriesObj.length > 1 ||
                    chartType === "donut" ||
                    chartType === "radialBar" ||
                    chartType === "polarArea",
                position: "bottom",
                fontSize: "11px",
            },
            grid: {
                strokeDashArray: 3,
                padding: { left: 8, right: 8 },
            },
            tooltip: {
                shared: chartType !== "scatter" && chartType !== "bubble",
                intersect: chartType === "scatter" || chartType === "bubble",
            },
        };

        if (isSerieTemporal) {
            options.fill = {
                type: "solid",
                opacity: isComparativo && temDuasSeries ? 0.45 : 0.55,
            };
            options.stroke.width = isComparativo && temDuasSeries ? [3, 2] : 3;
            if (isComparativo && temDuasSeries) {
                options.stroke.dashArray = [0, 5];
            }
        }

        if (chartType === "radar") {
            options.fill = { opacity: 0.35 };
            options.markers = { size: 3 };
            options.stroke.width = 2;
        }

        if (isComparativo && isSerieTemporal) {
            options.tooltip.x = {
                formatter: function (valor, opts) {
                    const indice =
                        opts && typeof opts.dataPointIndex === "number"
                            ? opts.dataPointIndex
                            : -1;
                    const labelAtual =
                        (Array.isArray(grafico.labels)
                            ? grafico.labels[indice]
                            : "") || String(valor || "");
                    const labelComp = labelsComparativo[indice] || "";
                    if (labelComp) {
                        return (
                            "Atual: " +
                            labelAtual +
                            " · Comparativo: " +
                            labelComp
                        );
                    }
                    return labelAtual;
                },
            };
        }

        if (
            unidade &&
            chartType !== "donut" &&
            chartType !== "scatter" &&
            chartType !== "bubble" &&
            chartType !== "heatmap" &&
            chartType !== "radialBar" &&
            chartType !== "polarArea"
        ) {
            options.tooltip.y = {
                formatter: function (valor) {
                    return formatarValorGrafico(unidade, valor);
                },
            };
        }

        // ApexCharts 3.x lê plotOptions.bar no Core mesmo para donut/area/line.
        // Se plotOptions for passado só com pie, o merge pode perder .bar e quebrar.
        options.plotOptions = {
            bar: {
                horizontal: horizontal,
                borderRadius: 3,
                columnWidth: "55%",
                barHeight: "70%",
            },
        };

        if (chartType === "donut") {
            options.labels =
                Array.isArray(grafico.labels) && grafico.labels.length
                    ? grafico.labels
                    : ["Sem dados"];
            options.plotOptions.pie = {
                donut: { size: "65%" },
            };
        } else if (chartType === "polarArea") {
            options.labels =
                Array.isArray(grafico.labels) && grafico.labels.length
                    ? grafico.labels
                    : ["Sem dados"];
            options.stroke = { colors: ["#fff"], width: 2 };
            options.fill = { opacity: 0.85 };
            options.yaxis = { show: false };
            options.plotOptions.polarArea = {
                rings: { strokeWidth: 1 },
                spokes: { strokeWidth: 1 },
            };
            if (unidade) {
                options.tooltip.y = {
                    formatter: function (valor) {
                        return formatarValorGrafico(unidade, valor);
                    },
                };
            }
        } else if (chartType === "radialBar") {
            options.labels =
                Array.isArray(grafico.labels) && grafico.labels.length
                    ? grafico.labels
                    : ["Valor"];
            const radialMax = Number(meta.radial_max) || 100;
            const overrides = Array.isArray(meta.radial_value_override)
                ? meta.radial_value_override
                : [];
            options.plotOptions.radialBar = {
                hollow: { size: seriesObj[0] && seriesObj[0].data.length > 1 ? "42%" : "58%" },
                track: { background: "rgba(148, 163, 184, 0.22)", strokeWidth: "100%" },
                dataLabels: {
                    name: { fontSize: "12px", offsetY: -6 },
                    value: {
                        fontSize: "22px",
                        fontWeight: 700,
                        offsetY: 6,
                        formatter: function (val, opts) {
                            const idx =
                                opts && typeof opts.seriesIndex === "number"
                                    ? opts.seriesIndex
                                    : 0;
                            if (
                                overrides[idx] !== null &&
                                overrides[idx] !== undefined &&
                                Number.isFinite(Number(overrides[idx]))
                            ) {
                                return formatarValorGrafico(
                                    unidade || "min",
                                    overrides[idx],
                                );
                            }
                            return formatarValorGrafico(unidade || "pct", val);
                        },
                    },
                    total: {
                        show: true,
                        label: Array.isArray(grafico.labels) && grafico.labels[0]
                            ? String(grafico.labels[0])
                            : "Total",
                        formatter: function () {
                            if (meta.destaque) {
                                return String(meta.destaque);
                            }
                            const primeiro =
                                seriesObj[0] && Array.isArray(seriesObj[0].data)
                                    ? seriesObj[0].data[0]
                                    : 0;
                            return formatarValorGrafico(
                                unidade || "pct",
                                primeiro,
                            );
                        },
                    },
                },
            };
            options.yaxis = { max: radialMax };
        } else if (chartType === "radar") {
            options.xaxis = {
                categories:
                    Array.isArray(grafico.labels) && grafico.labels.length
                        ? grafico.labels
                        : ["—"],
            };
            options.yaxis = {
                show: false,
                max: unidade === "pct" ? 100 : undefined,
            };
            if (unidade) {
                options.tooltip.y = {
                    formatter: function (valor) {
                        return formatarValorGrafico(unidade, valor);
                    },
                };
            }
        } else if (chartType === "heatmap") {
            options.dataLabels = { enabled: false };
            options.plotOptions.heatmap = {
                shadeIntensity: 0.55,
                radius: 3,
                useFillColorAsStroke: false,
                colorScale: {
                    ranges: [
                        { from: -1, to: 20, color: "#fecaca", name: "Baixa" },
                        { from: 20.01, to: 40, color: "#fdba74", name: "Moderada" },
                        { from: 40.01, to: 60, color: "#fbbf24", name: "Média" },
                        { from: 60.01, to: 80, color: "#3379be", name: "Alta" },
                        { from: 80.01, to: 1000, color: "#00a771", name: "Muito alta" },
                    ],
                },
            };
            options.stroke = { width: 1, colors: ["#ffffff"] };
            if (unidade) {
                options.tooltip.y = {
                    formatter: function (valor) {
                        return formatarValorGrafico(unidade, valor);
                    },
                };
            }
        } else if (chartType === "bubble" || chartType === "scatter") {
            options.xaxis = { tickAmount: 4, labels: { style: { fontSize: "10px" } } };
            options.yaxis = { labels: { style: { fontSize: "10px" } } };
            if (chartType === "bubble") {
                options.plotOptions.bubble = {
                    minBubbleRadius: 5,
                    maxBubbleRadius: 22,
                };
            }
        } else {
            const categories =
                Array.isArray(grafico.labels) && grafico.labels.length
                    ? grafico.labels
                    : ["—"];
            options.xaxis = {
                categories: categories,
                labels: {
                    rotate: categories.length > 18 ? -25 : -35,
                    style: { fontSize: "10px" },
                    hideOverlappingLabels: true,
                },
            };

            if (isComparativo && isSerieTemporal) {
                options.xaxis.tickAmount =
                    categories.length > 14 ? 8 : undefined;
                options.xaxis.title = {
                    text: "Dias do período atual (alinhados ao comparativo)",
                    style: { fontSize: "10px", fontWeight: 500 },
                };
            }

            const formatarEixoValor = function (valor) {
                return formatarValorGrafico(unidade, valor);
            };
            const temAnotacaoY =
                grafico.annotations &&
                Array.isArray(grafico.annotations.yaxis) &&
                grafico.annotations.yaxis.length;

            if (!horizontal && unidade && !temAnotacaoY) {
                options.yaxis = {
                    labels: {
                        style: { fontSize: "10px" },
                        formatter: formatarEixoValor,
                    },
                };
            }
            options.series = (Array.isArray(options.series) ? options.series : []).map(
                function (serie) {
                    const data = Array.isArray(serie.data) ? serie.data.slice() : [];
                    while (data.length < categories.length) {
                        data.push(
                            chartType === "line" || chartType === "area" ? null : 0,
                        );
                    }
                    return {
                        name: serie.name || "",
                        data: data.slice(0, categories.length),
                    };
                },
            );
        }

        if (
            grafico.annotations &&
            ((Array.isArray(grafico.annotations.yaxis) &&
                grafico.annotations.yaxis.length) ||
                (Array.isArray(grafico.annotations.points) &&
                    grafico.annotations.points.length))
        ) {
            options.annotations = grafico.annotations;
        }

        return aplicarTemaEscuroApex(options, chartType);
    }

    function renderGraficosEm($container, payload) {
        destruirApexEm($container);
        $container.empty();
        if (!payload || !Array.isArray(payload.graficos) || !payload.graficos.length) {
            $container.html(
                '<div class="pipeline-alertas-graficos__erro">Nenhum gráfico disponível.</div>',
            );
            return;
        }
        if (typeof window.ApexCharts === "undefined") {
            $container.html(
                '<div class="pipeline-alertas-graficos__erro">Biblioteca de gráficos indisponível.</div>',
            );
            return;
        }

        const listaCharts = [];
        const legendaPeriodos = htmlLegendaPeriodosGraficos(payload);
        if (legendaPeriodos) {
            $container.append(legendaPeriodos);
        }
        const $grid = $('<div class="pipeline-alertas-graficos__grid"></div>');
        $container.append($grid);

        payload.graficos.forEach(function (grafico) {
            const metaGrafico = grafico.meta || {};
            const $card = $(`
                <div class="pipeline-alertas-graficos__item${metaGrafico.comparativo ? " is-comparativo" : ""}">
                    <div class="pipeline-alertas-graficos__item-title"></div>
                    <div class="pipeline-alertas-graficos__item-sub"></div>
                    <div class="pipeline-alertas-graficos__item-chart js-pipeline-alertas-grafico-el"></div>
                </div>
            `);
            $card.find(".pipeline-alertas-graficos__item-title").text(grafico.titulo || "");
            if (grafico.subtitulo) {
                $card.find(".pipeline-alertas-graficos__item-sub").text(grafico.subtitulo);
            } else if (metaGrafico.legenda_eixo) {
                $card
                    .find(".pipeline-alertas-graficos__item-sub")
                    .text(String(metaGrafico.legenda_eixo));
            } else if (metaGrafico.destaque) {
                $card
                    .find(".pipeline-alertas-graficos__item-sub")
                    .text(String(metaGrafico.destaque));
            } else {
                $card.find(".pipeline-alertas-graficos__item-sub").remove();
            }
            $grid.append($card);

            const el = $card.find(".js-pipeline-alertas-grafico-el").get(0);
            try {
                const chart = new window.ApexCharts(el, montarOpcoesApex(grafico));
                listaCharts.push(chart);
                chart.render().catch(function () {
                    $(el).html(
                        '<div class="pipeline-alertas-graficos__erro">Não foi possível montar este gráfico.</div>',
                    );
                });
            } catch (erro) {
                $card
                    .find(".js-pipeline-alertas-grafico-el")
                    .html(
                        '<div class="pipeline-alertas-graficos__erro">Não foi possível montar este gráfico.</div>',
                    );
            }
        });

        $container.data("apexCharts", listaCharts);
    }

    function buscarGraficos(params) {
        if (!graficosUrl) {
            return $.Deferred().reject().promise();
        }
        return $.ajax({
            url: graficosUrl,
            method: "GET",
            dataType: "json",
            data: Object.assign({ pipeline_id: pipelineId }, params || {}),
            headers: { Accept: "application/json", "X-CSRF-TOKEN": csrfToken() },
        });
    }

    function cancelarFecharBalaoGraficosHover() {
        if (hoverGraficosCloseTimer) {
            window.clearTimeout(hoverGraficosCloseTimer);
            hoverGraficosCloseTimer = null;
        }
    }

    function agendarFecharBalaoGraficosHover() {
        cancelarFecharBalaoGraficosHover();
        hoverGraficosCloseTimer = window.setTimeout(function () {
            hoverGraficosCloseTimer = null;
            fecharBalaoGraficosHover();
        }, 120);
    }

    function fecharBalaoGraficosHover() {
        cancelarFecharBalaoGraficosHover();
        if (hoverGraficosTimer) {
            window.clearTimeout(hoverGraficosTimer);
            hoverGraficosTimer = null;
        }
        if (hoverGraficosRequest && hoverGraficosRequest.abort) {
            hoverGraficosRequest.abort();
            hoverGraficosRequest = null;
        }
        hoverGraficosCardEl = null;
        $(window).off("resize.pipelineAlertasGraficosBalao");
        const $balao = $(".js-pipeline-alertas-graficos-balao");
        if ($balao.length) {
            destruirApexEm($balao.find(".js-pipeline-alertas-graficos-balao-body"));
            $balao.removeClass("is-visible");
            window.setTimeout(function () {
                $balao.remove();
            }, 180);
        }
    }

    function posicionarBalaoGraficosHover($balao, $card) {
        if (!$balao.length || !$card.length || !$card.get(0)) {
            return;
        }
        const rect = $card.get(0).getBoundingClientRect();
        const padding = 12;
        const balaoLargura = Math.min(720, window.innerWidth - padding * 2);
        const maxHeight = Math.min(
            window.innerHeight * 0.78,
            720,
            window.innerHeight - padding * 2,
        );

        $balao.css({
            width: balaoLargura + "px",
            maxHeight: maxHeight + "px",
        });
        $balao.find(".js-pipeline-alertas-graficos-balao-body").css({
            maxHeight: maxHeight + "px",
        });

        let left = rect.right + padding;
        if (left + balaoLargura > window.innerWidth - padding) {
            left = rect.left - balaoLargura - padding;
        }
        if (left < padding) {
            left = padding;
        }

        // Mede depois de aplicar largura/maxHeight para caber na viewport.
        const balaoHeight =
            Math.min($balao.outerHeight() || 0, maxHeight) ||
            Math.min(320, maxHeight);
        const topMax = Math.max(padding, window.innerHeight - padding - balaoHeight);
        const top = Math.min(Math.max(padding, rect.top), topMax);

        $balao.css({
            top: top + "px",
            left: left + "px",
        });
    }

    function abrirBalaoGraficosHover($card, metrica) {
        fecharBalaoGraficosHover();
        const $modal = $card.closest("#modalPipelineAlertasChat");
        ocultarHintHoverGraficos($modal, true);
        const $balao = $(`
            <div class="pipeline-alertas-graficos-balao js-pipeline-alertas-graficos-balao" role="dialog" aria-label="Gráficos do alerta">
                <div class="pipeline-alertas-graficos-balao__inner js-pipeline-alertas-graficos-balao-body">
                    ${htmlSkeletonGraficos()}
                </div>
            </div>
        `);
        $("body").append($balao);
        hoverGraficosCardEl = $card.get(0);
        posicionarBalaoGraficosHover($balao, $card);
        window.requestAnimationFrame(function () {
            posicionarBalaoGraficosHover($balao, $card);
            $balao.addClass("is-visible");
        });

        hoverGraficosRequest = buscarGraficos({
            metrica: metrica,
            modo_analise: "atual",
        });
        hoverGraficosRequest
            .done(function (payload) {
                if (!$balao.closest("body").length) {
                    return;
                }
                const $body = $balao.find(".js-pipeline-alertas-graficos-balao-body");
                renderGraficosEm($body, payload);
                window.requestAnimationFrame(function () {
                    posicionarBalaoGraficosHover($balao, $card);
                });
            })
            .fail(function (xhr) {
                if (xhr && xhr.statusText === "abort") {
                    return;
                }
                $balao
                    .find(".js-pipeline-alertas-graficos-balao-body")
                    .html(
                        '<div class="pipeline-alertas-graficos__erro">Não foi possível carregar os gráficos.</div>',
                    );
                posicionarBalaoGraficosHover($balao, $card);
            })
            .always(function () {
                hoverGraficosRequest = null;
            });

        $balao.on("mouseenter", function () {
            cancelarFecharBalaoGraficosHover();
        });
        $balao.on("mouseleave", function (e) {
            const related = e.relatedTarget;
            if (
                related &&
                hoverGraficosCardEl &&
                (related === hoverGraficosCardEl ||
                    $.contains(hoverGraficosCardEl, related))
            ) {
                return;
            }
            agendarFecharBalaoGraficosHover();
        });
        $modal
            .find(".pipeline-alertas-ativos__scroll")
            .one("scroll", fecharBalaoGraficosHover);
        $(window)
            .off("resize.pipelineAlertasGraficosBalao")
            .on("resize.pipelineAlertasGraficosBalao", function () {
                if ($(".js-pipeline-alertas-graficos-balao").length) {
                    posicionarBalaoGraficosHover($balao, $card);
                }
            });
    }

    function labelMetricaGraficos(metrica) {
        return METRICAS_LABELS[metrica] || "Métrica da análise";
    }

    function htmlBannerGraficosChat(metrica) {
        const label = labelMetricaGraficos(metrica);
        return `
            <div class="pipeline-alertas-graficos-banner js-pipeline-alertas-graficos-banner alerta-vazao-modal__chat-row alerta-vazao-modal__chat-row--assistant" hidden aria-hidden="true">
                <div class="pipeline-alertas-graficos-banner__avatar" aria-hidden="true">
                    <i class="fas fa-chart-area"></i>
                </div>
                <div class="alerta-vazao-modal__chat-bubble alerta-vazao-modal__chat-bubble--assistant pipeline-alertas-graficos-banner__bubble">
                    <div class="pipeline-alertas-graficos-banner__text">
                        <strong>Gráficos da análise</strong>
                        <span class="js-pipeline-alertas-graficos-banner-metrica">${escapeHtml(label)}</span>
                        <span class="pipeline-alertas-graficos-banner__hint">Indicadores padrão do sistema para apoiar a leitura desta conversa.</span>
                    </div>
                    <button type="button" class="pipeline-alertas-graficos-banner__btn js-pipeline-alertas-graficos-toggle">
                        Abrir gráficos
                        <i class="fas fa-external-link-alt" aria-hidden="true"></i>
                    </button>
                </div>
            </div>
        `;
    }

    function htmlFabGraficosChat() {
        return `
            <div class="pipeline-alertas-graficos-fab-wrap js-pipeline-alertas-graficos-fab-wrap" hidden>
                <button type="button" class="pipeline-alertas-graficos-fab js-pipeline-alertas-graficos-fab" aria-label="Abrir gráficos da análise" title="Gráficos da análise" aria-expanded="false">
                    <i class="fas fa-chart-area" aria-hidden="true"></i>
                </button>
                <div class="pipeline-alertas-graficos-fab-panel js-pipeline-alertas-graficos-fab-panel" hidden>
                    <div class="pipeline-alertas-graficos-fab-panel__text">
                        <strong>Gráficos da análise</strong>
                        <span class="js-pipeline-alertas-graficos-fab-metrica">Métrica da análise</span>
                        <span class="pipeline-alertas-graficos-banner__hint">Indicadores padrão do sistema para apoiar a leitura desta conversa.</span>
                    </div>
                    <button type="button" class="pipeline-alertas-graficos-banner__btn js-pipeline-alertas-graficos-toggle">
                        Abrir gráficos
                        <i class="fas fa-external-link-alt" aria-hidden="true"></i>
                    </button>
                </div>
            </div>
        `;
    }

    function garantirFabGraficosChat($modal) {
        const $thread = $modal.find(".alerta-vazao-modal__chat-thread");
        if (!$thread.length) {
            return $();
        }
        let $wrap = $modal.find(".js-pipeline-alertas-graficos-fab-wrap");
        if (!$wrap.length) {
            $thread.append(htmlFabGraficosChat());
            $wrap = $modal.find(".js-pipeline-alertas-graficos-fab-wrap");
        }
        return $wrap;
    }

    function fecharPainelFabGraficos($modal, imediato) {
        if (graficosFabHoverTimer) {
            window.clearTimeout(graficosFabHoverTimer);
            graficosFabHoverTimer = null;
        }
        const $panel = $modal.find(".js-pipeline-alertas-graficos-fab-panel");
        const $fab = $modal.find(".js-pipeline-alertas-graficos-fab");
        $panel.removeClass("is-open");
        $fab.attr("aria-expanded", "false");
        if (imediato) {
            $panel.attr("hidden", true);
            return;
        }
        window.setTimeout(function () {
            if (!$panel.hasClass("is-open")) {
                $panel.attr("hidden", true);
            }
        }, 240);
    }

    function abrirPainelFabGraficos($modal) {
        if (graficosFabHoverTimer) {
            window.clearTimeout(graficosFabHoverTimer);
            graficosFabHoverTimer = null;
        }
        const $wrap = $modal.find(".js-pipeline-alertas-graficos-fab-wrap");
        if ($wrap.is("[hidden]") || !$wrap.hasClass("is-visible")) {
            return;
        }
        const $panel = $modal.find(".js-pipeline-alertas-graficos-fab-panel");
        $panel.removeAttr("hidden");
        window.requestAnimationFrame(function () {
            $panel.addClass("is-open");
            $modal
                .find(".js-pipeline-alertas-graficos-fab")
                .attr("aria-expanded", "true");
        });
    }

    function mostrarFabGraficosChat($wrap) {
        if (graficosFabHideTimer) {
            window.clearTimeout(graficosFabHideTimer);
            graficosFabHideTimer = null;
        }
        $wrap.data("fabShouldShow", true);
        $wrap.removeAttr("hidden");
        window.requestAnimationFrame(function () {
            if ($wrap.data("fabShouldShow")) {
                $wrap.addClass("is-visible");
            }
        });
    }

    function ocultarFabGraficosChat($modal, $wrap) {
        $wrap.data("fabShouldShow", false);
        fecharPainelFabGraficos($modal, true);
        $wrap.removeClass("is-visible");
        if (graficosFabHideTimer) {
            window.clearTimeout(graficosFabHideTimer);
        }
        graficosFabHideTimer = window.setTimeout(function () {
            graficosFabHideTimer = null;
            if (!$wrap.data("fabShouldShow")) {
                $wrap.attr("hidden", true);
            }
        }, 280);
    }

    function bannerGraficosVisivelNaArea($messages, $banner) {
        const messagesEl = $messages.get(0);
        const bannerEl = $banner.get(0);
        if (!messagesEl || !bannerEl) {
            return false;
        }
        const msgRect = messagesEl.getBoundingClientRect();
        const bannerRect = bannerEl.getBoundingClientRect();
        const overlap =
            Math.min(bannerRect.bottom, msgRect.bottom) -
            Math.max(bannerRect.top, msgRect.top);
        return overlap > 12;
    }

    function chatEstaBusy($modal) {
        return $modal.find(".js-alerta-vazao-chat-form").hasClass("is-busy");
    }

    function sincronizarFabGraficosChat($modal) {
        const $banner = $modal.find(".js-pipeline-alertas-graficos-banner").first();
        const $messages = $modal.find(".js-alerta-vazao-chat-messages");
        const $wrap = garantirFabGraficosChat($modal);
        if (!$wrap.length || !$banner.length || !$messages.length) {
            return;
        }

        const messagesEl = $messages.get(0);
        const scrollTop = messagesEl ? messagesEl.scrollTop || 0 : 0;
        const noTopo = scrollTop <= 16;
        const bannerAtivo =
            $banner.attr("hidden") == null &&
            $banner.attr("aria-hidden") !== "true";

        // No topo, ou com o balão ainda à vista, o ícone nunca aparece.
        if (
            !bannerAtivo ||
            chatEstaBusy($modal) ||
            noTopo ||
            bannerGraficosVisivelNaArea($messages, $banner)
        ) {
            ocultarFabGraficosChat($modal, $wrap);
            return;
        }

        mostrarFabGraficosChat($wrap);
    }

    function bindScrollFabGraficosChat($modal) {
        const $messages = $modal.find(".js-alerta-vazao-chat-messages");
        if (!$messages.length) {
            return;
        }
        $messages.off("scroll.pipelineAlertasGraficosFab");
        $messages.on("scroll.pipelineAlertasGraficosFab", function () {
            sincronizarFabGraficosChat($modal);
        });
    }

    function metricaGraficosChatAtual() {
        const metrica = estadoChat.metrica || null;
        if (metrica && METRICAS_COM_GRAFICOS[metrica]) {
            return metrica;
        }
        if (estadoChat.origem === "livre" && estadoChat.temRespostaAssistente) {
            return "vazao_pipeline";
        }
        return null;
    }

    function podeExibirBannerGraficosChat() {
        if (modoListaArquivadas || estadoChat.aguardandoAnaliseConversas) {
            return false;
        }
        const metrica = metricaGraficosChatAtual();
        if (!metrica) {
            return false;
        }
        if (estadoChat.origem === "livre") {
            return !!estadoChat.temRespostaAssistente;
        }
        return true;
    }

    function atualizarBannerGraficosChat($modal) {
        const metrica = metricaGraficosChatAtual();
        const $banner = garantirBannerGraficosEmMensagens($modal);
        const $messages = $modal.find(".js-alerta-vazao-chat-messages");
        const $wrap = garantirFabGraficosChat($modal);
        if (!$banner.length) {
            return;
        }
        const podeExibir = podeExibirBannerGraficosChat();
        if (podeExibir) {
            const label = labelMetricaGraficos(metrica);
            $banner
                .find(".js-pipeline-alertas-graficos-banner-metrica")
                .text(label);
            $wrap.find(".js-pipeline-alertas-graficos-fab-metrica").text(label);
            $banner.removeAttr("hidden").attr("aria-hidden", "false");
            $messages.addClass("has-graficos-banner");
            sincronizarFabGraficosChat($modal);
            return;
        }
        $banner.attr("hidden", true).attr("aria-hidden", "true");
        $messages.removeClass("has-graficos-banner");
        ocultarFabGraficosChat($modal, $wrap);
    }

    function garantirModalGraficosChat() {
        let $modal = $("#modalPipelineAlertasGraficos");
        if ($modal.length) {
            return $modal;
        }

        $("body").append(`
            <div class="modal fade pipeline-alertas-graficos-modal-root" id="modalPipelineAlertasGraficos" tabindex="-1" role="dialog" aria-labelledby="modalPipelineAlertasGraficosLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered pipeline-alertas-graficos-dialog" role="document">
                    <div class="modal-content pipeline-alertas-graficos-modal">
                        <div class="modal-header">
                            <div class="pipeline-alertas-graficos-modal__heading">
                                <p class="pipeline-alertas-graficos-modal__eyebrow">Indicadores padrão</p>
                                <h5 class="modal-title" id="modalPipelineAlertasGraficosLabel">Gráficos da análise</h5>
                                <p class="pipeline-alertas-graficos-modal__subtitulo js-pipeline-alertas-graficos-modal-subtitulo"></p>
                            </div>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Fechar">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="pipeline-alertas-graficos-modal__body js-pipeline-alertas-graficos-modal-body"></div>
                        </div>
                    </div>
                </div>
            </div>
        `);

        $modal = $("#modalPipelineAlertasGraficos");
        $modal.on("show.bs.modal", function () {
            $("#modalPipelineAlertasChat .pipeline-alertas-chat-modal").addClass(
                "is-dimmed",
            );
            window.setTimeout(function () {
                $(".modal-backdrop")
                    .last()
                    .addClass("pipeline-alertas-graficos-backdrop");
            }, 0);
        });
        $modal.on("shown.bs.modal", function () {
            $(".modal-backdrop")
                .last()
                .addClass("pipeline-alertas-graficos-backdrop");
            const pending = $modal.data("graficosPendingPayload");
            const pendingSeq = $modal.data("graficosPendingSeq");
            const requestSeq = $modal.data("graficosRequestSeq");
            if (pending && pendingSeq === requestSeq) {
                $modal.removeData("graficosPendingPayload");
                $modal.removeData("graficosPendingSeq");
                renderGraficosEm(
                    $modal.find(".js-pipeline-alertas-graficos-modal-body"),
                    pending,
                );
            }
            redimensionarGraficosModal($modal);
        });
        $modal.on("hidden.bs.modal", function () {
            graficosModalRequestSeq += 1;
            $modal.removeData("graficosPendingPayload");
            $modal.removeData("graficosPendingSeq");
            $modal.removeData("graficosRequestSeq");
            $("#modalPipelineAlertasChat .pipeline-alertas-chat-modal").removeClass(
                "is-dimmed",
            );
            destruirApexEm($modal.find(".js-pipeline-alertas-graficos-modal-body"));
            $modal.find(".js-pipeline-alertas-graficos-modal-body").empty();
        });

        return $modal;
    }

    function redimensionarGraficosModal($grafModal) {
        const lista =
            $grafModal.find(".js-pipeline-alertas-graficos-modal-body").data("apexCharts") ||
            [];
        lista.forEach(function (chart) {
            try {
                if (chart && typeof chart.resize === "function") {
                    chart.resize();
                }
            } catch (e) {
                // ignore
            }
        });
    }

    function aplicarPayloadGraficosModal($grafModal, payload, requestSeq) {
        if ($grafModal.data("graficosRequestSeq") !== requestSeq) {
            return;
        }

        const $body = $grafModal.find(".js-pipeline-alertas-graficos-modal-body");
        $grafModal
            .find(".js-pipeline-alertas-graficos-modal-subtitulo")
            .text(montarSubtituloModalGraficos(payload));
        if ($grafModal.hasClass("show")) {
            $grafModal.removeData("graficosPendingPayload");
            $grafModal.removeData("graficosPendingSeq");
            renderGraficosEm($body, payload);
            window.requestAnimationFrame(function () {
                redimensionarGraficosModal($grafModal);
            });
            return;
        }

        // Bootstrap 4 só aplica .show após o backdrop; a API pode voltar antes.
        $grafModal.data("graficosPendingPayload", payload);
        $grafModal.data("graficosPendingSeq", requestSeq);
    }

    function abrirModalGraficosChat() {
        const metrica = metricaGraficosChatAtual();
        if (!metrica || !METRICAS_COM_GRAFICOS[metrica] || !graficosUrl) {
            return;
        }

        const $grafModal = garantirModalGraficosChat();
        const $body = $grafModal.find(".js-pipeline-alertas-graficos-modal-body");
        const label = labelMetricaGraficos(metrica);
        const requestSeq = ++graficosModalRequestSeq;
        $grafModal.data("graficosRequestSeq", requestSeq);
        $grafModal.removeData("graficosPendingPayload");
        $grafModal.removeData("graficosPendingSeq");
        $grafModal
            .find("#modalPipelineAlertasGraficosLabel")
            .text("Gráficos · " + label);
        $grafModal
            .find(".js-pipeline-alertas-graficos-modal-subtitulo")
            .text("Visualização padrão do sistema para a métrica desta conversa.");
        $body.html(htmlSkeletonGraficos());
        $grafModal.modal("show");

        const params = { metrica: metrica };
        if (estadoChat.conversaId) {
            params.conversa_id = estadoChat.conversaId;
        } else {
            params.modo_analise = estadoChat.modoAnalise || "atual";
            if (params.modo_analise === "comparativo") {
                params.data_inicio = estadoChat.dataInicio;
                params.data_fim = estadoChat.dataFim;
            }
        }

        buscarGraficos(params)
            .done(function (payload) {
                aplicarPayloadGraficosModal($grafModal, payload, requestSeq);
            })
            .fail(function () {
                if ($grafModal.data("graficosRequestSeq") !== requestSeq) {
                    return;
                }
                $body.html(
                    '<div class="pipeline-alertas-graficos__erro">Não foi possível carregar os gráficos.</div>',
                );
            });
    }

    function htmlPaginaAlertasAtivos() {
        return `
            <div class="pipeline-alertas-ativos js-pipeline-alertas-ativos-page" hidden aria-hidden="true">
                <header class="pipeline-alertas-ativos__header">
                    <div class="pipeline-alertas-ativos__heading">
                        <h3 class="pipeline-alertas-ativos__title">Alertas em curso</h3>
                        <p class="pipeline-alertas-ativos__subtitle">Avisos desta pipeline. Passe o mouse para ver mais detalhes.</p>
                    </div>
                    <div class="pipeline-alertas-ativos__tabs" role="tablist" aria-label="Filtro de alertas">
                        <button type="button" class="pipeline-alertas-ativos__tab js-pipeline-alertas-aba is-active" data-aba="pendentes" role="tab" aria-selected="true">
                            Pendentes
                        </button>
                        <button type="button" class="pipeline-alertas-ativos__tab js-pipeline-alertas-aba" data-aba="analisados" role="tab" aria-selected="false">
                            Analisados
                        </button>
                    </div>
                </header>
                <p class="pipeline-alertas-ativos__status js-pipeline-alertas-ativos-status" hidden role="alert"></p>
                <div class="pipeline-alertas-ativos__panels">
                    <div class="pipeline-alertas-ativos__panel js-pipeline-alertas-aba-panel" data-aba="pendentes">
                        <div class="pipeline-alertas-ativos__scroll">
                            <div class="pipeline-alertas-ativos__masonry js-pipeline-alertas-ativos-lista"></div>
                        </div>
                        <div class="pipeline-alertas-ativos__empty js-pipeline-alertas-ativos-empty" hidden>
                            Nenhum alerta pendente nesta pipeline no momento.
                        </div>
                    </div>
                    <div class="pipeline-alertas-ativos__panel js-pipeline-alertas-aba-panel" data-aba="analisados" hidden>
                        <div class="pipeline-alertas-ativos__scroll">
                            <div class="pipeline-alertas-ativos__masonry js-pipeline-alertas-analisados-lista"></div>
                        </div>
                        <div class="pipeline-alertas-ativos__empty js-pipeline-alertas-analisados-empty" hidden>
                            Nenhum alerta analisado nesta pipeline ainda.
                        </div>
                    </div>
                </div>
            </div>
        `;
    }

    function labelTendencia(tendencia) {
        if (tendencia === "melhorando") {
            return "Melhorando";
        }
        if (tendencia === "piorando") {
            return "Piorando";
        }
        return "Estável";
    }

    function labelBotaoPorQueTendencia(tendencia) {
        if (tendencia === "melhorando") {
            return "Por que está melhorando?";
        }
        if (tendencia === "piorando") {
            return "Por que está piorando?";
        }
        return "Por que está estável?";
    }

    function iconeTendencia(tendencia) {
        if (tendencia === "melhorando") {
            return "fa-arrow-up";
        }
        if (tendencia === "piorando") {
            return "fa-arrow-down";
        }
        return "fa-minus";
    }

    function formatarDataAnalise(iso) {
        if (!iso) {
            return "";
        }
        const data = new Date(iso);
        if (Number.isNaN(data.getTime())) {
            return "";
        }
        const pad = function (n) {
            return String(n).padStart(2, "0");
        };
        return (
            pad(data.getDate()) +
            "/" +
            pad(data.getMonth() + 1) +
            "/" +
            data.getFullYear() +
            " " +
            pad(data.getHours()) +
            ":" +
            pad(data.getMinutes())
        );
    }

    function sincronizarBotoesAbaAlertasAtivos($modal) {
        const aba = abaAlertasAtivos === "analisados" ? "analisados" : "pendentes";
        $modal.find(".js-pipeline-alertas-aba").each(function () {
            const ativa = $(this).attr("data-aba") === aba;
            $(this)
                .toggleClass("is-active", ativa)
                .attr("aria-selected", ativa ? "true" : "false");
        });
    }

    function garantirWrapperPaineisAlertas($modal) {
        const $page = $modal.find(".js-pipeline-alertas-ativos-page");
        const $paineis = $page.find(".js-pipeline-alertas-aba-panel");
        if (!$paineis.length) {
            return;
        }
        if (!$paineis.first().parent().hasClass("pipeline-alertas-ativos__panels")) {
            $paineis.wrapAll(
                '<div class="pipeline-alertas-ativos__panels"></div>',
            );
        }
    }

    function animarTrocaAbaAlertasAtivos($modal, abaAnterior, abaNova) {
        garantirWrapperPaineisAlertas($modal);
        const $paineis = $modal.find(".js-pipeline-alertas-aba-panel");
        const $saida = $paineis.filter('[data-aba="' + abaAnterior + '"]');
        const $entrada = $paineis.filter('[data-aba="' + abaNova + '"]');
        const deferred = $.Deferred();

        if (!$entrada.length) {
            return deferred.resolve().promise();
        }

        if (!$saida.length || $saida[0] === $entrada[0] || $saida.prop("hidden")) {
            $paineis
                .not($entrada)
                .prop("hidden", true)
                .removeClass(
                    "is-leaving is-leaving-reverse is-entering is-entering-reverse",
                );
            $entrada
                .prop("hidden", false)
                .removeClass(
                    "is-leaving is-leaving-reverse is-entering is-entering-reverse",
                );
            return deferred.resolve().promise();
        }

        const indoParaAnalisados = abaNova === "analisados";
        const classeSaida = indoParaAnalisados
            ? "is-leaving"
            : "is-leaving-reverse";
        const classeEntrada = indoParaAnalisados
            ? "is-entering"
            : "is-entering-reverse";

        $saida
            .removeClass(
                "is-leaving is-leaving-reverse is-entering is-entering-reverse",
            )
            .addClass(classeSaida);

        window.setTimeout(function () {
            $saida
                .prop("hidden", true)
                .removeClass(classeSaida);
            $entrada
                .prop("hidden", false)
                .removeClass(
                    "is-leaving is-leaving-reverse is-entering is-entering-reverse",
                )
                .addClass(classeEntrada);

            window.requestAnimationFrame(function () {
                window.requestAnimationFrame(function () {
                    $entrada.removeClass(classeEntrada);
                });
            });

            window.setTimeout(function () {
                deferred.resolve();
            }, 240);
        }, 180);

        return deferred.promise();
    }

    function sincronizarAbaAlertasAtivos($modal) {
        sincronizarBotoesAbaAlertasAtivos($modal);
        garantirWrapperPaineisAlertas($modal);
        const aba = abaAlertasAtivos === "analisados" ? "analisados" : "pendentes";
        $modal.find(".js-pipeline-alertas-aba-panel").each(function () {
            const ativa = $(this).attr("data-aba") === aba;
            $(this)
                .prop("hidden", !ativa)
                .removeClass(
                    "is-leaving is-leaving-reverse is-entering is-entering-reverse",
                );
        });
    }

    function selecionarAbaAlertasAtivos($modal, aba, forcarRefresh) {
        const abaNova = aba === "analisados" ? "analisados" : "pendentes";
        const abaAnterior = abaAlertasAtivos === "analisados" ? "analisados" : "pendentes";

        if (abaNova === abaAnterior) {
            sincronizarBotoesAbaAlertasAtivos($modal);
            if (abaNova === "analisados") {
                return carregarERenderizarAlertasAnalisados($modal, !!forcarRefresh);
            }
            return carregarERenderizarAlertasAtivos($modal, !!forcarRefresh);
        }

        abaAlertasAtivos = abaNova;
        sincronizarBotoesAbaAlertasAtivos($modal);

        return animarTrocaAbaAlertasAtivos($modal, abaAnterior, abaNova).then(
            function () {
                if (abaNova === "analisados") {
                    return carregarERenderizarAlertasAnalisados(
                        $modal,
                        !!forcarRefresh,
                    );
                }
                return carregarERenderizarAlertasAtivos($modal, !!forcarRefresh);
            },
        );
    }

    function quantidadeColunasAlertasAtivos($lista) {
        const largura =
            ($lista && $lista.outerWidth()) ||
            ($lista &&
                $lista.closest(".pipeline-alertas-ativos").outerWidth()) ||
            window.innerWidth ||
            0;

        return largura >= 900 ? 3 : 2;
    }

    function prepararColunasAlertasAtivos($lista) {
        const quantidade = quantidadeColunasAlertasAtivos($lista);
        const colunas = [];

        $lista.empty();
        for (let indice = 0; indice < quantidade; indice++) {
            const $coluna = $(
                '<div class="pipeline-alertas-ativos__column"></div>',
            );
            $lista.append($coluna);
            colunas.push($coluna);
        }

        return colunas;
    }

    function anexarCardNaColunaAlertas(colunas, $card, indice) {
        if (!colunas.length) {
            return;
        }
        colunas[indice % colunas.length].append($card);
    }

    function renderAlertasAtivosPage($modal, alertas, payloadBase) {
        const $lista = $modal.find(".js-pipeline-alertas-ativos-lista");
        const $empty = $modal.find(".js-pipeline-alertas-ativos-empty");
        $lista.empty();

        if (!alertas.length) {
            $lista.attr("hidden", true);
            $empty.removeAttr("hidden");
            return;
        }

        $empty.attr("hidden", true);
        $lista.removeAttr("hidden");
        const colunas = prepararColunasAlertasAtivos($lista);

        alertas.forEach(function (alerta, indice) {
            const metaParts = Array.isArray(alerta.meta) ? alerta.meta : [];
            const tamanho = (indice % 3) + 1;
            const $card = $(`
                <article class="pipeline-alertas-ativos__card pipeline-alertas-ativos__card--size-${tamanho} js-pipeline-alertas-ativo-card" tabindex="0">
                    <div class="pipeline-alertas-ativos__card-badges js-pipeline-alertas-categoria-wrap" hidden>
                        <span class="pipeline-alertas-categoria-badge js-pipeline-alertas-categoria-badge" hidden></span>
                    </div>
                    <div class="pipeline-alertas-ativos__card-eyebrow js-pipeline-alertas-ativo-eyebrow"></div>
                    <div class="pipeline-alertas-ativos__card-label js-pipeline-alertas-ativo-label"></div>
                    <h3 class="pipeline-alertas-ativos__card-title js-pipeline-alertas-ativo-titulo"></h3>
                    <p class="pipeline-alertas-ativos__card-subtitle js-pipeline-alertas-ativo-subtitulo"></p>
                    <div class="pipeline-alertas-ativos__card-meta js-pipeline-alertas-ativo-meta"></div>
                    <div class="pipeline-alertas-ativos__card-footer">
                        <div class="pipeline-alertas-ativos__card-actions">
                            <button type="button" class="pipeline-alertas-ativos__card-cta js-pipeline-alertas-ativo-cta">
                                Entender o que está acontecendo
                            </button>
                            <button type="button" class="pipeline-alertas-ativos__card-cta pipeline-alertas-ativos__card-cta--secondary js-pipeline-alertas-ativo-analisado">
                                Analisado
                            </button>
                        </div>
                    </div>
                </article>
            `);

            aplicarBadgeCategoria(
                $card,
                (payloadBase && payloadBase.tipo) || "",
                alerta.categoria,
                ".js-pipeline-alertas-categoria-badge",
            );
            $card.find(".js-pipeline-alertas-ativo-eyebrow").text(
                alerta.eyebrow || "Atenção à operação",
            );
            $card.find(".js-pipeline-alertas-ativo-label").text(alerta.label || "Aviso");
            $card.find(".js-pipeline-alertas-ativo-titulo").text(alerta.titulo || "");
            const $subtitulo = $card.find(".js-pipeline-alertas-ativo-subtitulo");
            if (alerta.subtitulo) {
                $subtitulo.text(alerta.subtitulo);
            } else {
                $subtitulo.remove();
            }
            const $meta = $card.find(".js-pipeline-alertas-ativo-meta");
            if (metaParts.length) {
                $meta.text(metaParts.join(" · "));
            } else {
                $meta.remove();
            }
            if (alerta.cta_habilitado === false) {
                $card.find(".js-pipeline-alertas-ativo-cta").remove();
            }

            $card.data(
                "alertaPayload",
                Object.assign({}, payloadBase || {}, alerta),
            );
            anexarCardNaColunaAlertas(colunas, $card, indice);
        });
    }

    function garantirModalTendenciaAnalise() {
        let $modal = $("#modalPipelineAlertasTendencia");
        if ($modal.length) {
            return $modal;
        }

        $("body").append(`
            <div class="modal fade alerta-vazao-modal-root pipeline-alertas-tendencia-modal-root" id="modalPipelineAlertasTendencia" tabindex="-1" role="dialog" aria-labelledby="modalPipelineAlertasTendenciaLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered pipeline-alertas-tendencia-dialog" role="document">
                    <div class="modal-content alerta-vazao-modal pipeline-alertas-tendencia-modal">
                        <div class="modal-header">
                            <div class="alerta-vazao-modal__heading">
                                <h5 class="modal-title" id="modalPipelineAlertasTendenciaLabel"></h5>
                                <div class="alerta-vazao-modal__periodo js-pipeline-alertas-tendencia-periodo"></div>
                            </div>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Fechar">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="alerta-vazao-modal__intro js-pipeline-alertas-tendencia-intro"></div>
                            <div class="alerta-vazao-modal__resumo js-pipeline-alertas-tendencia-resumo"></div>
                            <div class="alerta-vazao-modal__section">
                                <div class="alerta-vazao-modal__section-title">
                                    <i class="fas fa-list-ul" aria-hidden="true"></i>
                                    <span class="js-pipeline-alertas-tendencia-pontos-title">O que mudou</span>
                                </div>
                                <table class="table alerta-vazao-modal__tabela js-pipeline-alertas-tendencia-tabela">
                                    <thead>
                                        <tr>
                                            <th scope="col">Indicador</th>
                                            <th scope="col">Valor</th>
                                        </tr>
                                    </thead>
                                    <tbody></tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `);

        $modal = $("#modalPipelineAlertasTendencia");
        $modal.on("show.bs.modal", function () {
            $("#modalPipelineAlertasChat .pipeline-alertas-chat-modal").addClass(
                "is-dimmed",
            );
            window.setTimeout(function () {
                $(".modal-backdrop")
                    .last()
                    .addClass(
                        "alerta-vazao-modal-backdrop pipeline-alertas-tendencia-backdrop",
                    );
            }, 0);
        });
        $modal.on("hidden.bs.modal", function () {
            $("#modalPipelineAlertasChat .pipeline-alertas-chat-modal").removeClass(
                "is-dimmed",
            );
        });

        return $modal;
    }

    function abrirModalTendenciaAnalise(analise) {
        if (!analise) {
            return;
        }

        const $existente = $("#modalPipelineAlertasTendencia");
        if (
            $existente.length &&
            !$existente.find(".js-pipeline-alertas-tendencia-tabela").length
        ) {
            $existente.remove();
        }

        const tendencia = analise.tendencia || "estavel";
        const comparativo = analise.comparativo || {};
        const $tendModal = garantirModalTendenciaAnalise();
        const titulo =
            tendencia === "melhorando"
                ? "Por que está melhorando?"
                : tendencia === "piorando"
                  ? "Por que está piorando?"
                  : "Por que está estável?";
        const rotulo = comparativo.rotulo || analise.label || "Indicador";
        const dataAnalise = formatarDataAnalise(analise.analisado_em);
        const nomeAnalista =
            analise.analisado_por && analise.analisado_por.name
                ? analise.analisado_por.name
                : "";
        const classeAtual =
            tendencia === "melhorando"
                ? "alerta-vazao-modal__stat--ganho"
                : tendencia === "piorando"
                  ? "alerta-vazao-modal__stat--perda"
                  : "alerta-vazao-modal__stat--neutro";
        const iconeAtual =
            tendencia === "melhorando"
                ? "fa-arrow-up"
                : tendencia === "piorando"
                  ? "fa-arrow-down"
                  : "fa-minus";
        const iconeVariacao =
            tendencia === "melhorando"
                ? "fa-check-circle"
                : tendencia === "piorando"
                  ? "fa-exclamation-circle"
                  : "fa-minus";

        $tendModal.find("#modalPipelineAlertasTendenciaLabel").text(titulo);
        $tendModal
            .find(".js-pipeline-alertas-tendencia-periodo")
            .text(
                (analise.label || "Alerta") +
                    (dataAnalise ? " · Analisado em " + dataAnalise : "") +
                    (nomeAnalista ? " · " + nomeAnalista : ""),
            );
        $tendModal
            .find(".js-pipeline-alertas-tendencia-intro")
            .text(analise.titulo || "Comparativo entre o momento da análise e o indicador atual.");
        $tendModal
            .find(".js-pipeline-alertas-tendencia-pontos-title")
            .text(rotulo);

        const $resumo = $tendModal.find(".js-pipeline-alertas-tendencia-resumo");
        $resumo.empty().append(`
            <div class="alerta-vazao-modal__stat alerta-vazao-modal__stat--neutro">
                <div class="alerta-vazao-modal__stat-icon"><i class="fas fa-history" aria-hidden="true"></i></div>
                <div class="alerta-vazao-modal__stat-body">
                    <span>Na análise</span>
                    <strong class="js-pipeline-alertas-tendencia-ref"></strong>
                </div>
            </div>
            <div class="alerta-vazao-modal__stat ${classeAtual}">
                <div class="alerta-vazao-modal__stat-icon"><i class="fas ${iconeAtual}" aria-hidden="true"></i></div>
                <div class="alerta-vazao-modal__stat-body">
                    <span>Agora</span>
                    <strong class="js-pipeline-alertas-tendencia-atual"></strong>
                </div>
            </div>
            <div class="alerta-vazao-modal__stat ${classeAtual}">
                <div class="alerta-vazao-modal__stat-icon"><i class="fas ${iconeVariacao}" aria-hidden="true"></i></div>
                <div class="alerta-vazao-modal__stat-body">
                    <span>Variação</span>
                    <strong class="js-pipeline-alertas-tendencia-delta"></strong>
                </div>
            </div>
        `);
        $resumo
            .find(".js-pipeline-alertas-tendencia-ref")
            .text(comparativo.valor_referencia_formatado || "—");
        $resumo
            .find(".js-pipeline-alertas-tendencia-atual")
            .text(comparativo.valor_atual_formatado || "—");
        $resumo
            .find(".js-pipeline-alertas-tendencia-delta")
            .text(comparativo.delta_percentual_formatado || labelTendencia(tendencia));

        const linhas = [
            {
                indicador: "Na análise",
                valor: comparativo.valor_referencia_formatado || "—",
            },
            {
                indicador: "Agora",
                valor: comparativo.valor_atual_formatado || "—",
            },
            {
                indicador: "Diferença",
                valor: comparativo.delta_formatado || "—",
            },
            {
                indicador: "Percentual",
                valor: comparativo.delta_percentual_formatado || "—",
            },
            {
                indicador: "Situação",
                valor: labelTendencia(tendencia),
            },
        ];
        const $tbody = $tendModal.find(
            ".js-pipeline-alertas-tendencia-tabela tbody",
        );
        $tbody.empty();
        linhas.forEach(function (linha) {
            const $tr = $("<tr></tr>");
            $tr.append($("<td></td>").text(linha.indicador));
            $tr.append($("<td></td>").text(linha.valor));
            $tbody.append($tr);
        });

        $tendModal.modal({
            backdrop: true,
            keyboard: true,
            show: true,
        });
        window.setTimeout(function () {
            $(".modal-backdrop")
                .last()
                .addClass(
                    "alerta-vazao-modal-backdrop pipeline-alertas-tendencia-backdrop",
                );
        }, 0);
    }

    function renderAlertasAnalisadosPage($modal, analises, payloadBase) {
        const $lista = $modal.find(".js-pipeline-alertas-analisados-lista");
        const $empty = $modal.find(".js-pipeline-alertas-analisados-empty");
        $lista.empty();

        if (!analises.length) {
            $lista.attr("hidden", true);
            $empty.removeAttr("hidden");
            return;
        }

        $empty.attr("hidden", true);
        $lista.removeAttr("hidden");
        const colunas = prepararColunasAlertasAtivos($lista);

        analises.forEach(function (analise, indice) {
            const metaParts = Array.isArray(analise.meta) ? analise.meta : [];
            const tamanho = (indice % 3) + 1;
            const tendencia = analise.tendencia || "estavel";
            const dataAnalise = formatarDataAnalise(analise.analisado_em);
            const nomeAnalista =
                analise.analisado_por && analise.analisado_por.name
                    ? analise.analisado_por.name
                    : "";
            const comparativo = analise.comparativo || {};
            const $card = $(`
                <article class="pipeline-alertas-ativos__card pipeline-alertas-ativos__card--analisado pipeline-alertas-ativos__card--${tendencia} pipeline-alertas-ativos__card--size-${tamanho} js-pipeline-alertas-ativo-card" tabindex="0">
                    <div class="pipeline-alertas-ativos__card-badges">
                        <span class="pipeline-alertas-categoria-badge js-pipeline-alertas-categoria-badge" hidden></span>
                        <span class="pipeline-alertas-ativos__tendencia pipeline-alertas-ativos__tendencia--${tendencia} js-pipeline-alertas-tendencia"></span>
                        <span class="pipeline-alertas-ativos__delta-badge pipeline-alertas-ativos__delta-badge--${tendencia} js-pipeline-alertas-delta-badge" hidden></span>
                    </div>
                    <div class="pipeline-alertas-ativos__card-eyebrow js-pipeline-alertas-ativo-eyebrow"></div>
                    <div class="pipeline-alertas-ativos__card-label js-pipeline-alertas-ativo-label"></div>
                    <h3 class="pipeline-alertas-ativos__card-title js-pipeline-alertas-ativo-titulo"></h3>
                    <p class="pipeline-alertas-ativos__card-subtitle js-pipeline-alertas-ativo-subtitulo"></p>
                    <div class="pipeline-alertas-ativos__card-meta js-pipeline-alertas-ativo-meta"></div>
                    <div class="pipeline-alertas-ativos__card-analise js-pipeline-alertas-ativo-analise"></div>
                    <div class="pipeline-alertas-ativos__card-footer">
                        <div class="pipeline-alertas-ativos__card-actions">
                            <button type="button" class="pipeline-alertas-ativos__card-cta pipeline-alertas-ativos__card-cta--secondary js-pipeline-alertas-por-que-tendencia">
                            </button>
                            <button type="button" class="pipeline-alertas-ativos__card-cta js-pipeline-alertas-ativo-cta">
                                Entender o que está acontecendo
                            </button>
                        </div>
                    </div>
                </article>
            `);

            aplicarBadgeCategoria(
                $card,
                (payloadBase && payloadBase.tipo) || "",
                analise.categoria,
                ".js-pipeline-alertas-categoria-badge",
            );
            $card
                .find(".js-pipeline-alertas-tendencia")
                .html(
                    '<i class="fas ' +
                        iconeTendencia(tendencia) +
                        '" aria-hidden="true"></i> ' +
                        labelTendencia(tendencia),
                );
            const $deltaBadge = $card.find(".js-pipeline-alertas-delta-badge");
            if (comparativo.delta_percentual_formatado) {
                $deltaBadge
                    .text(comparativo.delta_percentual_formatado)
                    .removeAttr("hidden");
            } else {
                $deltaBadge.remove();
            }
            $card
                .find(".js-pipeline-alertas-por-que-tendencia")
                .text(labelBotaoPorQueTendencia(tendencia));
            $card.find(".js-pipeline-alertas-ativo-eyebrow").text(
                analise.eyebrow || "Atenção à operação",
            );
            $card.find(".js-pipeline-alertas-ativo-label").text(analise.label || "Aviso");
            $card.find(".js-pipeline-alertas-ativo-titulo").text(analise.titulo || "");
            const $subtitulo = $card.find(".js-pipeline-alertas-ativo-subtitulo");
            if (analise.subtitulo) {
                $subtitulo.text(analise.subtitulo);
            } else {
                $subtitulo.remove();
            }
            const $meta = $card.find(".js-pipeline-alertas-ativo-meta");
            if (metaParts.length) {
                $meta.text(metaParts.join(" · "));
            } else {
                $meta.remove();
            }

            const partesAnalise = [];
            if (dataAnalise) {
                partesAnalise.push("Analisado em " + dataAnalise);
            }
            if (nomeAnalista) {
                partesAnalise.push("por " + nomeAnalista);
            }
            const $analiseInfo = $card.find(".js-pipeline-alertas-ativo-analise");
            if (partesAnalise.length) {
                $analiseInfo.text(partesAnalise.join(" "));
            } else {
                $analiseInfo.remove();
            }
            if (analise.cta_habilitado === false) {
                $card.find(".js-pipeline-alertas-ativo-cta").remove();
            }

            $card.data(
                "alertaPayload",
                Object.assign({}, payloadBase || {}, analise, {
                    metrica: analise.metrica,
                }),
            );
            anexarCardNaColunaAlertas(colunas, $card, indice);
        });
    }

    function carregarERenderizarAlertasAtivos($modal, forcarRefresh) {
        function aplicarCache() {
            atualizarBotaoAlertasAtivos($modal);
            if (abaAlertasAtivos === "pendentes") {
                renderAlertasAtivosPage(
                    $modal,
                    cacheAlertasAtivos.alertas,
                    cacheAlertasAtivos.payload || {},
                );
            }
        }

        if (!forcarRefresh && cacheAlertasAtivos.payload) {
            aplicarCache();
            return $.Deferred().resolve(cacheAlertasAtivos).promise();
        }

        return $.ajax({
            url: alertaUrl,
            method: "GET",
            data: { pipeline_id: pipelineId },
            dataType: "json",
        })
            .done(function (payload) {
                cacheAlertasAtivos = {
                    payload: payload || null,
                    alertas: normalizarAlertas(payload || {}),
                    autorizado: payload ? payload.autorizado !== false : false,
                };
                if (payload && payload.autorizado === false) {
                    cacheAlertasAtivos.autorizado = false;
                    cacheAlertasAtivos.alertas = [];
                }
                analiseConversasHabilitada = !!(payload && payload.analise_conversas);
                aplicarCache();
            })
            .fail(function () {
                cacheAlertasAtivos = {
                    payload: null,
                    alertas: [],
                    autorizado: false,
                };
                aplicarCache();
            });
    }

    function carregarERenderizarAlertasAnalisados($modal, forcarRefresh) {
        function aplicarCache() {
            renderAlertasAnalisadosPage(
                $modal,
                cacheAlertasAnalisados.analises,
                cacheAlertasAtivos.payload || { pipeline_id: pipelineId },
            );
        }

        if (!analisesUrl) {
            cacheAlertasAnalisados = { carregado: true, analises: [] };
            aplicarCache();
            return $.Deferred().resolve(cacheAlertasAnalisados).promise();
        }

        if (!forcarRefresh && cacheAlertasAnalisados.carregado) {
            aplicarCache();
            return $.Deferred().resolve(cacheAlertasAnalisados).promise();
        }

        return $.ajax({
            url: analisesUrl,
            method: "GET",
            data: { pipeline_id: pipelineId },
            dataType: "json",
        })
            .done(function (payload) {
                cacheAlertasAnalisados = {
                    carregado: true,
                    analises: Array.isArray(payload && payload.analises)
                        ? payload.analises
                        : [],
                };
                aplicarCache();
            })
            .fail(function () {
                cacheAlertasAnalisados = { carregado: true, analises: [] };
                aplicarCache();
            });
    }

    function mostrarStatusAlertasAtivos($modal, msg) {
        const $status = $modal.find(".js-pipeline-alertas-ativos-status");
        if (!$status.length) {
            return;
        }
        if (!msg) {
            $status.text("").removeClass("is-error").attr("hidden", true);
            return;
        }
        $status.text(msg).addClass("is-error").removeAttr("hidden");
    }

    function marcarAlertaComoAnalisado($modal, alertaPayload, $botao) {
        if (!analisesUrl || !alertaPayload) {
            return;
        }
        const metrica = alertaPayload.metrica;
        const assinatura = alertaPayload.assinatura;
        if (!metrica || !assinatura) {
            return;
        }
        fecharBalaoGraficosHover();
        if ($botao && $botao.length) {
            $botao.prop("disabled", true).addClass("is-busy");
        }

        $.ajax({
            url: analisesUrl,
            method: "POST",
            dataType: "json",
            headers: {
                Accept: "application/json",
                "X-CSRF-TOKEN": csrfToken(),
            },
            data: {
                pipeline_id: pipelineId,
                metrica: metrica,
                assinatura: assinatura,
            },
        })
            .done(function () {
                mostrarStatusAlertasAtivos($modal, "");
                cacheAlertasAtivos.alertas = cacheAlertasAtivos.alertas.filter(
                    function (alerta) {
                        return !(
                            alerta.metrica === metrica &&
                            alerta.assinatura === assinatura
                        );
                    },
                );
                if (cacheAlertasAtivos.payload) {
                    cacheAlertasAtivos.payload.alertas = cacheAlertasAtivos.alertas;
                    cacheAlertasAtivos.payload.show =
                        cacheAlertasAtivos.alertas.length > 0;
                }
                cacheAlertasAnalisados.carregado = false;
                atualizarBotaoAlertasAtivos($modal);
                renderAlertasAtivosPage(
                    $modal,
                    cacheAlertasAtivos.alertas,
                    cacheAlertasAtivos.payload || {},
                );
                carregarAlerta();
            })
            .fail(function (xhr) {
                const msg =
                    (xhr.responseJSON && xhr.responseJSON.message) ||
                    "Não foi possível marcar o alerta como analisado.";
                mostrarStatusAlertasAtivos($modal, msg);
                if ($botao && $botao.length) {
                    $botao.prop("disabled", false).removeClass("is-busy");
                }
            });
    }

    function iniciarConversaAlerta($modal, payload) {
        if (!mensagensUrl) {
            return;
        }

        mostrarViewModal($modal, "chat");
        fecharBalaoGraficosHover();

        const metricaAlerta = payload.metrica || "vazao_pipeline";
        estadoChat = estadoChatBase({
            origem: "alerta",
            rascunho: true,
            titulo: payload.titulo || "Nova análise",
            metrica: metricaAlerta,
        });
        fecharBalaoInfo($modal);
        limparThread($modal);
        setComposerVisivel($modal, true);
        atualizarBannerGraficosChat($modal);
        carregarListaConversas($modal, pipelineId, true);

        const $messages = $modal.find(".js-alerta-vazao-chat-messages");
        const inicioTyping = Date.now();
        setChatBusy($modal, true);
        const $typing = appendTyping($messages);

        $.ajax({
            url: mensagensUrl,
            method: "POST",
            dataType: "json",
            headers: { "X-CSRF-TOKEN": csrfToken() },
            data: {
                pipeline_id: pipelineId,
                iniciar_alerta: 1,
                origem: "alerta",
                metrica: metricaAlerta,
            },
        })
            .done(function (response) {
                const abertura = response.message || "";
                const baloes = Array.isArray(response.baloes) ? response.baloes : [];
                estadoChat = estadoChatBase({
                    origem: "alerta",
                    rascunho: true,
                    titulo: response.titulo || estadoChat.titulo,
                    mensagemAbertura: abertura,
                    baloesAbertura: baloes,
                    metrica: metricaAlerta,
                });
                aguardarPontinhosMinimos(inicioTyping, 3000, function () {
                    revelarRespostaAposPontinhos(
                        $typing,
                        $messages,
                        abertura,
                        baloes,
                        function () {
                            setChatBusy($modal, false);
                            carregarListaConversas($modal, pipelineId, true);
                            marcarItemAtivo($modal, null, true);
                        },
                    );
                });
            })
            .fail(function (xhr) {
                aguardarPontinhosMinimos(inicioTyping, 3000, function () {
                    $typing.remove();
                    const msg =
                        (xhr.responseJSON && xhr.responseJSON.message) ||
                        "Não foi possível iniciar a análise.";
                    $modal
                        .find(".js-alerta-vazao-chat-status")
                        .text(msg)
                        .addClass("is-error");
                    setChatBusy($modal, false);
                });
            });
    }

    function navegadorTranscreveFala() {
        if (falaNavegadorIndisponivel || navigator.brave) {
            return false;
        }

        return !!(window.SpeechRecognition || window.webkitSpeechRecognition);
    }

    function atualizarBotaoComposerAudio($modal) {
        const $input = $modal.find(".js-alerta-vazao-chat-input");
        const $btn = $modal.find(".js-alerta-vazao-chat-enviar");
        if (!$btn.length) {
            return;
        }
        if (ouvindoFalaNavegador) {
            $btn.removeClass("is-mic").attr("title", "Parar").text("Parar");
            return;
        }
        const temTexto = String($input.val() || "").trim() !== "";
        $btn.toggleClass("is-mic", !temTexto);
        if (temTexto) {
            $btn.attr("title", "Enviar").text("Enviar");
            return;
        }
        $btn.attr("title", navegadorTranscreveFala() ? "Falar" : "Gravar áudio").html(
            '<i class="fas fa-microphone" aria-hidden="true"></i>',
        );
    }

    function atualizarCampoFalaNavegador($modal, interim) {
        const $input = $modal.find(".js-alerta-vazao-chat-input");
        const texto = (textoBaseFalaCopiloto + textoConfirmadoFalaCopiloto + (interim || ""))
            .replace(/\s+/g, " ")
            .trim()
            .slice(0, 2000);
        $input.val(texto);
        ajustarAlturaChatInput($input);
        atualizarBotaoComposerAudio($modal);
    }

    function pararTranscricaoNavegadorCopiloto($modal) {
        ouvindoFalaNavegador = false;
        if (reconhecimentoFalaCopiloto) {
            try {
                reconhecimentoFalaCopiloto.stop();
            } catch (e) {
                // ignore
            }
        }
        if ($modal) {
            const $status = $modal.find(".js-alerta-vazao-chat-status");
            if (!$status.hasClass("is-error")) {
                $status.text("");
            }
            atualizarBotaoComposerAudio($modal);
        }
    }

    function garantirReconhecimentoFalaCopiloto() {
        if (reconhecimentoFalaCopiloto) {
            return reconhecimentoFalaCopiloto;
        }

        const ApiFala = window.SpeechRecognition || window.webkitSpeechRecognition;
        const recognition = new ApiFala();
        recognition.lang = "pt-BR";
        recognition.continuous = true;
        recognition.interimResults = true;

        recognition.onresult = function (event) {
            if (!$modalFalaCopiloto) {
                return;
            }
            let interim = "";
            for (let i = event.resultIndex; i < event.results.length; i++) {
                const trecho = event.results[i][0].transcript;
                if (event.results[i].isFinal) {
                    textoConfirmadoFalaCopiloto += trecho;
                } else {
                    interim += trecho;
                }
            }
            atualizarCampoFalaNavegador($modalFalaCopiloto, interim);
        };

        recognition.onerror = function (event) {
            if (event.error === "aborted" || event.error === "no-speech") {
                return;
            }
            ouvindoFalaNavegador = false;
            if (!$modalFalaCopiloto) {
                return;
            }
            if (event.error === "not-allowed") {
                $modalFalaCopiloto
                    .find(".js-alerta-vazao-chat-status")
                    .text("Permissão do microfone negada.")
                    .addClass("is-error");
                atualizarBotaoComposerAudio($modalFalaCopiloto);
                return;
            }
            if (event.error === "network") {
                falaNavegadorIndisponivel = true;
                const texto = String(
                    $modalFalaCopiloto.find(".js-alerta-vazao-chat-input").val() || "",
                ).trim();
                $modalFalaCopiloto
                    .find(".js-alerta-vazao-chat-status")
                    .text("")
                    .removeClass("is-error");
                atualizarBotaoComposerAudio($modalFalaCopiloto);
                if (!texto) {
                    iniciarGravacaoAudioCopiloto($modalFalaCopiloto);
                }
                return;
            }
            $modalFalaCopiloto
                .find(".js-alerta-vazao-chat-status")
                .text("Não foi possível transcrever a fala.")
                .addClass("is-error");
            atualizarBotaoComposerAudio($modalFalaCopiloto);
        };

        recognition.onend = function () {
            if (ouvindoFalaNavegador) {
                try {
                    recognition.start();
                } catch (e) {
                    ouvindoFalaNavegador = false;
                }
            }
            if (!ouvindoFalaNavegador && $modalFalaCopiloto) {
                atualizarBotaoComposerAudio($modalFalaCopiloto);
            }
        };

        reconhecimentoFalaCopiloto = recognition;

        return recognition;
    }

    function iniciarTranscricaoNavegadorCopiloto($modal) {
        if (
            ouvindoFalaNavegador ||
            gravandoAudioCopiloto ||
            processandoGravacaoAudioCopiloto ||
            $modal.find(".js-alerta-vazao-chat-form").hasClass("is-busy")
        ) {
            return;
        }
        const recognition = garantirReconhecimentoFalaCopiloto();
        $modalFalaCopiloto = $modal;
        textoBaseFalaCopiloto = String($modal.find(".js-alerta-vazao-chat-input").val() || "");
        textoConfirmadoFalaCopiloto = "";
        ouvindoFalaNavegador = true;
        $modal
            .find(".js-alerta-vazao-chat-status")
            .text("Ouvindo... o texto aparece no campo.")
            .removeClass("is-error");
        atualizarBotaoComposerAudio($modal);
        try {
            recognition.start();
        } catch (e) {
            ouvindoFalaNavegador = false;
            falaNavegadorIndisponivel = true;
            atualizarBotaoComposerAudio($modal);
            iniciarGravacaoAudioCopiloto($modal);
        }
    }

    function iniciarEntradaPorVozCopiloto($modal) {
        if (ouvindoFalaNavegador) {
            pararTranscricaoNavegadorCopiloto($modal);
            return;
        }
        if (navegadorTranscreveFala()) {
            iniciarTranscricaoNavegadorCopiloto($modal);
            return;
        }
        iniciarGravacaoAudioCopiloto($modal);
    }

    function setComposerGravando($modal, gravando) {
        $modal
            .find(".js-alerta-vazao-chat-composer-normal")
            .toggle(!gravando);
        $modal
            .find(".js-alerta-vazao-chat-composer-audio")
            .prop("hidden", !gravando);
    }

    function encerrarContadorGravacaoAudio() {
        if (intervaloDuracaoGravacaoAudio) {
            window.clearInterval(intervaloDuracaoGravacaoAudio);
            intervaloDuracaoGravacaoAudio = null;
        }
    }

    function cancelarGravacaoAudioCopiloto($modal) {
        if (ouvindoFalaNavegador) {
            pararTranscricaoNavegadorCopiloto($modal);
        }
        if (processandoGravacaoAudioCopiloto) {
            return;
        }
        if (gravadorAudioCopiloto) {
            try {
                gravadorAudioCopiloto.stop();
            } catch (e) {
                // ignore
            }
            gravadorAudioCopiloto = null;
        }
        encerrarContadorGravacaoAudio();
        gravandoAudioCopiloto = false;
        gravacaoAudioIniciadaEm = null;
        processandoGravacaoAudioCopiloto = false;
        if ($modal) {
            $modal.find(".js-alerta-vazao-chat-audio-segundos").text("0");
            setComposerGravando($modal, false);
            atualizarBotaoComposerAudio($modal);
        }
    }

    function iniciarGravacaoAudioCopiloto($modal) {
        if (
            gravandoAudioCopiloto ||
            processandoGravacaoAudioCopiloto ||
            $modal.find(".js-alerta-vazao-chat-form").hasClass("is-busy")
        ) {
            return;
        }
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
            $modal
                .find(".js-alerta-vazao-chat-status")
                .text("Seu navegador não suporta gravação de áudio.")
                .addClass("is-error");
            return;
        }
        const MicRecorder = require("mic-recorder-to-mp3");
        const gravador = new MicRecorder({ bitRate: 128 });
        gravador
            .start()
            .then(function () {
                gravadorAudioCopiloto = gravador;
                gravandoAudioCopiloto = true;
                gravacaoAudioIniciadaEm = Date.now();
                $modal.find(".js-alerta-vazao-chat-audio-segundos").text("0");
                setComposerGravando($modal, true);
                encerrarContadorGravacaoAudio();
                intervaloDuracaoGravacaoAudio = window.setInterval(function () {
                    if (!gravacaoAudioIniciadaEm) {
                        return;
                    }
                    const segundos = Math.floor(
                        (Date.now() - gravacaoAudioIniciadaEm) / 1000,
                    );
                    $modal
                        .find(".js-alerta-vazao-chat-audio-segundos")
                        .text(String(segundos));
                }, 200);
            })
            .catch(function () {
                $modal
                    .find(".js-alerta-vazao-chat-status")
                    .text("Não foi possível acessar o microfone.")
                    .addClass("is-error");
            });
    }

    function enviarAudioGravadoCopiloto($modal) {
        if (!gravadorAudioCopiloto || processandoGravacaoAudioCopiloto) {
            return;
        }
        const duracao = gravacaoAudioIniciadaEm
            ? Date.now() - gravacaoAudioIniciadaEm
            : 0;
        if (duracao < 1000) {
            $modal
                .find(".js-alerta-vazao-chat-status")
                .text("Grave por pelo menos 1 segundo antes de enviar.")
                .addClass("is-error");
            return;
        }
        processandoGravacaoAudioCopiloto = true;
        const gravador = gravadorAudioCopiloto;
        gravadorAudioCopiloto = null;
        encerrarContadorGravacaoAudio();
        gravador
            .stop()
            .getMp3()
            .then(function (resultado) {
                const buffer = resultado[0];
                const blob = resultado[1];
                gravandoAudioCopiloto = false;
                setComposerGravando($modal, false);
                const tamanhoBuffer = Array.isArray(buffer) ? buffer.length : 0;
                const tamanhoBlob = blob && blob.size ? blob.size : 0;
                if (!tamanhoBuffer && tamanhoBlob === 0) {
                    processandoGravacaoAudioCopiloto = false;
                    atualizarBotaoComposerAudio($modal);
                    $modal
                        .find(".js-alerta-vazao-chat-status")
                        .text(
                            "Não foi possível gravar o áudio. Tente falar mais perto do microfone.",
                        )
                        .addClass("is-error");
                    return;
                }
                const arquivoAudio = new File(
                    buffer,
                    "audio-copiloto-" + Date.now() + ".mp3",
                    { type: "audio/mpeg", lastModified: Date.now() },
                );
                if (arquivoAudio.size < 1000) {
                    processandoGravacaoAudioCopiloto = false;
                    atualizarBotaoComposerAudio($modal);
                    $modal
                        .find(".js-alerta-vazao-chat-status")
                        .text("Áudio muito curto. Grave por mais tempo e tente novamente.")
                        .addClass("is-error");
                    return;
                }
                processandoGravacaoAudioCopiloto = false;
                enviarMensagemChat($modal, null, arquivoAudio);
            })
            .catch(function () {
                gravandoAudioCopiloto = false;
                processandoGravacaoAudioCopiloto = false;
                setComposerGravando($modal, false);
                atualizarBotaoComposerAudio($modal);
                $modal
                    .find(".js-alerta-vazao-chat-status")
                    .text("Erro ao finalizar a gravação de áudio.")
                    .addClass("is-error");
            });
    }

    function montarFormDataMensagem(data, arquivoAudio) {
        const formData = new FormData();
        Object.keys(data).forEach(function (key) {
            const valor = data[key];
            if (valor == null || valor === "") {
                return;
            }
            if (key === "baloes_abertura" && Array.isArray(valor)) {
                valor.forEach(function (item, i) {
                    Object.keys(item || {}).forEach(function (campo) {
                        if (item[campo] == null) {
                            return;
                        }
                        formData.append(
                            "baloes_abertura[" + i + "][" + campo + "]",
                            item[campo],
                        );
                    });
                });
                return;
            }
            formData.append(key, valor);
        });
        formData.append("audio", arquivoAudio);
        return formData;
    }

    function enviarMensagemChat($modal, textoOpcional, arquivoAudio) {
        if (!mensagensUrl) {
            return;
        }

        if ($modal.find(".js-alerta-vazao-chat-form").hasClass("is-busy")) {
            return;
        }

        const $input = $modal.find(".js-alerta-vazao-chat-input");
        const $messages = $modal.find(".js-alerta-vazao-chat-messages");
        const $status = $modal.find(".js-alerta-vazao-chat-status");
        const texto = String(
            textoOpcional != null ? textoOpcional : $input.val() || "",
        ).trim();

        if (!texto && !arquivoAudio) {
            return;
        }

        if (estadoChat.limiteMensagensAtingido) {
            sincronizarLimiteMensagensChat($modal, {
                limite_mensagens_atingido: true,
                limite_mensagens_usuario: estadoChat.limiteMensagensUsuario,
                mensagens_usuario: estadoChat.mensagensUsuario,
            });
            return;
        }

        $status.text("").removeClass("is-error");
        $messages
            .find(
                ".pipeline-alertas-chat__empty, .pipeline-alertas-chat__ready, .pipeline-alertas-modo",
            )
            .remove();
        $input.val("");
        ajustarAlturaChatInput($input);
        esconderSugestoesChat($modal);
        setChatBusy($modal, true);
        let blobUrlAudio = null;
        const $userBubble = arquivoAudio
            ? (function () {
                  blobUrlAudio = URL.createObjectURL(arquivoAudio);
                  return appendBubble(
                      $messages,
                      "user",
                      "Transcrevendo...",
                      false,
                      [],
                      blobUrlAudio,
                  );
              })()
            : appendBubble($messages, "user", texto, false);

        const inicioTyping = Date.now();
        const $typing = appendTyping($messages);

        const data = {
            pipeline_id: pipelineId,
            origem: estadoChat.origem || "livre",
        };
        if (texto) {
            data.message = texto;
        }
        if (estadoChat.conversaId) {
            data.conversa_id = estadoChat.conversaId;
        } else {
            data.modo_analise = estadoChat.modoAnalise || "atual";
            if (estadoChat.dataInicio && estadoChat.dataFim) {
                data.data_inicio = estadoChat.dataInicio;
                data.data_fim = estadoChat.dataFim;
            }
            if (estadoChat.incluirAnaliseConversas) {
                data.incluir_analise_conversas = 1;
            }
            if (estadoChat.mensagemAbertura) {
                data.mensagem_abertura_assistente = estadoChat.mensagemAbertura;
                if (
                    Array.isArray(estadoChat.baloesAbertura) &&
                    estadoChat.baloesAbertura.length
                ) {
                    data.baloes_abertura = estadoChat.baloesAbertura;
                }
            }
            if (estadoChat.metrica) {
                data.metrica = estadoChat.metrica;
            }
        }

        const ajaxOptions = {
            url: mensagensUrl,
            method: "POST",
            dataType: "json",
            headers: {
                "X-CSRF-TOKEN": csrfToken(),
                Accept: "application/json",
            },
        };
        if (arquivoAudio) {
            ajaxOptions.processData = false;
            ajaxOptions.contentType = false;
            ajaxOptions.data = montarFormDataMensagem(data, arquivoAudio);
        } else {
            ajaxOptions.contentType = "application/json";
            ajaxOptions.data = JSON.stringify(data);
        }

        $.ajax(ajaxOptions)
            .done(function (response) {
                if (arquivoAudio) {
                    const transcricao = String(
                        (response && response.transcricao) || "",
                    );
                    $userBubble
                        .find(".alerta-vazao-modal__audio-msg")
                        .removeClass("is-transcribing");
                    $userBubble
                        .find(".js-alerta-vazao-audio-toggle-label")
                        .text("Transcrição");
                    $userBubble
                        .find(".alerta-vazao-modal__chat-transcricao-texto")
                        .text(transcricao || "Transcrição indisponível.");
                    if (response && response.audio_url) {
                        $userBubble
                            .find(".js-alerta-vazao-audio-el")
                            .attr("src", response.audio_url);
                    }
                    if (blobUrlAudio) {
                        URL.revokeObjectURL(blobUrlAudio);
                        blobUrlAudio = null;
                    }
                }
                const resposta =
                    (response && response.message) ||
                    "Não consegui gerar uma resposta agora.";
                const baloes = Array.isArray(response.baloes)
                    ? response.baloes
                    : [];
                estadoChat.conversaId = response.conversa_id || estadoChat.conversaId;
                estadoChat.rascunho = false;
                estadoChat.titulo = response.titulo || estadoChat.titulo;
                estadoChat.mensagemAbertura = null;
                estadoChat.baloesAbertura = [];
                if (estadoChat.origem === "livre") {
                    estadoChat.temRespostaAssistente = true;
                    if (!estadoChat.metrica) {
                        estadoChat.metrica = "vazao_pipeline";
                    }
                }
                sincronizarLimiteMensagensChat($modal, response, {
                    adiarAviso: true,
                });
                aguardarPontinhosMinimos(inicioTyping, 3000, function () {
                    revelarRespostaAposPontinhos(
                        $typing,
                        $messages,
                        resposta,
                        baloes,
                        function () {
                            atualizarAvisoLimiteChat($modal);
                            setChatBusy($modal, false);
                            atualizarBannerGraficosChat($modal);
                            if (!estadoChat.limiteMensagensAtingido) {
                                $input.trigger("focus");
                            }
                            carregarListaConversas($modal, pipelineId, false);
                            marcarItemAtivo($modal, estadoChat.conversaId, false);
                        },
                    );
                });
            })
            .fail(function (xhr) {
                aguardarPontinhosMinimos(inicioTyping, 3000, function () {
                    $typing.remove();
                    $userBubble.remove();
                    if (blobUrlAudio) {
                        URL.revokeObjectURL(blobUrlAudio);
                    }
                    const payload = (xhr && xhr.responseJSON) || {};
                    const msg =
                        payload.message ||
                        "Não foi possível falar com a IA no momento. Tente novamente.";
                    setChatBusy($modal, false);
                    if (payload.limite_mensagens_atingido) {
                        sincronizarLimiteMensagensChat($modal, payload);
                        return;
                    }
                    $status.text(msg).addClass("is-error");
                    $input.trigger("focus");
                });
            });
    }

    function garantirModalTipo() {
        let $modal = $("#modalPipelineAlertasTipo");
        if ($modal.length) {
            if ($modal.find(".pipeline-alertas-tipo-modal__opcao-check").length) {
                return $modal;
            }
            $modal.remove();
        }

        $modal = $(`
            <div class="modal fade pipeline-alertas-tipo-modal-root js-pipeline-alertas-tipo-modal" id="modalPipelineAlertasTipo" tabindex="-1" role="dialog" aria-labelledby="modalPipelineAlertasTipoLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered pipeline-alertas-tipo-dialog" role="document">
                    <div class="modal-content pipeline-alertas-tipo-modal">
                        <div class="modal-header">
                            <div class="pipeline-alertas-tipo-modal__heading">
                                <p class="pipeline-alertas-tipo-modal__eyebrow">Configuração inicial</p>
                                <h5 class="modal-title" id="modalPipelineAlertasTipoLabel">Qual é a categoria desta pipeline?</h5>
                            </div>
                        </div>
                        <div class="modal-body">
                            <p class="pipeline-alertas-tipo-modal__intro">
                                Selecione a categoria para que métricas inteligentes associadas ao tipo escolhido sejam geradas periodicamente e ajudem a aumentar a produtividade da sua equipe.
                            </p>
                            <div class="pipeline-alertas-tipo-modal__opcoes" role="radiogroup" aria-label="Categoria da pipeline">
                                <button type="button" class="pipeline-alertas-tipo-modal__opcao js-pipeline-alertas-tipo-opcao" data-tipo="vendas" aria-pressed="false">
                                    <span class="pipeline-alertas-tipo-modal__opcao-check" aria-hidden="true">
                                        <i class="fas fa-check"></i>
                                    </span>
                                    <span class="pipeline-alertas-tipo-modal__opcao-icon" aria-hidden="true">
                                        <i class="fas fa-chart-line"></i>
                                    </span>
                                    <strong class="pipeline-alertas-tipo-modal__opcao-title">Vendas</strong>
                                    <span class="pipeline-alertas-tipo-modal__opcao-hint">Conversão, perdas e vazão financeira</span>
                                </button>
                                <button type="button" class="pipeline-alertas-tipo-modal__opcao js-pipeline-alertas-tipo-opcao" data-tipo="atendimento" aria-pressed="false">
                                    <span class="pipeline-alertas-tipo-modal__opcao-check" aria-hidden="true">
                                        <i class="fas fa-check"></i>
                                    </span>
                                    <span class="pipeline-alertas-tipo-modal__opcao-icon" aria-hidden="true">
                                        <i class="fas fa-handshake"></i>
                                    </span>
                                    <strong class="pipeline-alertas-tipo-modal__opcao-title">Atendimento</strong>
                                    <span class="pipeline-alertas-tipo-modal__opcao-hint">Relacionamento e atendimento ao cliente</span>
                                </button>
                                <button type="button" class="pipeline-alertas-tipo-modal__opcao js-pipeline-alertas-tipo-opcao" data-tipo="mista" aria-pressed="false">
                                    <span class="pipeline-alertas-tipo-modal__opcao-check" aria-hidden="true">
                                        <i class="fas fa-check"></i>
                                    </span>
                                    <span class="pipeline-alertas-tipo-modal__opcao-icon" aria-hidden="true">
                                        <i class="fas fa-layer-group"></i>
                                    </span>
                                    <strong class="pipeline-alertas-tipo-modal__opcao-title">Vendas e atendimento</strong>
                                    <span class="pipeline-alertas-tipo-modal__opcao-hint">Métricas dos dois packs no mesmo kanban</span>
                                </button>
                            </div>
                            <div class="pipeline-alertas-tipo-modal__detalhe js-pipeline-alertas-tipo-detalhe" hidden>
                                <div class="pipeline-alertas-tipo-modal__detalhe-card">
                                    <div class="pipeline-alertas-tipo-modal__detalhe-icon js-pipeline-alertas-tipo-detalhe-icon" aria-hidden="true"></div>
                                    <div class="pipeline-alertas-tipo-modal__detalhe-copy">
                                        <h6 class="pipeline-alertas-tipo-modal__detalhe-titulo js-pipeline-alertas-tipo-detalhe-titulo"></h6>
                                        <p class="pipeline-alertas-tipo-modal__detalhe-texto js-pipeline-alertas-tipo-detalhe-texto"></p>
                                        <ul class="pipeline-alertas-tipo-modal__detalhe-lista js-pipeline-alertas-tipo-detalhe-lista"></ul>
                                    </div>
                                </div>
                            </div>
                            <p class="pipeline-alertas-tipo-modal__aviso">
                                <i class="fas fa-info-circle" aria-hidden="true"></i>
                                Essa escolha pode ser alterada depois nas configurações da pipeline.
                            </p>
                            <div class="pipeline-alertas-tipo-modal__acoes js-pipeline-alertas-tipo-acoes" hidden>
                                <p class="pipeline-alertas-tipo-modal__status js-pipeline-alertas-tipo-status" role="status" hidden></p>
                                <button type="button" class="pipeline-alertas-tipo-modal__salvar js-pipeline-alertas-tipo-salvar" disabled>
                                    Salvar categoria
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `);

        $("body").append($modal);
        return $modal;
    }

    function abrirModalTipo(onSalvo) {
        if (!tipoUrl) {
            return;
        }

        const detalhesPorTipo = {
            vendas: {
                titulo: "Pipeline de Vendas",
                iconHtml: '<i class="fas fa-chart-line"></i>',
                texto:
                    "Ideal para funis com foco em conversão. A plataforma acompanha vazão, ações urgentes, forecast versus meta, velocidade da primeira resposta e distribuição de carga entre vendedores para alertar a gestão quando o desempenho sair do esperado.",
                itens: [
                    "Alertas de vazão e concentração de perdas",
                    "Ações urgentes: alto valor esfriando, mensagens sem resposta e tarefas atrasadas",
                    "Forecast x meta: previsão de fechamento, gap e negócios para cobrir a meta",
                    "Primeira resposta: vendedor lento vs média da equipe no WhatsApp",
                    "Distribuição: sugestão de redistribuição quando a carga está desbalanceada",
                    "Taxa de conversão abaixo do histórico da pipeline",
                ],
            },
            atendimento: {
                titulo: "Pipeline Atendimento",
                iconHtml: '<i class="fas fa-handshake"></i>',
                texto:
                    "Indicada para pipelines de relacionamento e atendimento ao cliente. A plataforma acompanha o tempo na fase e o tempo ideal das categorias de fases para alertar quando o atendimento sair do esperado.",
                itens: [
                    "Alertas de atraso acima do tempo ideal por fase e categoria",
                    "Alertas de TMA (tempo médio de atendimento) fora do padrão",
                    "Tempo de encerramento (ciclo total) acima do histórico",
                    "Alertas de vazão financeira ficam desligados nesta categoria",
                ],
            },
            mista: {
                titulo: "Pipeline Vendas e atendimento",
                iconHtml: '<i class="fas fa-layer-group"></i>',
                texto:
                    "Ideal quando o mesmo kanban mistura conversão e relacionamento. A plataforma une as métricas de vendas e de atendimento; cada aviso indica se é de vendas ou de atendimento.",
                itens: [
                    "Todas as métricas de vendas (vazão, ações urgentes, forecast, primeira resposta, distribuição e conversão)",
                    "Todas as métricas de atendimento (tempo ideal, TMA e tempo de encerramento)",
                    "Badge Vendas ou Atendimento em cada alerta para orientar a gestão",
                ],
            },
        };

        const $modal = garantirModalTipo();
        const $status = $modal.find(".js-pipeline-alertas-tipo-status");
        const $detalhe = $modal.find(".js-pipeline-alertas-tipo-detalhe");
        const $acoes = $modal.find(".js-pipeline-alertas-tipo-acoes");
        const $salvar = $modal.find(".js-pipeline-alertas-tipo-salvar");
        let tipoSelecionado = null;

        function resetSelecao() {
            tipoSelecionado = null;
            $status.text("").removeClass("is-error").attr("hidden", true);
            $modal
                .find(".js-pipeline-alertas-tipo-opcao")
                .removeClass("is-selected")
                .attr("aria-pressed", "false")
                .prop("disabled", false);
            $detalhe
                .removeClass("is-visible")
                .attr("hidden", true);
            $acoes.attr("hidden", true).removeClass("is-visible");
            $salvar.prop("disabled", true).removeClass("is-loading");
            $salvar.text("Salvar categoria");
        }

        function mostrarDetalhe(tipo) {
            const detalhe = detalhesPorTipo[tipo];
            if (!detalhe) {
                return;
            }

            tipoSelecionado = tipo;
            $modal
                .find(".js-pipeline-alertas-tipo-opcao")
                .removeClass("is-selected")
                .attr("aria-pressed", "false");
            $modal
                .find(`.js-pipeline-alertas-tipo-opcao[data-tipo='${tipo}']`)
                .addClass("is-selected")
                .attr("aria-pressed", "true");

            $modal.find(".js-pipeline-alertas-tipo-detalhe-icon").html(detalhe.iconHtml);
            $modal.find(".js-pipeline-alertas-tipo-detalhe-titulo").text(detalhe.titulo);
            $modal.find(".js-pipeline-alertas-tipo-detalhe-texto").text(detalhe.texto);

            const $lista = $modal.find(".js-pipeline-alertas-tipo-detalhe-lista");
            $lista.empty();
            detalhe.itens.forEach(function (item) {
                const $li = $("<li></li>");
                $li.text(item);
                $lista.append($li);
            });

            $salvar.prop("disabled", false);
            $status.text("").removeClass("is-error").attr("hidden", true);
            $detalhe.removeAttr("hidden");
            $acoes.removeAttr("hidden");
            window.requestAnimationFrame(function () {
                $detalhe.addClass("is-visible");
                $acoes.addClass("is-visible");
            });
        }

        function salvarTipo() {
            if (!tipoSelecionado) {
                return;
            }

            $salvar.prop("disabled", true).addClass("is-loading");
            $salvar.text("Salvando…");
            $modal.find(".js-pipeline-alertas-tipo-opcao").prop("disabled", true);
            $status.text("").removeClass("is-error").attr("hidden", true);

            $.ajax({
                url: tipoUrl,
                method: "POST",
                dataType: "json",
                headers: { "X-CSRF-TOKEN": csrfToken() },
                data: {
                    pipeline_id: pipelineId,
                    tipo: tipoSelecionado,
                },
            })
                .done(function () {
                    const tipo = tipoSelecionado;
                    $modal.modal("hide");
                    if (typeof onSalvo === "function") {
                        onSalvo(tipo);
                    }
                })
                .fail(function (xhr) {
                    const msg =
                        (xhr.responseJSON && xhr.responseJSON.message) ||
                        "Não foi possível salvar a categoria da pipeline.";
                    $status.text(msg).addClass("is-error").removeAttr("hidden");
                    $modal
                        .find(".js-pipeline-alertas-tipo-opcao")
                        .prop("disabled", false);
                    $salvar.prop("disabled", false).removeClass("is-loading");
                    $salvar.text("Salvar categoria");
                });
        }

        resetSelecao();

        $modal
            .off("click.pipelineAlertasTipo")
            .on("click.pipelineAlertasTipo", ".js-pipeline-alertas-tipo-opcao", function () {
                if ($salvar.hasClass("is-loading")) {
                    return;
                }
                const tipo = String($(this).attr("data-tipo") || "");
                if (!tipo) {
                    return;
                }
                mostrarDetalhe(tipo);
            })
            .on("click.pipelineAlertasTipo", ".js-pipeline-alertas-tipo-salvar", function () {
                salvarTipo();
            });

        $modal
            .off("hidden.bs.modal.pipelineAlertasTipo")
            .on("hidden.bs.modal.pipelineAlertasTipo", function () {
                resetSelecao();
            });

        $modal.modal({
            backdrop: "static",
            keyboard: false,
            show: true,
        });
    }

    function garantirEstruturaAlertasAtivos($modal) {
        const $head = $modal.find(".pipeline-alertas-chat__sidebar-head");
        const $btnExistente = $head.find(".js-pipeline-alertas-abrir-ativos");
        if ($head.length && !$btnExistente.length) {
            $head.prepend(`
                <button type="button" class="pipeline-alertas-chat__alertas-btn js-pipeline-alertas-abrir-ativos" aria-pressed="false" hidden>
                    <i class="fas fa-bell" aria-hidden="true"></i>
                    Alertas em curso
                </button>
            `);
        } else if ($btnExistente.length) {
            $btnExistente
                .find("i")
                .attr("class", "fas fa-bell")
                .attr("aria-hidden", "true");
        }

        const $main = $modal.find(".pipeline-alertas-chat__main");
        if ($main.length && !$main.find(".js-pipeline-alertas-ativos-page").length) {
            $main.addClass("is-view-chat");
            $main.append(htmlPaginaAlertasAtivos());
        }

        const $pageAtivos = $modal.find(".js-pipeline-alertas-ativos-page");
        if ($pageAtivos.length && !$pageAtivos.find(".js-pipeline-alertas-aba").length) {
            $pageAtivos.replaceWith(htmlPaginaAlertasAtivos());
        }

        const $listaAtivos = $modal.find(".js-pipeline-alertas-ativos-lista");
        if (
            $listaAtivos.length &&
            !$listaAtivos.closest(".pipeline-alertas-ativos__scroll").length
        ) {
            $listaAtivos.wrap('<div class="pipeline-alertas-ativos__scroll"></div>');
        }

        sincronizarAbaAlertasAtivos($modal);

        const $chat = $modal.find(".js-alerta-vazao-chat");
        if ($chat.length) {
            $chat.find(".js-pipeline-alertas-graficos-panel").remove();
            garantirBannerGraficosEmMensagens($modal);
            garantirFabGraficosChat($modal);
            bindScrollFabGraficosChat($modal);
            atualizarBannerGraficosChat($modal);
        }
    }

    function garantirModalChat() {
        let $modal = $("#modalPipelineAlertasChat");
        if ($modal.length) {
            garantirEstruturaAlertasAtivos($modal);
            return $modal;
        }

        $modal = $(`
            <div class="modal fade alerta-vazao-modal-root pipeline-alertas-chat-modal-root" id="modalPipelineAlertasChat" tabindex="-1" role="dialog" aria-labelledby="modalPipelineAlertasChatLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered pipeline-alertas-chat-dialog" role="document">
                    <div class="modal-content alerta-vazao-modal pipeline-alertas-chat-modal">
                        <div class="modal-header">
                            <div class="alerta-vazao-modal__heading">
                                <h5 class="modal-title js-pipeline-alertas-chat-titulo" id="modalPipelineAlertasChatLabel">Eloca Copiloto</h5>
                                <div class="alerta-vazao-modal__periodo js-alerta-vazao-modal-periodo"></div>
                            </div>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Fechar">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body pipeline-alertas-chat-modal__body">
                            <aside class="pipeline-alertas-chat__sidebar">
                                <div class="pipeline-alertas-chat__sidebar-head">
                                    <button type="button" class="pipeline-alertas-chat__alertas-btn js-pipeline-alertas-abrir-ativos" aria-pressed="false" hidden>
                                        <i class="fas fa-bell" aria-hidden="true"></i>
                                        Alertas em curso
                                    </button>
                                    <button type="button" class="pipeline-alertas-chat__novo js-pipeline-alertas-novo-chat">
                                        <i class="fas fa-plus" aria-hidden="true"></i>
                                        Nova análise
                                    </button>
                                    <div class="pipeline-alertas-chat__sidebar-meta">
                                        <span class="pipeline-alertas-chat__sidebar-label js-pipeline-alertas-sidebar-label">Histórico</span>
                                        <button type="button" class="pipeline-alertas-chat__toggle-arquivadas js-pipeline-alertas-toggle-arquivadas" aria-pressed="false" title="Alternar arquivadas">
                                            <i class="fas fa-archive js-pipeline-alertas-toggle-arquivadas-icon" aria-hidden="true"></i>
                                            <span class="js-pipeline-alertas-toggle-arquivadas-label">Ver arquivadas</span>
                                        </button>
                                    </div>
                                </div>
                                <div class="pipeline-alertas-chat__list js-pipeline-alertas-chat-list"></div>
                            </aside>
                            <section class="pipeline-alertas-chat__main is-view-chat">
                                <div class="alerta-vazao-modal__chat js-alerta-vazao-chat">
                                    <div class="alerta-vazao-modal__chat-thread">
                                        <div class="alerta-vazao-modal__chat-messages js-alerta-vazao-chat-messages" aria-live="polite">
                                            <div class="pipeline-alertas-graficos-banner js-pipeline-alertas-graficos-banner alerta-vazao-modal__chat-row alerta-vazao-modal__chat-row--assistant" hidden aria-hidden="true">
                                                <div class="pipeline-alertas-graficos-banner__avatar" aria-hidden="true">
                                                    <i class="fas fa-chart-area"></i>
                                                </div>
                                                <div class="alerta-vazao-modal__chat-bubble alerta-vazao-modal__chat-bubble--assistant pipeline-alertas-graficos-banner__bubble">
                                                    <div class="pipeline-alertas-graficos-banner__text">
                                                        <strong>Gráficos da análise</strong>
                                                        <span class="js-pipeline-alertas-graficos-banner-metrica">Métrica da análise</span>
                                                        <span class="pipeline-alertas-graficos-banner__hint">Indicadores padrão do sistema para apoiar a leitura desta conversa.</span>
                                                    </div>
                                                    <button type="button" class="pipeline-alertas-graficos-banner__btn js-pipeline-alertas-graficos-toggle">
                                                        Abrir gráficos
                                                        <i class="fas fa-external-link-alt" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="pipeline-alertas-graficos-fab-wrap js-pipeline-alertas-graficos-fab-wrap" hidden>
                                            <button type="button" class="pipeline-alertas-graficos-fab js-pipeline-alertas-graficos-fab" aria-label="Abrir gráficos da análise" title="Gráficos da análise" aria-expanded="false">
                                                <i class="fas fa-chart-area" aria-hidden="true"></i>
                                            </button>
                                            <div class="pipeline-alertas-graficos-fab-panel js-pipeline-alertas-graficos-fab-panel" hidden>
                                                <div class="pipeline-alertas-graficos-fab-panel__text">
                                                    <strong>Gráficos da análise</strong>
                                                    <span class="js-pipeline-alertas-graficos-fab-metrica">Métrica da análise</span>
                                                    <span class="pipeline-alertas-graficos-banner__hint">Indicadores padrão do sistema para apoiar a leitura desta conversa.</span>
                                                </div>
                                                <button type="button" class="pipeline-alertas-graficos-banner__btn js-pipeline-alertas-graficos-toggle">
                                                    Abrir gráficos
                                                    <i class="fas fa-external-link-alt" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="alerta-vazao-modal__chat-composer">
                                        <div class="alerta-vazao-modal__chat-sugestoes js-alerta-vazao-chat-sugestoes" aria-hidden="true">
                                            <div class="alerta-vazao-modal__chat-sugestoes-label">Sugestões</div>
                                            <div class="alerta-vazao-modal__chat-sugestoes-lista js-alerta-vazao-chat-sugestoes-lista"></div>
                                        </div>
                                        <form class="alerta-vazao-modal__chat-form js-alerta-vazao-chat-form" autocomplete="off">
                                            <div class="alerta-vazao-modal__chat-composer-normal js-alerta-vazao-chat-composer-normal">
                                                <div class="alerta-vazao-modal__chat-field">
                                                    <textarea
                                                        rows="1"
                                                        class="alerta-vazao-modal__chat-input js-alerta-vazao-chat-input"
                                                        maxlength="2000"
                                                        placeholder="Pergunte sobre as métricas da pipeline..."
                                                        aria-label="Mensagem para a IA"
                                                    ></textarea>
                                                </div>
                                                <button type="submit" class="alerta-vazao-modal__chat-enviar js-alerta-vazao-chat-enviar is-mic" title="${navegadorTranscreveFala() ? "Falar" : "Gravar áudio"}">
                                                    <i class="fas fa-microphone" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                            <div class="alerta-vazao-modal__chat-composer-audio js-alerta-vazao-chat-composer-audio" hidden>
                                                <span class="alerta-vazao-modal__chat-audio-label">
                                                    <span class="alerta-vazao-modal__chat-audio-dot" aria-hidden="true"></span>
                                                    Gravando... <span class="js-alerta-vazao-chat-audio-segundos">0</span>s
                                                </span>
                                                <div class="alerta-vazao-modal__chat-audio-actions">
                                                    <button type="button" class="alerta-vazao-modal__chat-audio-cancelar js-alerta-vazao-chat-audio-cancelar">
                                                        Cancelar
                                                    </button>
                                                    <button type="button" class="alerta-vazao-modal__chat-audio-enviar js-alerta-vazao-chat-audio-enviar">
                                                        Enviar áudio
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    <div class="alerta-vazao-modal__chat-status js-alerta-vazao-chat-status" role="status"></div>
                                </div>
                                ${htmlPaginaAlertasAtivos().trim()}
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        `);

        $("body").append($modal);

        $modal.on("show.bs.modal", function () {
            $("body").addClass("alerta-vazao-modal-open");
            window.setTimeout(function () {
                $(".modal-backdrop")
                    .last()
                    .addClass("alerta-vazao-modal-backdrop");
            }, 0);
        });

        $modal.on("hidden.bs.modal", function () {
            $("body").removeClass("alerta-vazao-modal-open");
            fecharMenusChat($modal);
            fecharBalaoInfo($modal);
            fecharBalaoGraficosHover();
            ocultarHintHoverGraficos($modal, false);
            cancelarGravacaoAudioCopiloto($modal);
            const $grafModal = $("#modalPipelineAlertasGraficos");
            if ($grafModal.length && $grafModal.hasClass("show")) {
                $grafModal.modal("hide");
            }
            if (!estadoChat.conversaId) {
                estadoChat = estadoChatBase();
            }
            setComposerVisivel($modal, true);
            limparThread($modal);
        });

        $modal.on("click", ".js-pipeline-alertas-abrir-ativos", function () {
            if ($modal.find(".js-alerta-vazao-chat-form").hasClass("is-busy")) {
                return;
            }
            fecharMenusChat($modal);
            fecharBalaoInfo($modal);
            mostrarViewModal($modal, "alertas");
            $.when(selecionarAbaAlertasAtivos($modal, "pendentes", true)).always(
                function () {
                    agendarHintHoverGraficos($modal);
                },
            );
        });

        $modal.on("click", ".js-pipeline-alertas-aba", function () {
            const aba = $(this).attr("data-aba") || "pendentes";
            selecionarAbaAlertasAtivos($modal, aba, true);
        });

        $modal.on("click", ".js-pipeline-alertas-ativo-analisado", function (e) {
            e.preventDefault();
            e.stopPropagation();
            const $botao = $(this);
            if ($botao.prop("disabled")) {
                return;
            }
            fecharBalaoGraficosHover();
            const $card = $botao.closest(".js-pipeline-alertas-ativo-card");
            const alertaPayload = $card.data("alertaPayload");
            marcarAlertaComoAnalisado($modal, alertaPayload, $botao);
        });

        $modal.on("click", ".js-pipeline-alertas-por-que-tendencia", function (e) {
            e.preventDefault();
            e.stopPropagation();
            fecharBalaoGraficosHover();
            const $card = $(this).closest(".js-pipeline-alertas-ativo-card");
            const alertaPayload = $card.data("alertaPayload");
            abrirModalTendenciaAnalise(alertaPayload);
        });

        $modal.on(
            "mouseenter",
            ".js-pipeline-alertas-ativo-card",
            function () {
                const $card = $(this);
                cancelarFecharBalaoGraficosHover();
                const payload = $card.data("alertaPayload") || {};
                const metrica = payload.metrica;
                if (!metrica || !METRICAS_COM_GRAFICOS[metrica] || !graficosUrl) {
                    return;
                }
                if (
                    hoverGraficosCardEl &&
                    hoverGraficosCardEl === $card.get(0) &&
                    $(".js-pipeline-alertas-graficos-balao").length
                ) {
                    return;
                }
                if (hoverGraficosTimer) {
                    window.clearTimeout(hoverGraficosTimer);
                }
                hoverGraficosTimer = window.setTimeout(function () {
                    hoverGraficosTimer = null;
                    abrirBalaoGraficosHover($card, metrica);
                }, 1000);
            },
        );

        $modal.on(
            "mouseleave",
            ".js-pipeline-alertas-ativo-card",
            function (e) {
                const related = e.relatedTarget;
                if (
                    related &&
                    $(related).closest(".js-pipeline-alertas-graficos-balao").length
                ) {
                    cancelarFecharBalaoGraficosHover();
                    return;
                }
                if (hoverGraficosTimer) {
                    window.clearTimeout(hoverGraficosTimer);
                    hoverGraficosTimer = null;
                }
                if ($(".js-pipeline-alertas-graficos-balao").length) {
                    agendarFecharBalaoGraficosHover();
                }
            },
        );

        $modal.on("click", ".js-pipeline-alertas-graficos-toggle", function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (
                chatEstaBusy($modal) ||
                estadoChat.aguardandoAnaliseConversas ||
                $(this).prop("disabled")
            ) {
                return;
            }
            fecharPainelFabGraficos($modal);
            abrirModalGraficosChat();
        });

        $modal.on("click", ".js-pipeline-alertas-graficos-fab", function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (
                chatEstaBusy($modal) ||
                estadoChat.aguardandoAnaliseConversas ||
                $(this).prop("disabled")
            ) {
                return;
            }
            fecharPainelFabGraficos($modal);
            abrirModalGraficosChat();
        });

        bindScrollFabGraficosChat($modal);

        $modal.on(
            "mouseenter",
            ".js-pipeline-alertas-graficos-fab, .js-pipeline-alertas-graficos-fab-panel",
            function () {
                if (chatEstaBusy($modal) || estadoChat.aguardandoAnaliseConversas) {
                    return;
                }
                abrirPainelFabGraficos($modal);
            },
        );

        $modal.on(
            "mouseleave",
            ".js-pipeline-alertas-graficos-fab-wrap",
            function () {
                if (graficosFabHoverTimer) {
                    window.clearTimeout(graficosFabHoverTimer);
                }
                graficosFabHoverTimer = window.setTimeout(function () {
                    graficosFabHoverTimer = null;
                    fecharPainelFabGraficos($modal);
                }, 160);
            },
        );

        $modal.on("click", ".js-pipeline-alertas-ativo-cta", function (e) {
            e.preventDefault();
            e.stopPropagation();
            if ($modal.find(".js-alerta-vazao-chat-form").hasClass("is-busy")) {
                return;
            }
            fecharBalaoGraficosHover();
            const $card = $(this).closest(".js-pipeline-alertas-ativo-card");
            const alertaPayload = $card.data("alertaPayload");
            if (!alertaPayload) {
                return;
            }
            iniciarConversaAlerta($modal, alertaPayload);
        });

        $modal.on("click", ".js-pipeline-alertas-novo-chat", function () {
            if ($modal.find(".js-alerta-vazao-chat-form").hasClass("is-busy")) {
                return;
            }
            mostrarViewModal($modal, "chat");
            if (modoListaArquivadas) {
                modoListaArquivadas = false;
                sincronizarUiListaArquivadas($modal);
            }
            abrirSeletorModoAnalise($modal);
        });

        $modal.on("click", ".js-pipeline-alertas-toggle-arquivadas", function () {
            if ($modal.find(".js-alerta-vazao-chat-form").hasClass("is-busy")) {
                return;
            }
            mostrarViewModal($modal, "chat");
            modoListaArquivadas = !modoListaArquivadas;
            sincronizarUiListaArquivadas($modal);
            estadoChat = estadoChatBase();
            limparThread($modal);
            setComposerVisivel($modal, false);
            atualizarBannerGraficosChat($modal);
            carregarListaConversas($modal, pipelineId, false).done(function (
                response,
            ) {
                const conversas = (response && response.conversas) || [];
                if (conversas.length) {
                    carregarConversa($modal, conversas[0].id);
                    return;
                }
                mostrarEstadoVazioChat($modal, true);
            });
        });

        $modal.on("click", ".js-pipeline-alertas-modo-opcao", function () {
            const $opcao = $(this);
            $modal
                .find(".js-pipeline-alertas-modo-opcao")
                .removeClass("is-selected")
                .attr("aria-pressed", "false");
            $opcao.addClass("is-selected").attr("aria-pressed", "true");
            const modo = String($opcao.attr("data-modo") || "atual");
            const $inicio = $modal.find(".js-pipeline-alertas-modo-inicio");
            if (modo === "atual") {
                const padrao = datasPadraoAtual();
                $inicio.val(padrao.inicio).data("periodoAtualInicializado", true);
            } else {
                const padrao = datasPadraoComparativo();
                $inicio.val(padrao.inicio);
            }
            sincronizarUiPeriodoModo($modal);
            atualizarValidacaoPeriodoModo($modal);
        });

        $modal.on(
            "change input",
            ".js-pipeline-alertas-modo-inicio, .js-pipeline-alertas-modo-fim",
            function () {
                atualizarValidacaoPeriodoModo($modal);
            },
        );

        $modal.on("click", ".js-pipeline-alertas-modo-continuar", function () {
            const $continuar = $(this);
            if ($continuar.prop("disabled")) {
                return;
            }
            const modo = String(
                $modal
                    .find(".js-pipeline-alertas-modo-opcao.is-selected")
                    .attr("data-modo") || "atual",
            );
            const dataInicio = String(
                $modal.find(".js-pipeline-alertas-modo-inicio").val() || "",
            ).trim();
            const validacao =
                modo === "comparativo"
                    ? validarPeriodoComparativo(dataInicio)
                    : validarPeriodoAtual(
                          dataInicio,
                          formatDateInput(hojeLocal()),
                      );

            if (!validacao.valido) {
                $modal
                    .find(".js-pipeline-alertas-modo-erro")
                    .text(validacao.mensagem)
                    .prop("hidden", false);
                $modal
                    .find(".pipeline-alertas-modo__periodo-card")
                    .addClass("is-invalid");
                $continuar.prop("disabled", true);
                return;
            }

            const incluirConversas =
                analiseConversasHabilitada &&
                $modal.find(".js-pipeline-alertas-incluir-conversas").is(":checked");

            if (incluirConversas) {
                aguardarAnaliseConversasEContinuar(
                    $modal,
                    modo,
                    dataInicio,
                    validacao.dataFim,
                );
                return;
            }

            confirmarModoAnalise(
                $modal,
                modo,
                dataInicio,
                validacao.dataFim,
                false,
            );
        });

        $modal.on("click", ".js-pipeline-alertas-chat-item", function (e) {
            if (
                $(e.target).closest(".js-pipeline-alertas-chat-menu-wrap").length
            ) {
                return;
            }
            if ($modal.find(".js-alerta-vazao-chat-form").hasClass("is-busy")) {
                return;
            }
            fecharBalaoInfo($modal);
            fecharMenusChat($modal);
            mostrarViewModal($modal, "chat");
            const $item = $(this);
            if ($item.attr("data-draft") === "1") {
                if (estadoChat.selecionandoModo) {
                    abrirSeletorModoAnalise($modal);
                    return;
                }
                $modal.find(".js-alerta-vazao-chat-input").trigger("focus");
                return;
            }
            const id = parseInt($item.attr("data-id"), 10);
            if (!id) {
                return;
            }
            descartarRascunhoSeVazio($modal);
            carregarConversa($modal, id);
        });

        $modal.on(
            "click",
            ".js-pipeline-alertas-chat-menu-trigger",
            function (e) {
                e.preventDefault();
                e.stopPropagation();
                if ($modal.find(".js-alerta-vazao-chat-form").hasClass("is-busy")) {
                    return;
                }
                const $trigger = $(this);
                const $item = $trigger.closest(".js-pipeline-alertas-chat-item");
                const $float = $("#pipelineAlertasChatMenuFloat");
                const mesmoAberto =
                    !$float.prop("hidden") &&
                    Number($float.data("conversaId")) ===
                        Number($item.attr("data-id"));
                fecharMenusChat($modal);
                if (mesmoAberto) {
                    return;
                }
                abrirMenuFlutuanteChat($modal, $trigger, $item);
            },
        );

        $(document)
            .off("click.pipelineAlertasChatMenuAcao")
            .on(
                "click.pipelineAlertasChatMenuAcao",
                "#pipelineAlertasChatMenuFloat .js-pipeline-alertas-chat-acao",
                function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    const $float = $("#pipelineAlertasChatMenuFloat");
                    const $chatModal = $float.data("chatModal") || $modal;
                    if (
                        $chatModal
                            .find(".js-alerta-vazao-chat-form")
                            .hasClass("is-busy")
                    ) {
                        return;
                    }

                    const acao = String($(this).attr("data-acao") || "");
                    const id = parseInt($float.data("conversaId"), 10);
                    const jaFixado = !!$float.data("fixado");
                    const jaArquivada = !!$float.data("arquivado");
                    const tituloAtual = String($float.data("titulo") || "").trim();
                    fecharMenusChat($chatModal);
                    if (!id || !acao) {
                        return;
                    }

                    if (acao === "fixar") {
                        atualizarConversa($chatModal, id, {
                            fixado: !jaFixado,
                        });
                        return;
                    }

                    if (acao === "renomear") {
                        abrirModalAcaoChat({
                            modo: "renomear",
                            titulo: "Renomear análise",
                            texto: "Defina um novo nome para esta conversa.",
                            botao: "Salvar",
                            valorInicial: tituloAtual,
                            onConfirm: function (titulo) {
                                atualizarConversa($chatModal, id, {
                                    titulo: titulo,
                                });
                            },
                        });
                        return;
                    }

                    if (acao === "arquivar") {
                        if (jaArquivada) {
                            atualizarConversa($chatModal, id, {
                                arquivado: false,
                            });
                            return;
                        }
                        abrirModalAcaoChat({
                            titulo: "Arquivar análise",
                            texto: "A análise sairá da lista principal. Você poderá gerenciá-la depois em “Ver arquivadas”.",
                            botao: "Arquivar",
                            onConfirm: function () {
                                atualizarConversa($chatModal, id, {
                                    arquivado: true,
                                });
                            },
                        });
                        return;
                    }

                    if (acao === "excluir") {
                        abrirModalAcaoChat({
                            titulo: "Excluir análise",
                            texto: "Tem certeza que deseja excluir esta análise? Essa ação não pode ser desfeita.",
                            botao: "Excluir",
                            danger: true,
                            onConfirm: function () {
                                excluirConversa($chatModal, id);
                            },
                        });
                    }
                },
            );

        $(document)
            .off("click.pipelineAlertasChatMenuClose")
            .on("click.pipelineAlertasChatMenuClose", function (e) {
                if (
                    $(e.target).closest(
                        ".js-pipeline-alertas-chat-menu-wrap, #pipelineAlertasChatMenuFloat",
                    ).length
                ) {
                    return;
                }
                fecharMenusChat($modal);
            });

        $(window)
            .off("resize.pipelineAlertasChatMenu scroll.pipelineAlertasChatMenu")
            .on(
                "resize.pipelineAlertasChatMenu scroll.pipelineAlertasChatMenu",
                function () {
                    fecharMenusChat($modal);
                },
            );

        $modal.on("click", ".js-pipeline-alertas-chip", function (e) {
            e.preventDefault();
            e.stopPropagation();
            if ($modal.find(".js-alerta-vazao-chat-form").hasClass("is-busy")) {
                return;
            }

            const $chip = $(this);
            const chave = String($chip.attr("data-chave") || "").trim();
            const baloes = $chip.closest(".alerta-vazao-modal__chat-row").data("baloes") || [];
            let balao = null;
            (baloes || []).forEach(function (item) {
                if (!item) {
                    return;
                }
                const itemChave = String(item.chave || "").trim();
                if (
                    itemChave === chave ||
                    itemChave.toLowerCase() === chave.toLowerCase()
                ) {
                    balao = item;
                }
            });

            if (!balao) {
                return;
            }

            if ($chip.hasClass("is-active")) {
                fecharBalaoInfo($modal);
                return;
            }

            abrirBalaoInfo($modal, $chip, balao);
        });

        $modal.on("click", ".js-pipeline-alertas-balao", function (e) {
            e.stopPropagation();
        });

        $modal.on("click", ".js-pipeline-alertas-balao-fechar", function (e) {
            e.preventDefault();
            e.stopPropagation();
            fecharBalaoInfo($modal);
        });

        $modal.on("click", ".js-alerta-vazao-chat-messages", function (e) {
            const $target = $(e.target);
            if (
                $target.closest(".js-pipeline-alertas-balao").length ||
                $target.closest(".js-pipeline-alertas-chip").length
            ) {
                return;
            }
            fecharBalaoInfo($modal);
        });

        $(document).on("keydown.pipelineAlertasBalao", function (e) {
            if (e.key === "Escape") {
                fecharBalaoInfo($modal);
            }
        });

        $modal.on("submit", ".js-alerta-vazao-chat-form", function (e) {
            e.preventDefault();
            if (ouvindoFalaNavegador) {
                pararTranscricaoNavegadorCopiloto($modal);
                return;
            }
            const texto = String(
                $modal.find(".js-alerta-vazao-chat-input").val() || "",
            ).trim();
            if (!texto) {
                iniciarEntradaPorVozCopiloto($modal);
                return;
            }
            enviarMensagemChat($modal);
        });

        $modal.on("click", ".js-alerta-vazao-chat-audio-cancelar", function () {
            cancelarGravacaoAudioCopiloto($modal);
        });

        $modal.on("click", ".js-alerta-vazao-chat-audio-enviar", function () {
            enviarAudioGravadoCopiloto($modal);
        });

        $modal.on("keydown", ".js-alerta-vazao-chat-input", function (e) {
            if (e.key !== "Enter" || e.shiftKey || e.isComposing) {
                return;
            }
            e.preventDefault();
            $modal.find(".js-alerta-vazao-chat-form").trigger("submit");
        });

        $modal.on(
            "input focus",
            ".js-alerta-vazao-chat-input",
            function () {
                ajustarAlturaChatInput($(this));
                if ($modal.find(".js-alerta-vazao-chat-form").hasClass("is-busy")) {
                    return;
                }
                atualizarBotaoComposerAudio($modal);
                atualizarSugestoesChat($modal);
            },
        );

        $modal.on("click", ".js-alerta-vazao-chat-sugestao", function () {
            if ($modal.find(".js-alerta-vazao-chat-form").hasClass("is-busy")) {
                return;
            }
            const pergunta = String(
                $(this).attr("data-pergunta") || $(this).text() || "",
            ).trim();
            if (!pergunta) {
                return;
            }
            enviarMensagemChat($modal, pergunta);
        });

        return $modal;
    }

    function abrirModalChat(payload, options) {
        const opts =
            typeof options === "boolean"
                ? { iniciarAlerta: options }
                : options || {};
        const iniciarAlerta = !!opts.iniciarAlerta;
        const somenteHistorico = !!opts.somenteHistorico;
        const viewAlertas = !!opts.viewAlertas;

        const $modal = garantirModalChat();
        const periodoDias = payload.periodo_dias || 30;
        const periodoRotulo = payload.periodo_rotulo
            ? String(payload.periodo_rotulo)
            : "últimos " + periodoDias + " dias";
        const temaEloca = !iniciarAlerta;

        modoListaArquivadas = false;
        sincronizarUiListaArquivadas($modal);
        mostrarViewModal($modal, viewAlertas ? "alertas" : "chat");
        if (!viewAlertas) {
            carregarERenderizarAlertasAtivos($modal, false);
        }

        $modal
            .find(".pipeline-alertas-chat-modal")
            .toggleClass("pipeline-alertas-chat-modal--eloca", temaEloca);
        $modal
            .find(".js-pipeline-alertas-chat-titulo")
            .text(
                iniciarAlerta
                    ? "Assistente da pipeline"
                    : "Eloca Copiloto",
            );
        $modal
            .find(".js-alerta-vazao-modal-periodo")
            .text(
                iniciarAlerta
                    ? "Análise do alerta · " + periodoRotulo
                    : viewAlertas
                      ? "Alertas da pipeline"
                      : "Histórico de análises · últimos " + periodoDias + " dias",
            );

        $modal.modal({
            backdrop: true,
            keyboard: true,
            focus: true,
            show: true,
        });

        if (viewAlertas) {
            selecionarAbaAlertasAtivos($modal, "pendentes", true);
            return;
        }

        carregarListaConversas($modal, pipelineId, false).done(function (
            response,
        ) {
            if (iniciarAlerta) {
                iniciarConversaAlerta($modal, payload);
                return;
            }

            if (somenteHistorico) {
                const conversas = (response && response.conversas) || [];
                if (conversas.length) {
                    carregarConversa($modal, conversas[0].id);
                    return;
                }
                mostrarEstadoVazioChat($modal, true);
                return;
            }

            iniciarRascunhoLivre($modal);
        });
    }

    function normalizarAlertas(payload) {
        if (Array.isArray(payload.alertas) && payload.alertas.length) {
            return payload.alertas.filter(function (alerta) {
                return alerta && alerta.show !== false;
            });
        }

        if (!payload.show) {
            return [];
        }

        // Retrocompat: payload flat antigo
        const meta = [];
        if (payload.total_vazao != null) {
            meta.push("Valor perdido: " + formatCurrency(payload.total_vazao));
        }
        if (payload.quant_perda != null) {
            meta.push(
                Number(payload.quant_perda) === 1
                    ? "1 oportunidade"
                    : payload.quant_perda + " oportunidades",
            );
        }
        if (meta.length) {
            meta.push("Últimos 30 dias");
        }

        return [
            {
                metrica: payload.metrica || "vazao_pipeline",
                show: true,
                assinatura: payload.assinatura || "",
                eyebrow: payload.eyebrow || "Atenção às vendas perdidas",
                titulo: payload.titulo || "",
                subtitulo: payload.subtitulo || null,
                meta: payload.meta || meta,
                label: payload.label || "Vazão",
                cta_habilitado:
                    payload.cta_habilitado != null
                        ? !!payload.cta_habilitado
                        : true,
                loja_id: payload.loja_id,
                pipeline_id: payload.pipeline_id,
                user_id: payload.user_id,
            },
        ];
    }

    function atualizarConteudoCard($card, estadoCard) {
        const alerta = estadoCard.alertas[estadoCard.indice] || {};
        const total = estadoCard.alertas.length;

        $card.toggleClass("is-ok", alerta.estado === "ok");

        $card
            .find(".js-alerta-vazao-eyebrow-texto")
            .text(alerta.eyebrow || "Atenção à operação");
        aplicarBadgeCategoria(
            $card,
            estadoCard.tipo || "",
            alerta.categoria,
            ".js-pipeline-alertas-categoria-badge",
        );
        $card.find(".js-alerta-vazao-titulo").text(alerta.titulo || "");

        const $subtitulo = $card.find(".js-alerta-vazao-subtitulo");
        if (alerta.subtitulo) {
            $subtitulo.text(alerta.subtitulo).show();
        } else {
            $subtitulo.text("").hide();
        }

        const metaParts = Array.isArray(alerta.meta) ? alerta.meta : [];
        const $meta = $card.find(".js-alerta-vazao-meta");
        if (metaParts.length) {
            $meta.text(metaParts.join(" · ")).show();
        } else {
            $meta.text("").hide();
        }

        const $nav = $card.find(".js-alerta-vazao-nav");
        const $label = $card.find(".js-alerta-vazao-nav-label");
        const $dots = $card.find(".js-alerta-vazao-dots");
        const $prev = $card.find(".js-alerta-vazao-prev");
        const $next = $card.find(".js-alerta-vazao-next");

        if (total > 1) {
            $nav.removeAttr("hidden");
            $label.text(
                (alerta.label || "Aviso") +
                    " · " +
                    (estadoCard.indice + 1) +
                    " de " +
                    total,
            );
            $prev.prop("disabled", estadoCard.indice <= 0);
            $next.prop("disabled", estadoCard.indice >= total - 1);

            $dots.empty();
            estadoCard.alertas.forEach(function (_item, idx) {
                const $dot = $(
                    '<button type="button" class="alerta-vazao-pipeline__dot js-alerta-vazao-dot" aria-label="Ir para aviso"></button>',
                );
                $dot.attr("data-indice", idx);
                $dot.attr(
                    "aria-label",
                    "Ir para " +
                        (estadoCard.alertas[idx].label || "aviso") +
                        " (" +
                        (idx + 1) +
                        " de " +
                        total +
                        ")",
                );
                if (idx === estadoCard.indice) {
                    $dot.addClass("is-active");
                }
                $dots.append($dot);
            });
        } else {
            $nav.attr("hidden", true);
        }

        const $footer = $card.find(".js-alerta-vazao-footer");
        const $cta = $card.find(".js-alerta-vazao-saber-mais");
        if (alerta.cta_habilitado) {
            $footer.show();
            $cta.show();
        } else {
            $footer.hide();
            $cta.hide();
        }

        estadoCard.alertaAtual = alerta;
    }

    function trocarAlertaCard($card, estadoCard, novoIndice) {
        const total = estadoCard.alertas.length;
        if (total <= 1 || estadoCard.animando) {
            return;
        }
        if (novoIndice < 0 || novoIndice >= total || novoIndice === estadoCard.indice) {
            return;
        }

        const indoParaFrente = novoIndice > estadoCard.indice;
        const $body = $card.find(".js-alerta-vazao-body");
        const bodyEl = $body.get(0);
        if (!bodyEl) {
            estadoCard.indice = novoIndice;
            atualizarConteudoCard($card, estadoCard);
            return;
        }

        estadoCard.animando = true;
        $body.css("min-height", $body.outerHeight() + "px");
        $body
            .removeClass(
                "is-exit-next is-exit-prev is-enter-next is-enter-prev",
            )
            .addClass(indoParaFrente ? "is-exit-next" : "is-exit-prev");

        let finalizouSaida = false;

        function concluirEntrada() {
            $body.off("transitionend.alertaCardEnter");
            $body.css("min-height", "");
            estadoCard.animando = false;
        }

        function iniciarEntrada() {
            if (finalizouSaida) {
                return;
            }
            finalizouSaida = true;
            $body.off("transitionend.alertaCardExit");

            estadoCard.indice = novoIndice;
            atualizarConteudoCard($card, estadoCard);

            $body
                .removeClass("is-exit-next is-exit-prev")
                .addClass(indoParaFrente ? "is-enter-next" : "is-enter-prev");

            // Força reflow para o browser aplicar o estado "enter" sem animar.
            void bodyEl.offsetWidth;

            window.requestAnimationFrame(function () {
                $body.removeClass("is-enter-next is-enter-prev");
                $body.on("transitionend.alertaCardEnter", function (event) {
                    if (event.target !== bodyEl) {
                        return;
                    }
                    if (
                        event.originalEvent &&
                        event.originalEvent.propertyName &&
                        event.originalEvent.propertyName !== "opacity"
                    ) {
                        return;
                    }
                    concluirEntrada();
                });
                window.setTimeout(concluirEntrada, 320);
            });
        }

        $body.on("transitionend.alertaCardExit", function (event) {
            if (event.target !== bodyEl) {
                return;
            }
            if (
                event.originalEvent &&
                event.originalEvent.propertyName &&
                event.originalEvent.propertyName !== "opacity"
            ) {
                return;
            }
            iniciarEntrada();
        });
        window.setTimeout(iniciarEntrada, 240);
    }

    function renderCard(payload, alertasVisiveis) {
        const estadoCard = {
            lojaId: payload.loja_id,
            pipelineId: payload.pipeline_id,
            userId: payload.user_id,
            tipo: payload.tipo || "",
            alertas: alertasVisiveis.slice(),
            indice: 0,
            alertaAtual: alertasVisiveis[0] || {},
            animando: false,
        };

        const $card = $(`
            <aside class="alerta-vazao-pipeline js-alerta-vazao-pipeline" role="status" aria-live="polite">
                <button type="button" class="alerta-vazao-pipeline__close js-alerta-vazao-dispensar" aria-label="Dispensar aviso">&times;</button>
                <div class="alerta-vazao-pipeline__body js-alerta-vazao-body">
                    <div class="alerta-vazao-pipeline__categoria js-pipeline-alertas-categoria-wrap" hidden>
                        <span class="pipeline-alertas-categoria-badge js-pipeline-alertas-categoria-badge" hidden></span>
                    </div>
                    <div class="alerta-vazao-pipeline__eyebrow">
                        <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
                        <span class="js-alerta-vazao-eyebrow-texto"></span>
                    </div>
                    <div class="alerta-vazao-pipeline__title js-alerta-vazao-titulo"></div>
                    <div class="alerta-vazao-pipeline__subtitle js-alerta-vazao-subtitulo"></div>
                    <div class="alerta-vazao-pipeline__meta js-alerta-vazao-meta"></div>
                </div>
                <div class="alerta-vazao-pipeline__nav js-alerta-vazao-nav" hidden>
                    <button type="button" class="alerta-vazao-pipeline__nav-btn js-alerta-vazao-prev" aria-label="Aviso anterior">
                        <i class="fas fa-chevron-left" aria-hidden="true"></i>
                    </button>
                    <div class="alerta-vazao-pipeline__nav-center">
                        <div class="alerta-vazao-pipeline__nav-label js-alerta-vazao-nav-label"></div>
                        <div class="alerta-vazao-pipeline__dots js-alerta-vazao-dots"></div>
                    </div>
                    <button type="button" class="alerta-vazao-pipeline__nav-btn js-alerta-vazao-next" aria-label="Próximo aviso">
                        <i class="fas fa-chevron-right" aria-hidden="true"></i>
                    </button>
                </div>
                <div class="alerta-vazao-pipeline__footer js-alerta-vazao-footer">
                    <button type="button" class="alerta-vazao-pipeline__cta js-alerta-vazao-saber-mais">
                        <i class="fas fa-comments" aria-hidden="true"></i>
                        Melhore agora a sua operação
                    </button>
                </div>
            </aside>
        `);

        atualizarConteudoCard($card, estadoCard);

        $card.on("click", ".js-alerta-vazao-prev", function () {
            trocarAlertaCard($card, estadoCard, estadoCard.indice - 1);
        });
        $card.on("click", ".js-alerta-vazao-next", function () {
            trocarAlertaCard($card, estadoCard, estadoCard.indice + 1);
        });
        $card.on("click", ".js-alerta-vazao-dot", function () {
            const idx = parseInt($(this).attr("data-indice"), 10);
            if (Number.isNaN(idx)) {
                return;
            }
            trocarAlertaCard($card, estadoCard, idx);
        });

        $card.find(".js-alerta-vazao-dispensar").on("click", function () {
            fecharCard($card, estadoCard);
        });

        $card.find(".js-alerta-vazao-saber-mais").on("click", function () {
            const atual = estadoCard.alertaAtual || {};
            if (!atual.cta_habilitado) {
                return;
            }
            abrirModalChat(
                Object.assign({}, payload, atual, {
                    loja_id: estadoCard.lojaId,
                    pipeline_id: estadoCard.pipelineId,
                    user_id: estadoCard.userId,
                }),
                true,
            );
        });

        $("body").append($card);

        window.requestAnimationFrame(function () {
            window.requestAnimationFrame(function () {
                $card.addClass("is-visible");
            });
        });
    }

    function processarPayloadAlerta(payload) {
        if (!payload) {
            return;
        }

        cacheAlertasAtivos = {
            payload: payload,
            alertas: normalizarAlertas(payload),
            autorizado: payload.autorizado !== false,
        };
        if (payload.autorizado === false) {
            cacheAlertasAtivos.autorizado = false;
            cacheAlertasAtivos.alertas = [];
        }
        analiseConversasHabilitada = !!payload.analise_conversas;
        const $modalAberto = $("#modalPipelineAlertasChat");
        if ($modalAberto.length) {
            atualizarBotaoAlertasAtivos($modalAberto);
            if (
                $modalAberto.find(".pipeline-alertas-chat__main").hasClass("is-view-alertas") &&
                abaAlertasAtivos === "pendentes"
            ) {
                renderAlertasAtivosPage(
                    $modalAberto,
                    cacheAlertasAtivos.alertas,
                    cacheAlertasAtivos.payload || {},
                );
            }
        }

        if (payload.precisa_classificar) {
            abrirModalTipo(function () {
                carregarAlerta();
            });
            return;
        }

        const alertas = cacheAlertasAtivos.alertas;
        $(".js-alerta-vazao-pipeline").remove();
        if (!alertas.length) {
            return;
        }

        const alertasVisiveis = alertas.filter(function (alerta) {
            return !isDismissed(
                payload.loja_id,
                payload.pipeline_id,
                payload.user_id,
                alerta.assinatura,
                alerta.metrica,
            );
        });

        if (!alertasVisiveis.length) {
            return;
        }

        renderCard(payload, alertasVisiveis);
    }

    function carregarAlerta() {
        $.ajax({
            url: alertaUrl,
            method: "GET",
            data: { pipeline_id: pipelineId },
            dataType: "json",
        })
            .done(processarPayloadAlerta)
            .fail(function () {
                /* silencioso: alerta não bloqueia o Kanban */
            });
    }

    $(document)
        .off("click.pipelineAlertasMetricas", ".js-abrir-metricas-pipeline")
        .on("click.pipelineAlertasMetricas", ".js-abrir-metricas-pipeline", function (e) {
            e.preventDefault();
            const viewAlertas = $(this).attr("data-view") === "alertas";
            abrirModalChat(
                {
                    pipeline_id: pipelineId,
                    periodo_dias: 30,
                },
                viewAlertas
                    ? { viewAlertas: true }
                    : { somenteHistorico: true },
            );
        });

    carregarAlerta();
};
